import ft, { useCallback as wr, useState as Oe, useRef as Ie, useEffect as _e, forwardRef as bc, useLayoutEffect as rv, createContext as xc } from "react";
import { useMedia as Qr, useLocation as iv, useClickAway as Sc, useWindowSize as sv } from "react-use";
import { createPortal as av } from "react-dom";
var Ur = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function lv(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
var Sa = { exports: {} }, Gr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rc;
function ov() {
  if (rc) return Gr;
  rc = 1;
  var s = ft, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, c = s.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(p, f, b) {
    var m, S = {}, A = null, y = null;
    b !== void 0 && (A = "" + b), f.key !== void 0 && (A = "" + f.key), f.ref !== void 0 && (y = f.ref);
    for (m in f) a.call(f, m) && !o.hasOwnProperty(m) && (S[m] = f[m]);
    if (p && p.defaultProps) for (m in f = p.defaultProps, f) S[m] === void 0 && (S[m] = f[m]);
    return { $$typeof: r, type: p, key: A, ref: y, props: S, _owner: c.current };
  }
  return Gr.Fragment = n, Gr.jsx = d, Gr.jsxs = d, Gr;
}
var Hr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ic;
function cv() {
  return ic || (ic = 1, process.env.NODE_ENV !== "production" && function() {
    var s = ft, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), p = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), b = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), S = Symbol.for("react.memo"), A = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), _ = Symbol.iterator, O = "@@iterator";
    function G(w) {
      if (w === null || typeof w != "object")
        return null;
      var z = _ && w[_] || w[O];
      return typeof z == "function" ? z : null;
    }
    var M = s.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(w) {
      {
        for (var z = arguments.length, J = new Array(z > 1 ? z - 1 : 0), oe = 1; oe < z; oe++)
          J[oe - 1] = arguments[oe];
        T("error", w, J);
      }
    }
    function T(w, z, J) {
      {
        var oe = M.ReactDebugCurrentFrame, Ee = oe.getStackAddendum();
        Ee !== "" && (z += "%s", J = J.concat([Ee]));
        var Fe = J.map(function(xe) {
          return String(xe);
        });
        Fe.unshift("Warning: " + z), Function.prototype.apply.call(console[w], console, Fe);
      }
    }
    var L = !1, P = !1, k = !1, q = !1, W = !1, N;
    N = Symbol.for("react.module.reference");
    function V(w) {
      return !!(typeof w == "string" || typeof w == "function" || w === a || w === o || W || w === c || w === b || w === m || q || w === y || L || P || k || typeof w == "object" && w !== null && (w.$$typeof === A || w.$$typeof === S || w.$$typeof === d || w.$$typeof === p || w.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      w.$$typeof === N || w.getModuleId !== void 0));
    }
    function K(w, z, J) {
      var oe = w.displayName;
      if (oe)
        return oe;
      var Ee = z.displayName || z.name || "";
      return Ee !== "" ? J + "(" + Ee + ")" : J;
    }
    function Z(w) {
      return w.displayName || "Context";
    }
    function j(w) {
      if (w == null)
        return null;
      if (typeof w.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof w == "function")
        return w.displayName || w.name || null;
      if (typeof w == "string")
        return w;
      switch (w) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case c:
          return "StrictMode";
        case b:
          return "Suspense";
        case m:
          return "SuspenseList";
      }
      if (typeof w == "object")
        switch (w.$$typeof) {
          case p:
            var z = w;
            return Z(z) + ".Consumer";
          case d:
            var J = w;
            return Z(J._context) + ".Provider";
          case f:
            return K(w, w.render, "ForwardRef");
          case S:
            var oe = w.displayName || null;
            return oe !== null ? oe : j(w.type) || "Memo";
          case A: {
            var Ee = w, Fe = Ee._payload, xe = Ee._init;
            try {
              return j(xe(Fe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var te = Object.assign, re = 0, ue, Ne, Ge, ye, Be, We, je;
    function He() {
    }
    He.__reactDisabledLog = !0;
    function sn() {
      {
        if (re === 0) {
          ue = console.log, Ne = console.info, Ge = console.warn, ye = console.error, Be = console.group, We = console.groupCollapsed, je = console.groupEnd;
          var w = {
            configurable: !0,
            enumerable: !0,
            value: He,
            writable: !0
          };
          Object.defineProperties(console, {
            info: w,
            log: w,
            warn: w,
            error: w,
            group: w,
            groupCollapsed: w,
            groupEnd: w
          });
        }
        re++;
      }
    }
    function Qe() {
      {
        if (re--, re === 0) {
          var w = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: te({}, w, {
              value: ue
            }),
            info: te({}, w, {
              value: Ne
            }),
            warn: te({}, w, {
              value: Ge
            }),
            error: te({}, w, {
              value: ye
            }),
            group: te({}, w, {
              value: Be
            }),
            groupCollapsed: te({}, w, {
              value: We
            }),
            groupEnd: te({}, w, {
              value: je
            })
          });
        }
        re < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ve = M.ReactCurrentDispatcher, bt;
    function Ke(w, z, J) {
      {
        if (bt === void 0)
          try {
            throw Error();
          } catch (Ee) {
            var oe = Ee.stack.trim().match(/\n( *(at )?)/);
            bt = oe && oe[1] || "";
          }
        return `
` + bt + w;
      }
    }
    var ce = !1, vt;
    {
      var dt = typeof WeakMap == "function" ? WeakMap : Map;
      vt = new dt();
    }
    function gt(w, z) {
      if (!w || ce)
        return "";
      {
        var J = vt.get(w);
        if (J !== void 0)
          return J;
      }
      var oe;
      ce = !0;
      var Ee = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Fe;
      Fe = Ve.current, Ve.current = null, sn();
      try {
        if (z) {
          var xe = function() {
            throw Error();
          };
          if (Object.defineProperty(xe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(xe, []);
            } catch (It) {
              oe = It;
            }
            Reflect.construct(w, [], xe);
          } else {
            try {
              xe.call();
            } catch (It) {
              oe = It;
            }
            w.call(xe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (It) {
            oe = It;
          }
          w();
        }
      } catch (It) {
        if (It && oe && typeof It.stack == "string") {
          for (var ve = It.stack.split(`
`), St = oe.stack.split(`
`), nt = ve.length - 1, at = St.length - 1; nt >= 1 && at >= 0 && ve[nt] !== St[at]; )
            at--;
          for (; nt >= 1 && at >= 0; nt--, at--)
            if (ve[nt] !== St[at]) {
              if (nt !== 1 || at !== 1)
                do
                  if (nt--, at--, at < 0 || ve[nt] !== St[at]) {
                    var yt = `
` + ve[nt].replace(" at new ", " at ");
                    return w.displayName && yt.includes("<anonymous>") && (yt = yt.replace("<anonymous>", w.displayName)), typeof w == "function" && vt.set(w, yt), yt;
                  }
                while (nt >= 1 && at >= 0);
              break;
            }
        }
      } finally {
        ce = !1, Ve.current = Fe, Qe(), Error.prepareStackTrace = Ee;
      }
      var On = w ? w.displayName || w.name : "", Yt = On ? Ke(On) : "";
      return typeof w == "function" && vt.set(w, Yt), Yt;
    }
    function Gt(w, z, J) {
      return gt(w, !1);
    }
    function it(w) {
      var z = w.prototype;
      return !!(z && z.isReactComponent);
    }
    function pt(w, z, J) {
      if (w == null)
        return "";
      if (typeof w == "function")
        return gt(w, it(w));
      if (typeof w == "string")
        return Ke(w);
      switch (w) {
        case b:
          return Ke("Suspense");
        case m:
          return Ke("SuspenseList");
      }
      if (typeof w == "object")
        switch (w.$$typeof) {
          case f:
            return Gt(w.render);
          case S:
            return pt(w.type, z, J);
          case A: {
            var oe = w, Ee = oe._payload, Fe = oe._init;
            try {
              return pt(Fe(Ee), z, J);
            } catch {
            }
          }
        }
      return "";
    }
    var Tt = Object.prototype.hasOwnProperty, ot = {}, Q = M.ReactDebugCurrentFrame;
    function X(w) {
      if (w) {
        var z = w._owner, J = pt(w.type, w._source, z ? z.type : null);
        Q.setExtraStackFrame(J);
      } else
        Q.setExtraStackFrame(null);
    }
    function ge(w, z, J, oe, Ee) {
      {
        var Fe = Function.call.bind(Tt);
        for (var xe in w)
          if (Fe(w, xe)) {
            var ve = void 0;
            try {
              if (typeof w[xe] != "function") {
                var St = Error((oe || "React class") + ": " + J + " type `" + xe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof w[xe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw St.name = "Invariant Violation", St;
              }
              ve = w[xe](z, xe, oe, J, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (nt) {
              ve = nt;
            }
            ve && !(ve instanceof Error) && (X(Ee), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", oe || "React class", J, xe, typeof ve), X(null)), ve instanceof Error && !(ve.message in ot) && (ot[ve.message] = !0, X(Ee), E("Failed %s type: %s", J, ve.message), X(null));
          }
      }
    }
    var Te = Array.isArray;
    function we(w) {
      return Te(w);
    }
    function ze(w) {
      {
        var z = typeof Symbol == "function" && Symbol.toStringTag, J = z && w[Symbol.toStringTag] || w.constructor.name || "Object";
        return J;
      }
    }
    function be(w) {
      try {
        return Le(w), !1;
      } catch {
        return !0;
      }
    }
    function Le(w) {
      return "" + w;
    }
    function Xe(w) {
      if (be(w))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ze(w)), Le(w);
    }
    var st = M.ReactCurrentOwner, xt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Lt, mn, fn;
    fn = {};
    function In(w) {
      if (Tt.call(w, "ref")) {
        var z = Object.getOwnPropertyDescriptor(w, "ref").get;
        if (z && z.isReactWarning)
          return !1;
      }
      return w.ref !== void 0;
    }
    function Bn(w) {
      if (Tt.call(w, "key")) {
        var z = Object.getOwnPropertyDescriptor(w, "key").get;
        if (z && z.isReactWarning)
          return !1;
      }
      return w.key !== void 0;
    }
    function Mn(w, z) {
      if (typeof w.ref == "string" && st.current && z && st.current.stateNode !== z) {
        var J = j(st.current.type);
        fn[J] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', j(st.current.type), w.ref), fn[J] = !0);
      }
    }
    function Pn(w, z) {
      {
        var J = function() {
          Lt || (Lt = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", z));
        };
        J.isReactWarning = !0, Object.defineProperty(w, "key", {
          get: J,
          configurable: !0
        });
      }
    }
    function $(w, z) {
      {
        var J = function() {
          mn || (mn = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", z));
        };
        J.isReactWarning = !0, Object.defineProperty(w, "ref", {
          get: J,
          configurable: !0
        });
      }
    }
    var le = function(w, z, J, oe, Ee, Fe, xe) {
      var ve = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: w,
        key: z,
        ref: J,
        props: xe,
        // Record the component responsible for creating this element.
        _owner: Fe
      };
      return ve._store = {}, Object.defineProperty(ve._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ve, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: oe
      }), Object.defineProperty(ve, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ee
      }), Object.freeze && (Object.freeze(ve.props), Object.freeze(ve)), ve;
    };
    function At(w, z, J, oe, Ee) {
      {
        var Fe, xe = {}, ve = null, St = null;
        J !== void 0 && (Xe(J), ve = "" + J), Bn(z) && (Xe(z.key), ve = "" + z.key), In(z) && (St = z.ref, Mn(z, Ee));
        for (Fe in z)
          Tt.call(z, Fe) && !xt.hasOwnProperty(Fe) && (xe[Fe] = z[Fe]);
        if (w && w.defaultProps) {
          var nt = w.defaultProps;
          for (Fe in nt)
            xe[Fe] === void 0 && (xe[Fe] = nt[Fe]);
        }
        if (ve || St) {
          var at = typeof w == "function" ? w.displayName || w.name || "Unknown" : w;
          ve && Pn(xe, at), St && $(xe, at);
        }
        return le(w, ve, St, Ee, oe, st.current, xe);
      }
    }
    var Nt = M.ReactCurrentOwner, tt = M.ReactDebugCurrentFrame;
    function De(w) {
      if (w) {
        var z = w._owner, J = pt(w.type, w._source, z ? z.type : null);
        tt.setExtraStackFrame(J);
      } else
        tt.setExtraStackFrame(null);
    }
    var Me;
    Me = !1;
    function Pe(w) {
      return typeof w == "object" && w !== null && w.$$typeof === r;
    }
    function qe() {
      {
        if (Nt.current) {
          var w = j(Nt.current.type);
          if (w)
            return `

Check the render method of \`` + w + "`.";
        }
        return "";
      }
    }
    function Rn(w) {
      return "";
    }
    var _n = {};
    function an(w) {
      {
        var z = qe();
        if (!z) {
          var J = typeof w == "string" ? w : w.displayName || w.name;
          J && (z = `

Check the top-level render call using <` + J + ">.");
        }
        return z;
      }
    }
    function Kr(w, z) {
      {
        if (!w._store || w._store.validated || w.key != null)
          return;
        w._store.validated = !0;
        var J = an(z);
        if (_n[J])
          return;
        _n[J] = !0;
        var oe = "";
        w && w._owner && w._owner !== Nt.current && (oe = " It was passed a child from " + j(w._owner.type) + "."), De(w), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', J, oe), De(null);
      }
    }
    function qr(w, z) {
      {
        if (typeof w != "object")
          return;
        if (we(w))
          for (var J = 0; J < w.length; J++) {
            var oe = w[J];
            Pe(oe) && Kr(oe, z);
          }
        else if (Pe(w))
          w._store && (w._store.validated = !0);
        else if (w) {
          var Ee = G(w);
          if (typeof Ee == "function" && Ee !== w.entries)
            for (var Fe = Ee.call(w), xe; !(xe = Fe.next()).done; )
              Pe(xe.value) && Kr(xe.value, z);
        }
      }
    }
    function Ji(w) {
      {
        var z = w.type;
        if (z == null || typeof z == "string")
          return;
        var J;
        if (typeof z == "function")
          J = z.propTypes;
        else if (typeof z == "object" && (z.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        z.$$typeof === S))
          J = z.propTypes;
        else
          return;
        if (J) {
          var oe = j(z);
          ge(J, w.props, "prop", oe, w);
        } else if (z.PropTypes !== void 0 && !Me) {
          Me = !0;
          var Ee = j(z);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ee || "Unknown");
        }
        typeof z.getDefaultProps == "function" && !z.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Sr(w) {
      {
        for (var z = Object.keys(w.props), J = 0; J < z.length; J++) {
          var oe = z[J];
          if (oe !== "children" && oe !== "key") {
            De(w), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", oe), De(null);
            break;
          }
        }
        w.ref !== null && (De(w), E("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    var Yr = {};
    function nr(w, z, J, oe, Ee, Fe) {
      {
        var xe = V(w);
        if (!xe) {
          var ve = "";
          (w === void 0 || typeof w == "object" && w !== null && Object.keys(w).length === 0) && (ve += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var St = Rn();
          St ? ve += St : ve += qe();
          var nt;
          w === null ? nt = "null" : we(w) ? nt = "array" : w !== void 0 && w.$$typeof === r ? (nt = "<" + (j(w.type) || "Unknown") + " />", ve = " Did you accidentally export a JSX literal instead of a component?") : nt = typeof w, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", nt, ve);
        }
        var at = At(w, z, J, Ee, Fe);
        if (at == null)
          return at;
        if (xe) {
          var yt = z.children;
          if (yt !== void 0)
            if (oe)
              if (we(yt)) {
                for (var On = 0; On < yt.length; On++)
                  qr(yt[On], w);
                Object.freeze && Object.freeze(yt);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              qr(yt, w);
        }
        if (Tt.call(z, "key")) {
          var Yt = j(w), It = Object.keys(z).filter(function(Jr) {
            return Jr !== "key";
          }), yr = It.length > 0 ? "{key: someKey, " + It.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Yr[Yt + yr]) {
            var ts = It.length > 0 ? "{" + It.join(": ..., ") + ": ...}" : "{}";
            E(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, yr, Yt, ts, Yt), Yr[Yt + yr] = !0;
          }
        }
        return w === a ? Sr(at) : Ji(at), at;
      }
    }
    function Xi(w, z, J) {
      return nr(w, z, J, !0);
    }
    function Zi(w, z, J) {
      return nr(w, z, J, !1);
    }
    var $i = Zi, es = Xi;
    Hr.Fragment = a, Hr.jsx = $i, Hr.jsxs = es;
  }()), Hr;
}
process.env.NODE_ENV === "production" ? Sa.exports = ov() : Sa.exports = cv();
var x = Sa.exports;
const Gi = "/model-filter.html", uv = `${Gi}?type=all`, fv = "/campaigns/amg-brand.html", dv = "/campaigns/g-class-legend.html", gv = "/campaigns/Maybach.html", pv = "/test-drive.html", hv = "/dealers.html", mv = "/homepage.html";
var wc;
const vr = typeof window < "u" ? (wc = window.mbeCfg) == null ? void 0 : wc.api_oneweb : "https://api.oneweb-dev.mercedes-benz.com.cn";
`${vr}`, `${vr}`, `${vr}`, `${vr}`, `${vr}`, `${vr}`, `${parseInt(
  (Math.random() * 100).toString(),
  10
)}`;
const br = "级", yc = "woHeaderFooter", Cc = "global_header_user-center-icon", Ec = "global_header_search-icon", vv = "preUrl", Av = ["test-drive", "purchase/product-order-page", "presale-testdrive"], Hi = {
  sedan: "Sedan",
  suv: "SUV",
  coupe: "Coupe",
  mpv: "Van",
  eq: "NEV",
  phev: "PHEV",
  amg: "amg",
  maybach: "maybach",
  "g-class": "gClass"
}, Tc = "data:image/png;base64,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";
var Vi = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Vi.exports;
(function(s, r) {
  (function() {
    var n, a = "4.17.21", c = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", d = "Expected a function", p = "Invalid `variable` option passed into `_.template`", f = "__lodash_hash_undefined__", b = 500, m = "__lodash_placeholder__", S = 1, A = 2, y = 4, _ = 1, O = 2, G = 1, M = 2, E = 4, T = 8, L = 16, P = 32, k = 64, q = 128, W = 256, N = 512, V = 30, K = "...", Z = 800, j = 16, te = 1, re = 2, ue = 3, Ne = 1 / 0, Ge = 9007199254740991, ye = 17976931348623157e292, Be = NaN, We = 4294967295, je = We - 1, He = We >>> 1, sn = [
      ["ary", q],
      ["bind", G],
      ["bindKey", M],
      ["curry", T],
      ["curryRight", L],
      ["flip", N],
      ["partial", P],
      ["partialRight", k],
      ["rearg", W]
    ], Qe = "[object Arguments]", Ve = "[object Array]", bt = "[object AsyncFunction]", Ke = "[object Boolean]", ce = "[object Date]", vt = "[object DOMException]", dt = "[object Error]", gt = "[object Function]", Gt = "[object GeneratorFunction]", it = "[object Map]", pt = "[object Number]", Tt = "[object Null]", ot = "[object Object]", Q = "[object Promise]", X = "[object Proxy]", ge = "[object RegExp]", Te = "[object Set]", we = "[object String]", ze = "[object Symbol]", be = "[object Undefined]", Le = "[object WeakMap]", Xe = "[object WeakSet]", st = "[object ArrayBuffer]", xt = "[object DataView]", Lt = "[object Float32Array]", mn = "[object Float64Array]", fn = "[object Int8Array]", In = "[object Int16Array]", Bn = "[object Int32Array]", Mn = "[object Uint8Array]", Pn = "[object Uint8ClampedArray]", $ = "[object Uint16Array]", le = "[object Uint32Array]", At = /\b__p \+= '';/g, Nt = /\b(__p \+=) '' \+/g, tt = /(__e\(.*?\)|\b__t\)) \+\n'';/g, De = /&(?:amp|lt|gt|quot|#39);/g, Me = /[&<>"']/g, Pe = RegExp(De.source), qe = RegExp(Me.source), Rn = /<%-([\s\S]+?)%>/g, _n = /<%([\s\S]+?)%>/g, an = /<%=([\s\S]+?)%>/g, Kr = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, qr = /^\w*$/, Ji = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Sr = /[\\^$.*+?()[\]{}|]/g, Yr = RegExp(Sr.source), nr = /^\s+/, Xi = /\s/, Zi = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, $i = /\{\n\/\* \[wrapped with (.+)\] \*/, es = /,? & /, w = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, z = /[()=,{}\[\]\/\s]/, J = /\\(\\)?/g, oe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ee = /\w*$/, Fe = /^[-+]0x[0-9a-f]+$/i, xe = /^0b[01]+$/i, ve = /^\[object .+?Constructor\]$/, St = /^0o[0-7]+$/i, nt = /^(?:0|[1-9]\d*)$/, at = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, yt = /($^)/, On = /['\n\r\u2028\u2029\\]/g, Yt = "\\ud800-\\udfff", It = "\\u0300-\\u036f", yr = "\\ufe20-\\ufe2f", ts = "\\u20d0-\\u20ff", Jr = It + yr + ts, Ra = "\\u2700-\\u27bf", _a = "a-z\\xdf-\\xf6\\xf8-\\xff", Zc = "\\xac\\xb1\\xd7\\xf7", $c = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", eu = "\\u2000-\\u206f", tu = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Oa = "A-Z\\xc0-\\xd6\\xd8-\\xde", Na = "\\ufe0e\\ufe0f", Da = Zc + $c + eu + tu, ns = "['’]", nu = "[" + Yt + "]", ka = "[" + Da + "]", Xr = "[" + Jr + "]", Fa = "\\d+", ru = "[" + Ra + "]", Ua = "[" + _a + "]", Ga = "[^" + Yt + Da + Fa + Ra + _a + Oa + "]", rs = "\\ud83c[\\udffb-\\udfff]", iu = "(?:" + Xr + "|" + rs + ")", Ha = "[^" + Yt + "]", is = "(?:\\ud83c[\\udde6-\\uddff]){2}", ss = "[\\ud800-\\udbff][\\udc00-\\udfff]", rr = "[" + Oa + "]", Va = "\\u200d", za = "(?:" + Ua + "|" + Ga + ")", su = "(?:" + rr + "|" + Ga + ")", Wa = "(?:" + ns + "(?:d|ll|m|re|s|t|ve))?", ja = "(?:" + ns + "(?:D|LL|M|RE|S|T|VE))?", Qa = iu + "?", Ka = "[" + Na + "]?", au = "(?:" + Va + "(?:" + [Ha, is, ss].join("|") + ")" + Ka + Qa + ")*", lu = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", ou = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", qa = Ka + Qa + au, cu = "(?:" + [ru, is, ss].join("|") + ")" + qa, uu = "(?:" + [Ha + Xr + "?", Xr, is, ss, nu].join("|") + ")", fu = RegExp(ns, "g"), du = RegExp(Xr, "g"), as = RegExp(rs + "(?=" + rs + ")|" + uu + qa, "g"), gu = RegExp([
      rr + "?" + Ua + "+" + Wa + "(?=" + [ka, rr, "$"].join("|") + ")",
      su + "+" + ja + "(?=" + [ka, rr + za, "$"].join("|") + ")",
      rr + "?" + za + "+" + Wa,
      rr + "+" + ja,
      ou,
      lu,
      Fa,
      cu
    ].join("|"), "g"), pu = RegExp("[" + Va + Yt + Jr + Na + "]"), hu = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, mu = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], vu = -1, $e = {};
    $e[Lt] = $e[mn] = $e[fn] = $e[In] = $e[Bn] = $e[Mn] = $e[Pn] = $e[$] = $e[le] = !0, $e[Qe] = $e[Ve] = $e[st] = $e[Ke] = $e[xt] = $e[ce] = $e[dt] = $e[gt] = $e[it] = $e[pt] = $e[ot] = $e[ge] = $e[Te] = $e[we] = $e[Le] = !1;
    var Ze = {};
    Ze[Qe] = Ze[Ve] = Ze[st] = Ze[xt] = Ze[Ke] = Ze[ce] = Ze[Lt] = Ze[mn] = Ze[fn] = Ze[In] = Ze[Bn] = Ze[it] = Ze[pt] = Ze[ot] = Ze[ge] = Ze[Te] = Ze[we] = Ze[ze] = Ze[Mn] = Ze[Pn] = Ze[$] = Ze[le] = !0, Ze[dt] = Ze[gt] = Ze[Le] = !1;
    var Au = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, wu = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, bu = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, xu = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Su = parseFloat, yu = parseInt, Ya = typeof Ur == "object" && Ur && Ur.Object === Object && Ur, Cu = typeof self == "object" && self && self.Object === Object && self, Ct = Ya || Cu || Function("return this")(), ls = r && !r.nodeType && r, jn = ls && !0 && s && !s.nodeType && s, Ja = jn && jn.exports === ls, os = Ja && Ya.process, Jt = function() {
      try {
        var I = jn && jn.require && jn.require("util").types;
        return I || os && os.binding && os.binding("util");
      } catch {
      }
    }(), Xa = Jt && Jt.isArrayBuffer, Za = Jt && Jt.isDate, $a = Jt && Jt.isMap, el = Jt && Jt.isRegExp, tl = Jt && Jt.isSet, nl = Jt && Jt.isTypedArray;
    function Ht(I, D, R) {
      switch (R.length) {
        case 0:
          return I.call(D);
        case 1:
          return I.call(D, R[0]);
        case 2:
          return I.call(D, R[0], R[1]);
        case 3:
          return I.call(D, R[0], R[1], R[2]);
      }
      return I.apply(D, R);
    }
    function Eu(I, D, R, ee) {
      for (var fe = -1, Re = I == null ? 0 : I.length; ++fe < Re; ) {
        var ht = I[fe];
        D(ee, ht, R(ht), I);
      }
      return ee;
    }
    function Xt(I, D) {
      for (var R = -1, ee = I == null ? 0 : I.length; ++R < ee && D(I[R], R, I) !== !1; )
        ;
      return I;
    }
    function Tu(I, D) {
      for (var R = I == null ? 0 : I.length; R-- && D(I[R], R, I) !== !1; )
        ;
      return I;
    }
    function rl(I, D) {
      for (var R = -1, ee = I == null ? 0 : I.length; ++R < ee; )
        if (!D(I[R], R, I))
          return !1;
      return !0;
    }
    function Nn(I, D) {
      for (var R = -1, ee = I == null ? 0 : I.length, fe = 0, Re = []; ++R < ee; ) {
        var ht = I[R];
        D(ht, R, I) && (Re[fe++] = ht);
      }
      return Re;
    }
    function Zr(I, D) {
      var R = I == null ? 0 : I.length;
      return !!R && ir(I, D, 0) > -1;
    }
    function cs(I, D, R) {
      for (var ee = -1, fe = I == null ? 0 : I.length; ++ee < fe; )
        if (R(D, I[ee]))
          return !0;
      return !1;
    }
    function et(I, D) {
      for (var R = -1, ee = I == null ? 0 : I.length, fe = Array(ee); ++R < ee; )
        fe[R] = D(I[R], R, I);
      return fe;
    }
    function Dn(I, D) {
      for (var R = -1, ee = D.length, fe = I.length; ++R < ee; )
        I[fe + R] = D[R];
      return I;
    }
    function us(I, D, R, ee) {
      var fe = -1, Re = I == null ? 0 : I.length;
      for (ee && Re && (R = I[++fe]); ++fe < Re; )
        R = D(R, I[fe], fe, I);
      return R;
    }
    function Lu(I, D, R, ee) {
      var fe = I == null ? 0 : I.length;
      for (ee && fe && (R = I[--fe]); fe--; )
        R = D(R, I[fe], fe, I);
      return R;
    }
    function fs(I, D) {
      for (var R = -1, ee = I == null ? 0 : I.length; ++R < ee; )
        if (D(I[R], R, I))
          return !0;
      return !1;
    }
    var Iu = ds("length");
    function Bu(I) {
      return I.split("");
    }
    function Mu(I) {
      return I.match(w) || [];
    }
    function il(I, D, R) {
      var ee;
      return R(I, function(fe, Re, ht) {
        if (D(fe, Re, ht))
          return ee = Re, !1;
      }), ee;
    }
    function $r(I, D, R, ee) {
      for (var fe = I.length, Re = R + (ee ? 1 : -1); ee ? Re-- : ++Re < fe; )
        if (D(I[Re], Re, I))
          return Re;
      return -1;
    }
    function ir(I, D, R) {
      return D === D ? Vu(I, D, R) : $r(I, sl, R);
    }
    function Pu(I, D, R, ee) {
      for (var fe = R - 1, Re = I.length; ++fe < Re; )
        if (ee(I[fe], D))
          return fe;
      return -1;
    }
    function sl(I) {
      return I !== I;
    }
    function al(I, D) {
      var R = I == null ? 0 : I.length;
      return R ? ps(I, D) / R : Be;
    }
    function ds(I) {
      return function(D) {
        return D == null ? n : D[I];
      };
    }
    function gs(I) {
      return function(D) {
        return I == null ? n : I[D];
      };
    }
    function ll(I, D, R, ee, fe) {
      return fe(I, function(Re, ht, Ye) {
        R = ee ? (ee = !1, Re) : D(R, Re, ht, Ye);
      }), R;
    }
    function Ru(I, D) {
      var R = I.length;
      for (I.sort(D); R--; )
        I[R] = I[R].value;
      return I;
    }
    function ps(I, D) {
      for (var R, ee = -1, fe = I.length; ++ee < fe; ) {
        var Re = D(I[ee]);
        Re !== n && (R = R === n ? Re : R + Re);
      }
      return R;
    }
    function hs(I, D) {
      for (var R = -1, ee = Array(I); ++R < I; )
        ee[R] = D(R);
      return ee;
    }
    function _u(I, D) {
      return et(D, function(R) {
        return [R, I[R]];
      });
    }
    function ol(I) {
      return I && I.slice(0, dl(I) + 1).replace(nr, "");
    }
    function Vt(I) {
      return function(D) {
        return I(D);
      };
    }
    function ms(I, D) {
      return et(D, function(R) {
        return I[R];
      });
    }
    function Cr(I, D) {
      return I.has(D);
    }
    function cl(I, D) {
      for (var R = -1, ee = I.length; ++R < ee && ir(D, I[R], 0) > -1; )
        ;
      return R;
    }
    function ul(I, D) {
      for (var R = I.length; R-- && ir(D, I[R], 0) > -1; )
        ;
      return R;
    }
    function Ou(I, D) {
      for (var R = I.length, ee = 0; R--; )
        I[R] === D && ++ee;
      return ee;
    }
    var Nu = gs(Au), Du = gs(wu);
    function ku(I) {
      return "\\" + xu[I];
    }
    function Fu(I, D) {
      return I == null ? n : I[D];
    }
    function sr(I) {
      return pu.test(I);
    }
    function Uu(I) {
      return hu.test(I);
    }
    function Gu(I) {
      for (var D, R = []; !(D = I.next()).done; )
        R.push(D.value);
      return R;
    }
    function vs(I) {
      var D = -1, R = Array(I.size);
      return I.forEach(function(ee, fe) {
        R[++D] = [fe, ee];
      }), R;
    }
    function fl(I, D) {
      return function(R) {
        return I(D(R));
      };
    }
    function kn(I, D) {
      for (var R = -1, ee = I.length, fe = 0, Re = []; ++R < ee; ) {
        var ht = I[R];
        (ht === D || ht === m) && (I[R] = m, Re[fe++] = R);
      }
      return Re;
    }
    function ei(I) {
      var D = -1, R = Array(I.size);
      return I.forEach(function(ee) {
        R[++D] = ee;
      }), R;
    }
    function Hu(I) {
      var D = -1, R = Array(I.size);
      return I.forEach(function(ee) {
        R[++D] = [ee, ee];
      }), R;
    }
    function Vu(I, D, R) {
      for (var ee = R - 1, fe = I.length; ++ee < fe; )
        if (I[ee] === D)
          return ee;
      return -1;
    }
    function zu(I, D, R) {
      for (var ee = R + 1; ee--; )
        if (I[ee] === D)
          return ee;
      return ee;
    }
    function ar(I) {
      return sr(I) ? ju(I) : Iu(I);
    }
    function ln(I) {
      return sr(I) ? Qu(I) : Bu(I);
    }
    function dl(I) {
      for (var D = I.length; D-- && Xi.test(I.charAt(D)); )
        ;
      return D;
    }
    var Wu = gs(bu);
    function ju(I) {
      for (var D = as.lastIndex = 0; as.test(I); )
        ++D;
      return D;
    }
    function Qu(I) {
      return I.match(as) || [];
    }
    function Ku(I) {
      return I.match(gu) || [];
    }
    var qu = function I(D) {
      D = D == null ? Ct : lr.defaults(Ct.Object(), D, lr.pick(Ct, mu));
      var R = D.Array, ee = D.Date, fe = D.Error, Re = D.Function, ht = D.Math, Ye = D.Object, As = D.RegExp, Yu = D.String, Zt = D.TypeError, ti = R.prototype, Ju = Re.prototype, or = Ye.prototype, ni = D["__core-js_shared__"], ri = Ju.toString, Ue = or.hasOwnProperty, Xu = 0, gl = function() {
        var e = /[^.]+$/.exec(ni && ni.keys && ni.keys.IE_PROTO || "");
        return e ? "Symbol(src)_1." + e : "";
      }(), ii = or.toString, Zu = ri.call(Ye), $u = Ct._, ef = As(
        "^" + ri.call(Ue).replace(Sr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), si = Ja ? D.Buffer : n, Fn = D.Symbol, ai = D.Uint8Array, pl = si ? si.allocUnsafe : n, li = fl(Ye.getPrototypeOf, Ye), hl = Ye.create, ml = or.propertyIsEnumerable, oi = ti.splice, vl = Fn ? Fn.isConcatSpreadable : n, Er = Fn ? Fn.iterator : n, Qn = Fn ? Fn.toStringTag : n, ci = function() {
        try {
          var e = Xn(Ye, "defineProperty");
          return e({}, "", {}), e;
        } catch {
        }
      }(), tf = D.clearTimeout !== Ct.clearTimeout && D.clearTimeout, nf = ee && ee.now !== Ct.Date.now && ee.now, rf = D.setTimeout !== Ct.setTimeout && D.setTimeout, ui = ht.ceil, fi = ht.floor, ws = Ye.getOwnPropertySymbols, sf = si ? si.isBuffer : n, Al = D.isFinite, af = ti.join, lf = fl(Ye.keys, Ye), mt = ht.max, Bt = ht.min, of = ee.now, cf = D.parseInt, wl = ht.random, uf = ti.reverse, bs = Xn(D, "DataView"), Tr = Xn(D, "Map"), xs = Xn(D, "Promise"), cr = Xn(D, "Set"), Lr = Xn(D, "WeakMap"), Ir = Xn(Ye, "create"), di = Lr && new Lr(), ur = {}, ff = Zn(bs), df = Zn(Tr), gf = Zn(xs), pf = Zn(cr), hf = Zn(Lr), gi = Fn ? Fn.prototype : n, Br = gi ? gi.valueOf : n, bl = gi ? gi.toString : n;
      function g(e) {
        if (lt(e) && !de(e) && !(e instanceof Se)) {
          if (e instanceof $t)
            return e;
          if (Ue.call(e, "__wrapped__"))
            return So(e);
        }
        return new $t(e);
      }
      var fr = /* @__PURE__ */ function() {
        function e() {
        }
        return function(t) {
          if (!rt(t))
            return {};
          if (hl)
            return hl(t);
          e.prototype = t;
          var i = new e();
          return e.prototype = n, i;
        };
      }();
      function pi() {
      }
      function $t(e, t) {
        this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = n;
      }
      g.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Rn,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: _n,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: an,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: g
        }
      }, g.prototype = pi.prototype, g.prototype.constructor = g, $t.prototype = fr(pi.prototype), $t.prototype.constructor = $t;
      function Se(e) {
        this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = We, this.__views__ = [];
      }
      function mf() {
        var e = new Se(this.__wrapped__);
        return e.__actions__ = Dt(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Dt(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Dt(this.__views__), e;
      }
      function vf() {
        if (this.__filtered__) {
          var e = new Se(this);
          e.__dir__ = -1, e.__filtered__ = !0;
        } else
          e = this.clone(), e.__dir__ *= -1;
        return e;
      }
      function Af() {
        var e = this.__wrapped__.value(), t = this.__dir__, i = de(e), l = t < 0, u = i ? e.length : 0, h = Md(0, u, this.__views__), v = h.start, C = h.end, B = C - v, F = l ? C : v - 1, U = this.__iteratees__, H = U.length, Y = 0, ne = Bt(B, this.__takeCount__);
        if (!i || !l && u == B && ne == B)
          return Wl(e, this.__actions__);
        var se = [];
        e:
          for (; B-- && Y < ne; ) {
            F += t;
            for (var he = -1, ae = e[F]; ++he < H; ) {
              var Ae = U[he], Ce = Ae.iteratee, jt = Ae.type, _t = Ce(ae);
              if (jt == re)
                ae = _t;
              else if (!_t) {
                if (jt == te)
                  continue e;
                break e;
              }
            }
            se[Y++] = ae;
          }
        return se;
      }
      Se.prototype = fr(pi.prototype), Se.prototype.constructor = Se;
      function Kn(e) {
        var t = -1, i = e == null ? 0 : e.length;
        for (this.clear(); ++t < i; ) {
          var l = e[t];
          this.set(l[0], l[1]);
        }
      }
      function wf() {
        this.__data__ = Ir ? Ir(null) : {}, this.size = 0;
      }
      function bf(e) {
        var t = this.has(e) && delete this.__data__[e];
        return this.size -= t ? 1 : 0, t;
      }
      function xf(e) {
        var t = this.__data__;
        if (Ir) {
          var i = t[e];
          return i === f ? n : i;
        }
        return Ue.call(t, e) ? t[e] : n;
      }
      function Sf(e) {
        var t = this.__data__;
        return Ir ? t[e] !== n : Ue.call(t, e);
      }
      function yf(e, t) {
        var i = this.__data__;
        return this.size += this.has(e) ? 0 : 1, i[e] = Ir && t === n ? f : t, this;
      }
      Kn.prototype.clear = wf, Kn.prototype.delete = bf, Kn.prototype.get = xf, Kn.prototype.has = Sf, Kn.prototype.set = yf;
      function vn(e) {
        var t = -1, i = e == null ? 0 : e.length;
        for (this.clear(); ++t < i; ) {
          var l = e[t];
          this.set(l[0], l[1]);
        }
      }
      function Cf() {
        this.__data__ = [], this.size = 0;
      }
      function Ef(e) {
        var t = this.__data__, i = hi(t, e);
        if (i < 0)
          return !1;
        var l = t.length - 1;
        return i == l ? t.pop() : oi.call(t, i, 1), --this.size, !0;
      }
      function Tf(e) {
        var t = this.__data__, i = hi(t, e);
        return i < 0 ? n : t[i][1];
      }
      function Lf(e) {
        return hi(this.__data__, e) > -1;
      }
      function If(e, t) {
        var i = this.__data__, l = hi(i, e);
        return l < 0 ? (++this.size, i.push([e, t])) : i[l][1] = t, this;
      }
      vn.prototype.clear = Cf, vn.prototype.delete = Ef, vn.prototype.get = Tf, vn.prototype.has = Lf, vn.prototype.set = If;
      function An(e) {
        var t = -1, i = e == null ? 0 : e.length;
        for (this.clear(); ++t < i; ) {
          var l = e[t];
          this.set(l[0], l[1]);
        }
      }
      function Bf() {
        this.size = 0, this.__data__ = {
          hash: new Kn(),
          map: new (Tr || vn)(),
          string: new Kn()
        };
      }
      function Mf(e) {
        var t = Li(this, e).delete(e);
        return this.size -= t ? 1 : 0, t;
      }
      function Pf(e) {
        return Li(this, e).get(e);
      }
      function Rf(e) {
        return Li(this, e).has(e);
      }
      function _f(e, t) {
        var i = Li(this, e), l = i.size;
        return i.set(e, t), this.size += i.size == l ? 0 : 1, this;
      }
      An.prototype.clear = Bf, An.prototype.delete = Mf, An.prototype.get = Pf, An.prototype.has = Rf, An.prototype.set = _f;
      function qn(e) {
        var t = -1, i = e == null ? 0 : e.length;
        for (this.__data__ = new An(); ++t < i; )
          this.add(e[t]);
      }
      function Of(e) {
        return this.__data__.set(e, f), this;
      }
      function Nf(e) {
        return this.__data__.has(e);
      }
      qn.prototype.add = qn.prototype.push = Of, qn.prototype.has = Nf;
      function on(e) {
        var t = this.__data__ = new vn(e);
        this.size = t.size;
      }
      function Df() {
        this.__data__ = new vn(), this.size = 0;
      }
      function kf(e) {
        var t = this.__data__, i = t.delete(e);
        return this.size = t.size, i;
      }
      function Ff(e) {
        return this.__data__.get(e);
      }
      function Uf(e) {
        return this.__data__.has(e);
      }
      function Gf(e, t) {
        var i = this.__data__;
        if (i instanceof vn) {
          var l = i.__data__;
          if (!Tr || l.length < c - 1)
            return l.push([e, t]), this.size = ++i.size, this;
          i = this.__data__ = new An(l);
        }
        return i.set(e, t), this.size = i.size, this;
      }
      on.prototype.clear = Df, on.prototype.delete = kf, on.prototype.get = Ff, on.prototype.has = Uf, on.prototype.set = Gf;
      function xl(e, t) {
        var i = de(e), l = !i && $n(e), u = !i && !l && zn(e), h = !i && !l && !u && hr(e), v = i || l || u || h, C = v ? hs(e.length, Yu) : [], B = C.length;
        for (var F in e)
          (t || Ue.call(e, F)) && !(v && // Safari 9 has enumerable `arguments.length` in strict mode.
          (F == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          u && (F == "offset" || F == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          h && (F == "buffer" || F == "byteLength" || F == "byteOffset") || // Skip index properties.
          Sn(F, B))) && C.push(F);
        return C;
      }
      function Sl(e) {
        var t = e.length;
        return t ? e[Rs(0, t - 1)] : n;
      }
      function Hf(e, t) {
        return Ii(Dt(e), Yn(t, 0, e.length));
      }
      function Vf(e) {
        return Ii(Dt(e));
      }
      function Ss(e, t, i) {
        (i !== n && !cn(e[t], i) || i === n && !(t in e)) && wn(e, t, i);
      }
      function Mr(e, t, i) {
        var l = e[t];
        (!(Ue.call(e, t) && cn(l, i)) || i === n && !(t in e)) && wn(e, t, i);
      }
      function hi(e, t) {
        for (var i = e.length; i--; )
          if (cn(e[i][0], t))
            return i;
        return -1;
      }
      function zf(e, t, i, l) {
        return Un(e, function(u, h, v) {
          t(l, u, i(u), v);
        }), l;
      }
      function yl(e, t) {
        return e && gn(t, wt(t), e);
      }
      function Wf(e, t) {
        return e && gn(t, Ft(t), e);
      }
      function wn(e, t, i) {
        t == "__proto__" && ci ? ci(e, t, {
          configurable: !0,
          enumerable: !0,
          value: i,
          writable: !0
        }) : e[t] = i;
      }
      function ys(e, t) {
        for (var i = -1, l = t.length, u = R(l), h = e == null; ++i < l; )
          u[i] = h ? n : ra(e, t[i]);
        return u;
      }
      function Yn(e, t, i) {
        return e === e && (i !== n && (e = e <= i ? e : i), t !== n && (e = e >= t ? e : t)), e;
      }
      function en(e, t, i, l, u, h) {
        var v, C = t & S, B = t & A, F = t & y;
        if (i && (v = u ? i(e, l, u, h) : i(e)), v !== n)
          return v;
        if (!rt(e))
          return e;
        var U = de(e);
        if (U) {
          if (v = Rd(e), !C)
            return Dt(e, v);
        } else {
          var H = Mt(e), Y = H == gt || H == Gt;
          if (zn(e))
            return Kl(e, C);
          if (H == ot || H == Qe || Y && !u) {
            if (v = B || Y ? {} : go(e), !C)
              return B ? xd(e, Wf(v, e)) : bd(e, yl(v, e));
          } else {
            if (!Ze[H])
              return u ? e : {};
            v = _d(e, H, C);
          }
        }
        h || (h = new on());
        var ne = h.get(e);
        if (ne)
          return ne;
        h.set(e, v), Vo(e) ? e.forEach(function(ae) {
          v.add(en(ae, t, i, ae, e, h));
        }) : Go(e) && e.forEach(function(ae, Ae) {
          v.set(Ae, en(ae, t, i, Ae, e, h));
        });
        var se = F ? B ? zs : Vs : B ? Ft : wt, he = U ? n : se(e);
        return Xt(he || e, function(ae, Ae) {
          he && (Ae = ae, ae = e[Ae]), Mr(v, Ae, en(ae, t, i, Ae, e, h));
        }), v;
      }
      function jf(e) {
        var t = wt(e);
        return function(i) {
          return Cl(i, e, t);
        };
      }
      function Cl(e, t, i) {
        var l = i.length;
        if (e == null)
          return !l;
        for (e = Ye(e); l--; ) {
          var u = i[l], h = t[u], v = e[u];
          if (v === n && !(u in e) || !h(v))
            return !1;
        }
        return !0;
      }
      function El(e, t, i) {
        if (typeof e != "function")
          throw new Zt(d);
        return kr(function() {
          e.apply(n, i);
        }, t);
      }
      function Pr(e, t, i, l) {
        var u = -1, h = Zr, v = !0, C = e.length, B = [], F = t.length;
        if (!C)
          return B;
        i && (t = et(t, Vt(i))), l ? (h = cs, v = !1) : t.length >= c && (h = Cr, v = !1, t = new qn(t));
        e:
          for (; ++u < C; ) {
            var U = e[u], H = i == null ? U : i(U);
            if (U = l || U !== 0 ? U : 0, v && H === H) {
              for (var Y = F; Y--; )
                if (t[Y] === H)
                  continue e;
              B.push(U);
            } else h(t, H, l) || B.push(U);
          }
        return B;
      }
      var Un = Zl(dn), Tl = Zl(Es, !0);
      function Qf(e, t) {
        var i = !0;
        return Un(e, function(l, u, h) {
          return i = !!t(l, u, h), i;
        }), i;
      }
      function mi(e, t, i) {
        for (var l = -1, u = e.length; ++l < u; ) {
          var h = e[l], v = t(h);
          if (v != null && (C === n ? v === v && !Wt(v) : i(v, C)))
            var C = v, B = h;
        }
        return B;
      }
      function Kf(e, t, i, l) {
        var u = e.length;
        for (i = pe(i), i < 0 && (i = -i > u ? 0 : u + i), l = l === n || l > u ? u : pe(l), l < 0 && (l += u), l = i > l ? 0 : Wo(l); i < l; )
          e[i++] = t;
        return e;
      }
      function Ll(e, t) {
        var i = [];
        return Un(e, function(l, u, h) {
          t(l, u, h) && i.push(l);
        }), i;
      }
      function Et(e, t, i, l, u) {
        var h = -1, v = e.length;
        for (i || (i = Nd), u || (u = []); ++h < v; ) {
          var C = e[h];
          t > 0 && i(C) ? t > 1 ? Et(C, t - 1, i, l, u) : Dn(u, C) : l || (u[u.length] = C);
        }
        return u;
      }
      var Cs = $l(), Il = $l(!0);
      function dn(e, t) {
        return e && Cs(e, t, wt);
      }
      function Es(e, t) {
        return e && Il(e, t, wt);
      }
      function vi(e, t) {
        return Nn(t, function(i) {
          return yn(e[i]);
        });
      }
      function Jn(e, t) {
        t = Hn(t, e);
        for (var i = 0, l = t.length; e != null && i < l; )
          e = e[pn(t[i++])];
        return i && i == l ? e : n;
      }
      function Bl(e, t, i) {
        var l = t(e);
        return de(e) ? l : Dn(l, i(e));
      }
      function Pt(e) {
        return e == null ? e === n ? be : Tt : Qn && Qn in Ye(e) ? Bd(e) : Vd(e);
      }
      function Ts(e, t) {
        return e > t;
      }
      function qf(e, t) {
        return e != null && Ue.call(e, t);
      }
      function Yf(e, t) {
        return e != null && t in Ye(e);
      }
      function Jf(e, t, i) {
        return e >= Bt(t, i) && e < mt(t, i);
      }
      function Ls(e, t, i) {
        for (var l = i ? cs : Zr, u = e[0].length, h = e.length, v = h, C = R(h), B = 1 / 0, F = []; v--; ) {
          var U = e[v];
          v && t && (U = et(U, Vt(t))), B = Bt(U.length, B), C[v] = !i && (t || u >= 120 && U.length >= 120) ? new qn(v && U) : n;
        }
        U = e[0];
        var H = -1, Y = C[0];
        e:
          for (; ++H < u && F.length < B; ) {
            var ne = U[H], se = t ? t(ne) : ne;
            if (ne = i || ne !== 0 ? ne : 0, !(Y ? Cr(Y, se) : l(F, se, i))) {
              for (v = h; --v; ) {
                var he = C[v];
                if (!(he ? Cr(he, se) : l(e[v], se, i)))
                  continue e;
              }
              Y && Y.push(se), F.push(ne);
            }
          }
        return F;
      }
      function Xf(e, t, i, l) {
        return dn(e, function(u, h, v) {
          t(l, i(u), h, v);
        }), l;
      }
      function Rr(e, t, i) {
        t = Hn(t, e), e = vo(e, t);
        var l = e == null ? e : e[pn(nn(t))];
        return l == null ? n : Ht(l, e, i);
      }
      function Ml(e) {
        return lt(e) && Pt(e) == Qe;
      }
      function Zf(e) {
        return lt(e) && Pt(e) == st;
      }
      function $f(e) {
        return lt(e) && Pt(e) == ce;
      }
      function _r(e, t, i, l, u) {
        return e === t ? !0 : e == null || t == null || !lt(e) && !lt(t) ? e !== e && t !== t : ed(e, t, i, l, _r, u);
      }
      function ed(e, t, i, l, u, h) {
        var v = de(e), C = de(t), B = v ? Ve : Mt(e), F = C ? Ve : Mt(t);
        B = B == Qe ? ot : B, F = F == Qe ? ot : F;
        var U = B == ot, H = F == ot, Y = B == F;
        if (Y && zn(e)) {
          if (!zn(t))
            return !1;
          v = !0, U = !1;
        }
        if (Y && !U)
          return h || (h = new on()), v || hr(e) ? co(e, t, i, l, u, h) : Ld(e, t, B, i, l, u, h);
        if (!(i & _)) {
          var ne = U && Ue.call(e, "__wrapped__"), se = H && Ue.call(t, "__wrapped__");
          if (ne || se) {
            var he = ne ? e.value() : e, ae = se ? t.value() : t;
            return h || (h = new on()), u(he, ae, i, l, h);
          }
        }
        return Y ? (h || (h = new on()), Id(e, t, i, l, u, h)) : !1;
      }
      function td(e) {
        return lt(e) && Mt(e) == it;
      }
      function Is(e, t, i, l) {
        var u = i.length, h = u, v = !l;
        if (e == null)
          return !h;
        for (e = Ye(e); u--; ) {
          var C = i[u];
          if (v && C[2] ? C[1] !== e[C[0]] : !(C[0] in e))
            return !1;
        }
        for (; ++u < h; ) {
          C = i[u];
          var B = C[0], F = e[B], U = C[1];
          if (v && C[2]) {
            if (F === n && !(B in e))
              return !1;
          } else {
            var H = new on();
            if (l)
              var Y = l(F, U, B, e, t, H);
            if (!(Y === n ? _r(U, F, _ | O, l, H) : Y))
              return !1;
          }
        }
        return !0;
      }
      function Pl(e) {
        if (!rt(e) || kd(e))
          return !1;
        var t = yn(e) ? ef : ve;
        return t.test(Zn(e));
      }
      function nd(e) {
        return lt(e) && Pt(e) == ge;
      }
      function rd(e) {
        return lt(e) && Mt(e) == Te;
      }
      function id(e) {
        return lt(e) && Oi(e.length) && !!$e[Pt(e)];
      }
      function Rl(e) {
        return typeof e == "function" ? e : e == null ? Ut : typeof e == "object" ? de(e) ? Nl(e[0], e[1]) : Ol(e) : tc(e);
      }
      function Bs(e) {
        if (!Dr(e))
          return lf(e);
        var t = [];
        for (var i in Ye(e))
          Ue.call(e, i) && i != "constructor" && t.push(i);
        return t;
      }
      function sd(e) {
        if (!rt(e))
          return Hd(e);
        var t = Dr(e), i = [];
        for (var l in e)
          l == "constructor" && (t || !Ue.call(e, l)) || i.push(l);
        return i;
      }
      function Ms(e, t) {
        return e < t;
      }
      function _l(e, t) {
        var i = -1, l = kt(e) ? R(e.length) : [];
        return Un(e, function(u, h, v) {
          l[++i] = t(u, h, v);
        }), l;
      }
      function Ol(e) {
        var t = js(e);
        return t.length == 1 && t[0][2] ? ho(t[0][0], t[0][1]) : function(i) {
          return i === e || Is(i, e, t);
        };
      }
      function Nl(e, t) {
        return Ks(e) && po(t) ? ho(pn(e), t) : function(i) {
          var l = ra(i, e);
          return l === n && l === t ? ia(i, e) : _r(t, l, _ | O);
        };
      }
      function Ai(e, t, i, l, u) {
        e !== t && Cs(t, function(h, v) {
          if (u || (u = new on()), rt(h))
            ad(e, t, v, i, Ai, l, u);
          else {
            var C = l ? l(Ys(e, v), h, v + "", e, t, u) : n;
            C === n && (C = h), Ss(e, v, C);
          }
        }, Ft);
      }
      function ad(e, t, i, l, u, h, v) {
        var C = Ys(e, i), B = Ys(t, i), F = v.get(B);
        if (F) {
          Ss(e, i, F);
          return;
        }
        var U = h ? h(C, B, i + "", e, t, v) : n, H = U === n;
        if (H) {
          var Y = de(B), ne = !Y && zn(B), se = !Y && !ne && hr(B);
          U = B, Y || ne || se ? de(C) ? U = C : ct(C) ? U = Dt(C) : ne ? (H = !1, U = Kl(B, !0)) : se ? (H = !1, U = ql(B, !0)) : U = [] : Fr(B) || $n(B) ? (U = C, $n(C) ? U = jo(C) : (!rt(C) || yn(C)) && (U = go(B))) : H = !1;
        }
        H && (v.set(B, U), u(U, B, l, h, v), v.delete(B)), Ss(e, i, U);
      }
      function Dl(e, t) {
        var i = e.length;
        if (i)
          return t += t < 0 ? i : 0, Sn(t, i) ? e[t] : n;
      }
      function kl(e, t, i) {
        t.length ? t = et(t, function(h) {
          return de(h) ? function(v) {
            return Jn(v, h.length === 1 ? h[0] : h);
          } : h;
        }) : t = [Ut];
        var l = -1;
        t = et(t, Vt(ie()));
        var u = _l(e, function(h, v, C) {
          var B = et(t, function(F) {
            return F(h);
          });
          return { criteria: B, index: ++l, value: h };
        });
        return Ru(u, function(h, v) {
          return wd(h, v, i);
        });
      }
      function ld(e, t) {
        return Fl(e, t, function(i, l) {
          return ia(e, l);
        });
      }
      function Fl(e, t, i) {
        for (var l = -1, u = t.length, h = {}; ++l < u; ) {
          var v = t[l], C = Jn(e, v);
          i(C, v) && Or(h, Hn(v, e), C);
        }
        return h;
      }
      function od(e) {
        return function(t) {
          return Jn(t, e);
        };
      }
      function Ps(e, t, i, l) {
        var u = l ? Pu : ir, h = -1, v = t.length, C = e;
        for (e === t && (t = Dt(t)), i && (C = et(e, Vt(i))); ++h < v; )
          for (var B = 0, F = t[h], U = i ? i(F) : F; (B = u(C, U, B, l)) > -1; )
            C !== e && oi.call(C, B, 1), oi.call(e, B, 1);
        return e;
      }
      function Ul(e, t) {
        for (var i = e ? t.length : 0, l = i - 1; i--; ) {
          var u = t[i];
          if (i == l || u !== h) {
            var h = u;
            Sn(u) ? oi.call(e, u, 1) : Ns(e, u);
          }
        }
        return e;
      }
      function Rs(e, t) {
        return e + fi(wl() * (t - e + 1));
      }
      function cd(e, t, i, l) {
        for (var u = -1, h = mt(ui((t - e) / (i || 1)), 0), v = R(h); h--; )
          v[l ? h : ++u] = e, e += i;
        return v;
      }
      function _s(e, t) {
        var i = "";
        if (!e || t < 1 || t > Ge)
          return i;
        do
          t % 2 && (i += e), t = fi(t / 2), t && (e += e);
        while (t);
        return i;
      }
      function me(e, t) {
        return Js(mo(e, t, Ut), e + "");
      }
      function ud(e) {
        return Sl(mr(e));
      }
      function fd(e, t) {
        var i = mr(e);
        return Ii(i, Yn(t, 0, i.length));
      }
      function Or(e, t, i, l) {
        if (!rt(e))
          return e;
        t = Hn(t, e);
        for (var u = -1, h = t.length, v = h - 1, C = e; C != null && ++u < h; ) {
          var B = pn(t[u]), F = i;
          if (B === "__proto__" || B === "constructor" || B === "prototype")
            return e;
          if (u != v) {
            var U = C[B];
            F = l ? l(U, B, C) : n, F === n && (F = rt(U) ? U : Sn(t[u + 1]) ? [] : {});
          }
          Mr(C, B, F), C = C[B];
        }
        return e;
      }
      var Gl = di ? function(e, t) {
        return di.set(e, t), e;
      } : Ut, dd = ci ? function(e, t) {
        return ci(e, "toString", {
          configurable: !0,
          enumerable: !1,
          value: aa(t),
          writable: !0
        });
      } : Ut;
      function gd(e) {
        return Ii(mr(e));
      }
      function tn(e, t, i) {
        var l = -1, u = e.length;
        t < 0 && (t = -t > u ? 0 : u + t), i = i > u ? u : i, i < 0 && (i += u), u = t > i ? 0 : i - t >>> 0, t >>>= 0;
        for (var h = R(u); ++l < u; )
          h[l] = e[l + t];
        return h;
      }
      function pd(e, t) {
        var i;
        return Un(e, function(l, u, h) {
          return i = t(l, u, h), !i;
        }), !!i;
      }
      function wi(e, t, i) {
        var l = 0, u = e == null ? l : e.length;
        if (typeof t == "number" && t === t && u <= He) {
          for (; l < u; ) {
            var h = l + u >>> 1, v = e[h];
            v !== null && !Wt(v) && (i ? v <= t : v < t) ? l = h + 1 : u = h;
          }
          return u;
        }
        return Os(e, t, Ut, i);
      }
      function Os(e, t, i, l) {
        var u = 0, h = e == null ? 0 : e.length;
        if (h === 0)
          return 0;
        t = i(t);
        for (var v = t !== t, C = t === null, B = Wt(t), F = t === n; u < h; ) {
          var U = fi((u + h) / 2), H = i(e[U]), Y = H !== n, ne = H === null, se = H === H, he = Wt(H);
          if (v)
            var ae = l || se;
          else F ? ae = se && (l || Y) : C ? ae = se && Y && (l || !ne) : B ? ae = se && Y && !ne && (l || !he) : ne || he ? ae = !1 : ae = l ? H <= t : H < t;
          ae ? u = U + 1 : h = U;
        }
        return Bt(h, je);
      }
      function Hl(e, t) {
        for (var i = -1, l = e.length, u = 0, h = []; ++i < l; ) {
          var v = e[i], C = t ? t(v) : v;
          if (!i || !cn(C, B)) {
            var B = C;
            h[u++] = v === 0 ? 0 : v;
          }
        }
        return h;
      }
      function Vl(e) {
        return typeof e == "number" ? e : Wt(e) ? Be : +e;
      }
      function zt(e) {
        if (typeof e == "string")
          return e;
        if (de(e))
          return et(e, zt) + "";
        if (Wt(e))
          return bl ? bl.call(e) : "";
        var t = e + "";
        return t == "0" && 1 / e == -Ne ? "-0" : t;
      }
      function Gn(e, t, i) {
        var l = -1, u = Zr, h = e.length, v = !0, C = [], B = C;
        if (i)
          v = !1, u = cs;
        else if (h >= c) {
          var F = t ? null : Ed(e);
          if (F)
            return ei(F);
          v = !1, u = Cr, B = new qn();
        } else
          B = t ? [] : C;
        e:
          for (; ++l < h; ) {
            var U = e[l], H = t ? t(U) : U;
            if (U = i || U !== 0 ? U : 0, v && H === H) {
              for (var Y = B.length; Y--; )
                if (B[Y] === H)
                  continue e;
              t && B.push(H), C.push(U);
            } else u(B, H, i) || (B !== C && B.push(H), C.push(U));
          }
        return C;
      }
      function Ns(e, t) {
        return t = Hn(t, e), e = vo(e, t), e == null || delete e[pn(nn(t))];
      }
      function zl(e, t, i, l) {
        return Or(e, t, i(Jn(e, t)), l);
      }
      function bi(e, t, i, l) {
        for (var u = e.length, h = l ? u : -1; (l ? h-- : ++h < u) && t(e[h], h, e); )
          ;
        return i ? tn(e, l ? 0 : h, l ? h + 1 : u) : tn(e, l ? h + 1 : 0, l ? u : h);
      }
      function Wl(e, t) {
        var i = e;
        return i instanceof Se && (i = i.value()), us(t, function(l, u) {
          return u.func.apply(u.thisArg, Dn([l], u.args));
        }, i);
      }
      function Ds(e, t, i) {
        var l = e.length;
        if (l < 2)
          return l ? Gn(e[0]) : [];
        for (var u = -1, h = R(l); ++u < l; )
          for (var v = e[u], C = -1; ++C < l; )
            C != u && (h[u] = Pr(h[u] || v, e[C], t, i));
        return Gn(Et(h, 1), t, i);
      }
      function jl(e, t, i) {
        for (var l = -1, u = e.length, h = t.length, v = {}; ++l < u; ) {
          var C = l < h ? t[l] : n;
          i(v, e[l], C);
        }
        return v;
      }
      function ks(e) {
        return ct(e) ? e : [];
      }
      function Fs(e) {
        return typeof e == "function" ? e : Ut;
      }
      function Hn(e, t) {
        return de(e) ? e : Ks(e, t) ? [e] : xo(ke(e));
      }
      var hd = me;
      function Vn(e, t, i) {
        var l = e.length;
        return i = i === n ? l : i, !t && i >= l ? e : tn(e, t, i);
      }
      var Ql = tf || function(e) {
        return Ct.clearTimeout(e);
      };
      function Kl(e, t) {
        if (t)
          return e.slice();
        var i = e.length, l = pl ? pl(i) : new e.constructor(i);
        return e.copy(l), l;
      }
      function Us(e) {
        var t = new e.constructor(e.byteLength);
        return new ai(t).set(new ai(e)), t;
      }
      function md(e, t) {
        var i = t ? Us(e.buffer) : e.buffer;
        return new e.constructor(i, e.byteOffset, e.byteLength);
      }
      function vd(e) {
        var t = new e.constructor(e.source, Ee.exec(e));
        return t.lastIndex = e.lastIndex, t;
      }
      function Ad(e) {
        return Br ? Ye(Br.call(e)) : {};
      }
      function ql(e, t) {
        var i = t ? Us(e.buffer) : e.buffer;
        return new e.constructor(i, e.byteOffset, e.length);
      }
      function Yl(e, t) {
        if (e !== t) {
          var i = e !== n, l = e === null, u = e === e, h = Wt(e), v = t !== n, C = t === null, B = t === t, F = Wt(t);
          if (!C && !F && !h && e > t || h && v && B && !C && !F || l && v && B || !i && B || !u)
            return 1;
          if (!l && !h && !F && e < t || F && i && u && !l && !h || C && i && u || !v && u || !B)
            return -1;
        }
        return 0;
      }
      function wd(e, t, i) {
        for (var l = -1, u = e.criteria, h = t.criteria, v = u.length, C = i.length; ++l < v; ) {
          var B = Yl(u[l], h[l]);
          if (B) {
            if (l >= C)
              return B;
            var F = i[l];
            return B * (F == "desc" ? -1 : 1);
          }
        }
        return e.index - t.index;
      }
      function Jl(e, t, i, l) {
        for (var u = -1, h = e.length, v = i.length, C = -1, B = t.length, F = mt(h - v, 0), U = R(B + F), H = !l; ++C < B; )
          U[C] = t[C];
        for (; ++u < v; )
          (H || u < h) && (U[i[u]] = e[u]);
        for (; F--; )
          U[C++] = e[u++];
        return U;
      }
      function Xl(e, t, i, l) {
        for (var u = -1, h = e.length, v = -1, C = i.length, B = -1, F = t.length, U = mt(h - C, 0), H = R(U + F), Y = !l; ++u < U; )
          H[u] = e[u];
        for (var ne = u; ++B < F; )
          H[ne + B] = t[B];
        for (; ++v < C; )
          (Y || u < h) && (H[ne + i[v]] = e[u++]);
        return H;
      }
      function Dt(e, t) {
        var i = -1, l = e.length;
        for (t || (t = R(l)); ++i < l; )
          t[i] = e[i];
        return t;
      }
      function gn(e, t, i, l) {
        var u = !i;
        i || (i = {});
        for (var h = -1, v = t.length; ++h < v; ) {
          var C = t[h], B = l ? l(i[C], e[C], C, i, e) : n;
          B === n && (B = e[C]), u ? wn(i, C, B) : Mr(i, C, B);
        }
        return i;
      }
      function bd(e, t) {
        return gn(e, Qs(e), t);
      }
      function xd(e, t) {
        return gn(e, uo(e), t);
      }
      function xi(e, t) {
        return function(i, l) {
          var u = de(i) ? Eu : zf, h = t ? t() : {};
          return u(i, e, ie(l, 2), h);
        };
      }
      function dr(e) {
        return me(function(t, i) {
          var l = -1, u = i.length, h = u > 1 ? i[u - 1] : n, v = u > 2 ? i[2] : n;
          for (h = e.length > 3 && typeof h == "function" ? (u--, h) : n, v && Rt(i[0], i[1], v) && (h = u < 3 ? n : h, u = 1), t = Ye(t); ++l < u; ) {
            var C = i[l];
            C && e(t, C, l, h);
          }
          return t;
        });
      }
      function Zl(e, t) {
        return function(i, l) {
          if (i == null)
            return i;
          if (!kt(i))
            return e(i, l);
          for (var u = i.length, h = t ? u : -1, v = Ye(i); (t ? h-- : ++h < u) && l(v[h], h, v) !== !1; )
            ;
          return i;
        };
      }
      function $l(e) {
        return function(t, i, l) {
          for (var u = -1, h = Ye(t), v = l(t), C = v.length; C--; ) {
            var B = v[e ? C : ++u];
            if (i(h[B], B, h) === !1)
              break;
          }
          return t;
        };
      }
      function Sd(e, t, i) {
        var l = t & G, u = Nr(e);
        function h() {
          var v = this && this !== Ct && this instanceof h ? u : e;
          return v.apply(l ? i : this, arguments);
        }
        return h;
      }
      function eo(e) {
        return function(t) {
          t = ke(t);
          var i = sr(t) ? ln(t) : n, l = i ? i[0] : t.charAt(0), u = i ? Vn(i, 1).join("") : t.slice(1);
          return l[e]() + u;
        };
      }
      function gr(e) {
        return function(t) {
          return us($o(Zo(t).replace(fu, "")), e, "");
        };
      }
      function Nr(e) {
        return function() {
          var t = arguments;
          switch (t.length) {
            case 0:
              return new e();
            case 1:
              return new e(t[0]);
            case 2:
              return new e(t[0], t[1]);
            case 3:
              return new e(t[0], t[1], t[2]);
            case 4:
              return new e(t[0], t[1], t[2], t[3]);
            case 5:
              return new e(t[0], t[1], t[2], t[3], t[4]);
            case 6:
              return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
            case 7:
              return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
          }
          var i = fr(e.prototype), l = e.apply(i, t);
          return rt(l) ? l : i;
        };
      }
      function yd(e, t, i) {
        var l = Nr(e);
        function u() {
          for (var h = arguments.length, v = R(h), C = h, B = pr(u); C--; )
            v[C] = arguments[C];
          var F = h < 3 && v[0] !== B && v[h - 1] !== B ? [] : kn(v, B);
          if (h -= F.length, h < i)
            return so(
              e,
              t,
              Si,
              u.placeholder,
              n,
              v,
              F,
              n,
              n,
              i - h
            );
          var U = this && this !== Ct && this instanceof u ? l : e;
          return Ht(U, this, v);
        }
        return u;
      }
      function to(e) {
        return function(t, i, l) {
          var u = Ye(t);
          if (!kt(t)) {
            var h = ie(i, 3);
            t = wt(t), i = function(C) {
              return h(u[C], C, u);
            };
          }
          var v = e(t, i, l);
          return v > -1 ? u[h ? t[v] : v] : n;
        };
      }
      function no(e) {
        return xn(function(t) {
          var i = t.length, l = i, u = $t.prototype.thru;
          for (e && t.reverse(); l--; ) {
            var h = t[l];
            if (typeof h != "function")
              throw new Zt(d);
            if (u && !v && Ti(h) == "wrapper")
              var v = new $t([], !0);
          }
          for (l = v ? l : i; ++l < i; ) {
            h = t[l];
            var C = Ti(h), B = C == "wrapper" ? Ws(h) : n;
            B && qs(B[0]) && B[1] == (q | T | P | W) && !B[4].length && B[9] == 1 ? v = v[Ti(B[0])].apply(v, B[3]) : v = h.length == 1 && qs(h) ? v[C]() : v.thru(h);
          }
          return function() {
            var F = arguments, U = F[0];
            if (v && F.length == 1 && de(U))
              return v.plant(U).value();
            for (var H = 0, Y = i ? t[H].apply(this, F) : U; ++H < i; )
              Y = t[H].call(this, Y);
            return Y;
          };
        });
      }
      function Si(e, t, i, l, u, h, v, C, B, F) {
        var U = t & q, H = t & G, Y = t & M, ne = t & (T | L), se = t & N, he = Y ? n : Nr(e);
        function ae() {
          for (var Ae = arguments.length, Ce = R(Ae), jt = Ae; jt--; )
            Ce[jt] = arguments[jt];
          if (ne)
            var _t = pr(ae), Qt = Ou(Ce, _t);
          if (l && (Ce = Jl(Ce, l, u, ne)), h && (Ce = Xl(Ce, h, v, ne)), Ae -= Qt, ne && Ae < F) {
            var ut = kn(Ce, _t);
            return so(
              e,
              t,
              Si,
              ae.placeholder,
              i,
              Ce,
              ut,
              C,
              B,
              F - Ae
            );
          }
          var un = H ? i : this, En = Y ? un[e] : e;
          return Ae = Ce.length, C ? Ce = zd(Ce, C) : se && Ae > 1 && Ce.reverse(), U && B < Ae && (Ce.length = B), this && this !== Ct && this instanceof ae && (En = he || Nr(En)), En.apply(un, Ce);
        }
        return ae;
      }
      function ro(e, t) {
        return function(i, l) {
          return Xf(i, e, t(l), {});
        };
      }
      function yi(e, t) {
        return function(i, l) {
          var u;
          if (i === n && l === n)
            return t;
          if (i !== n && (u = i), l !== n) {
            if (u === n)
              return l;
            typeof i == "string" || typeof l == "string" ? (i = zt(i), l = zt(l)) : (i = Vl(i), l = Vl(l)), u = e(i, l);
          }
          return u;
        };
      }
      function Gs(e) {
        return xn(function(t) {
          return t = et(t, Vt(ie())), me(function(i) {
            var l = this;
            return e(t, function(u) {
              return Ht(u, l, i);
            });
          });
        });
      }
      function Ci(e, t) {
        t = t === n ? " " : zt(t);
        var i = t.length;
        if (i < 2)
          return i ? _s(t, e) : t;
        var l = _s(t, ui(e / ar(t)));
        return sr(t) ? Vn(ln(l), 0, e).join("") : l.slice(0, e);
      }
      function Cd(e, t, i, l) {
        var u = t & G, h = Nr(e);
        function v() {
          for (var C = -1, B = arguments.length, F = -1, U = l.length, H = R(U + B), Y = this && this !== Ct && this instanceof v ? h : e; ++F < U; )
            H[F] = l[F];
          for (; B--; )
            H[F++] = arguments[++C];
          return Ht(Y, u ? i : this, H);
        }
        return v;
      }
      function io(e) {
        return function(t, i, l) {
          return l && typeof l != "number" && Rt(t, i, l) && (i = l = n), t = Cn(t), i === n ? (i = t, t = 0) : i = Cn(i), l = l === n ? t < i ? 1 : -1 : Cn(l), cd(t, i, l, e);
        };
      }
      function Ei(e) {
        return function(t, i) {
          return typeof t == "string" && typeof i == "string" || (t = rn(t), i = rn(i)), e(t, i);
        };
      }
      function so(e, t, i, l, u, h, v, C, B, F) {
        var U = t & T, H = U ? v : n, Y = U ? n : v, ne = U ? h : n, se = U ? n : h;
        t |= U ? P : k, t &= ~(U ? k : P), t & E || (t &= ~(G | M));
        var he = [
          e,
          t,
          u,
          ne,
          H,
          se,
          Y,
          C,
          B,
          F
        ], ae = i.apply(n, he);
        return qs(e) && Ao(ae, he), ae.placeholder = l, wo(ae, e, t);
      }
      function Hs(e) {
        var t = ht[e];
        return function(i, l) {
          if (i = rn(i), l = l == null ? 0 : Bt(pe(l), 292), l && Al(i)) {
            var u = (ke(i) + "e").split("e"), h = t(u[0] + "e" + (+u[1] + l));
            return u = (ke(h) + "e").split("e"), +(u[0] + "e" + (+u[1] - l));
          }
          return t(i);
        };
      }
      var Ed = cr && 1 / ei(new cr([, -0]))[1] == Ne ? function(e) {
        return new cr(e);
      } : ca;
      function ao(e) {
        return function(t) {
          var i = Mt(t);
          return i == it ? vs(t) : i == Te ? Hu(t) : _u(t, e(t));
        };
      }
      function bn(e, t, i, l, u, h, v, C) {
        var B = t & M;
        if (!B && typeof e != "function")
          throw new Zt(d);
        var F = l ? l.length : 0;
        if (F || (t &= ~(P | k), l = u = n), v = v === n ? v : mt(pe(v), 0), C = C === n ? C : pe(C), F -= u ? u.length : 0, t & k) {
          var U = l, H = u;
          l = u = n;
        }
        var Y = B ? n : Ws(e), ne = [
          e,
          t,
          i,
          l,
          u,
          U,
          H,
          h,
          v,
          C
        ];
        if (Y && Gd(ne, Y), e = ne[0], t = ne[1], i = ne[2], l = ne[3], u = ne[4], C = ne[9] = ne[9] === n ? B ? 0 : e.length : mt(ne[9] - F, 0), !C && t & (T | L) && (t &= ~(T | L)), !t || t == G)
          var se = Sd(e, t, i);
        else t == T || t == L ? se = yd(e, t, C) : (t == P || t == (G | P)) && !u.length ? se = Cd(e, t, i, l) : se = Si.apply(n, ne);
        var he = Y ? Gl : Ao;
        return wo(he(se, ne), e, t);
      }
      function lo(e, t, i, l) {
        return e === n || cn(e, or[i]) && !Ue.call(l, i) ? t : e;
      }
      function oo(e, t, i, l, u, h) {
        return rt(e) && rt(t) && (h.set(t, e), Ai(e, t, n, oo, h), h.delete(t)), e;
      }
      function Td(e) {
        return Fr(e) ? n : e;
      }
      function co(e, t, i, l, u, h) {
        var v = i & _, C = e.length, B = t.length;
        if (C != B && !(v && B > C))
          return !1;
        var F = h.get(e), U = h.get(t);
        if (F && U)
          return F == t && U == e;
        var H = -1, Y = !0, ne = i & O ? new qn() : n;
        for (h.set(e, t), h.set(t, e); ++H < C; ) {
          var se = e[H], he = t[H];
          if (l)
            var ae = v ? l(he, se, H, t, e, h) : l(se, he, H, e, t, h);
          if (ae !== n) {
            if (ae)
              continue;
            Y = !1;
            break;
          }
          if (ne) {
            if (!fs(t, function(Ae, Ce) {
              if (!Cr(ne, Ce) && (se === Ae || u(se, Ae, i, l, h)))
                return ne.push(Ce);
            })) {
              Y = !1;
              break;
            }
          } else if (!(se === he || u(se, he, i, l, h))) {
            Y = !1;
            break;
          }
        }
        return h.delete(e), h.delete(t), Y;
      }
      function Ld(e, t, i, l, u, h, v) {
        switch (i) {
          case xt:
            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
              return !1;
            e = e.buffer, t = t.buffer;
          case st:
            return !(e.byteLength != t.byteLength || !h(new ai(e), new ai(t)));
          case Ke:
          case ce:
          case pt:
            return cn(+e, +t);
          case dt:
            return e.name == t.name && e.message == t.message;
          case ge:
          case we:
            return e == t + "";
          case it:
            var C = vs;
          case Te:
            var B = l & _;
            if (C || (C = ei), e.size != t.size && !B)
              return !1;
            var F = v.get(e);
            if (F)
              return F == t;
            l |= O, v.set(e, t);
            var U = co(C(e), C(t), l, u, h, v);
            return v.delete(e), U;
          case ze:
            if (Br)
              return Br.call(e) == Br.call(t);
        }
        return !1;
      }
      function Id(e, t, i, l, u, h) {
        var v = i & _, C = Vs(e), B = C.length, F = Vs(t), U = F.length;
        if (B != U && !v)
          return !1;
        for (var H = B; H--; ) {
          var Y = C[H];
          if (!(v ? Y in t : Ue.call(t, Y)))
            return !1;
        }
        var ne = h.get(e), se = h.get(t);
        if (ne && se)
          return ne == t && se == e;
        var he = !0;
        h.set(e, t), h.set(t, e);
        for (var ae = v; ++H < B; ) {
          Y = C[H];
          var Ae = e[Y], Ce = t[Y];
          if (l)
            var jt = v ? l(Ce, Ae, Y, t, e, h) : l(Ae, Ce, Y, e, t, h);
          if (!(jt === n ? Ae === Ce || u(Ae, Ce, i, l, h) : jt)) {
            he = !1;
            break;
          }
          ae || (ae = Y == "constructor");
        }
        if (he && !ae) {
          var _t = e.constructor, Qt = t.constructor;
          _t != Qt && "constructor" in e && "constructor" in t && !(typeof _t == "function" && _t instanceof _t && typeof Qt == "function" && Qt instanceof Qt) && (he = !1);
        }
        return h.delete(e), h.delete(t), he;
      }
      function xn(e) {
        return Js(mo(e, n, Eo), e + "");
      }
      function Vs(e) {
        return Bl(e, wt, Qs);
      }
      function zs(e) {
        return Bl(e, Ft, uo);
      }
      var Ws = di ? function(e) {
        return di.get(e);
      } : ca;
      function Ti(e) {
        for (var t = e.name + "", i = ur[t], l = Ue.call(ur, t) ? i.length : 0; l--; ) {
          var u = i[l], h = u.func;
          if (h == null || h == e)
            return u.name;
        }
        return t;
      }
      function pr(e) {
        var t = Ue.call(g, "placeholder") ? g : e;
        return t.placeholder;
      }
      function ie() {
        var e = g.iteratee || la;
        return e = e === la ? Rl : e, arguments.length ? e(arguments[0], arguments[1]) : e;
      }
      function Li(e, t) {
        var i = e.__data__;
        return Dd(t) ? i[typeof t == "string" ? "string" : "hash"] : i.map;
      }
      function js(e) {
        for (var t = wt(e), i = t.length; i--; ) {
          var l = t[i], u = e[l];
          t[i] = [l, u, po(u)];
        }
        return t;
      }
      function Xn(e, t) {
        var i = Fu(e, t);
        return Pl(i) ? i : n;
      }
      function Bd(e) {
        var t = Ue.call(e, Qn), i = e[Qn];
        try {
          e[Qn] = n;
          var l = !0;
        } catch {
        }
        var u = ii.call(e);
        return l && (t ? e[Qn] = i : delete e[Qn]), u;
      }
      var Qs = ws ? function(e) {
        return e == null ? [] : (e = Ye(e), Nn(ws(e), function(t) {
          return ml.call(e, t);
        }));
      } : ua, uo = ws ? function(e) {
        for (var t = []; e; )
          Dn(t, Qs(e)), e = li(e);
        return t;
      } : ua, Mt = Pt;
      (bs && Mt(new bs(new ArrayBuffer(1))) != xt || Tr && Mt(new Tr()) != it || xs && Mt(xs.resolve()) != Q || cr && Mt(new cr()) != Te || Lr && Mt(new Lr()) != Le) && (Mt = function(e) {
        var t = Pt(e), i = t == ot ? e.constructor : n, l = i ? Zn(i) : "";
        if (l)
          switch (l) {
            case ff:
              return xt;
            case df:
              return it;
            case gf:
              return Q;
            case pf:
              return Te;
            case hf:
              return Le;
          }
        return t;
      });
      function Md(e, t, i) {
        for (var l = -1, u = i.length; ++l < u; ) {
          var h = i[l], v = h.size;
          switch (h.type) {
            case "drop":
              e += v;
              break;
            case "dropRight":
              t -= v;
              break;
            case "take":
              t = Bt(t, e + v);
              break;
            case "takeRight":
              e = mt(e, t - v);
              break;
          }
        }
        return { start: e, end: t };
      }
      function Pd(e) {
        var t = e.match($i);
        return t ? t[1].split(es) : [];
      }
      function fo(e, t, i) {
        t = Hn(t, e);
        for (var l = -1, u = t.length, h = !1; ++l < u; ) {
          var v = pn(t[l]);
          if (!(h = e != null && i(e, v)))
            break;
          e = e[v];
        }
        return h || ++l != u ? h : (u = e == null ? 0 : e.length, !!u && Oi(u) && Sn(v, u) && (de(e) || $n(e)));
      }
      function Rd(e) {
        var t = e.length, i = new e.constructor(t);
        return t && typeof e[0] == "string" && Ue.call(e, "index") && (i.index = e.index, i.input = e.input), i;
      }
      function go(e) {
        return typeof e.constructor == "function" && !Dr(e) ? fr(li(e)) : {};
      }
      function _d(e, t, i) {
        var l = e.constructor;
        switch (t) {
          case st:
            return Us(e);
          case Ke:
          case ce:
            return new l(+e);
          case xt:
            return md(e, i);
          case Lt:
          case mn:
          case fn:
          case In:
          case Bn:
          case Mn:
          case Pn:
          case $:
          case le:
            return ql(e, i);
          case it:
            return new l();
          case pt:
          case we:
            return new l(e);
          case ge:
            return vd(e);
          case Te:
            return new l();
          case ze:
            return Ad(e);
        }
      }
      function Od(e, t) {
        var i = t.length;
        if (!i)
          return e;
        var l = i - 1;
        return t[l] = (i > 1 ? "& " : "") + t[l], t = t.join(i > 2 ? ", " : " "), e.replace(Zi, `{
/* [wrapped with ` + t + `] */
`);
      }
      function Nd(e) {
        return de(e) || $n(e) || !!(vl && e && e[vl]);
      }
      function Sn(e, t) {
        var i = typeof e;
        return t = t ?? Ge, !!t && (i == "number" || i != "symbol" && nt.test(e)) && e > -1 && e % 1 == 0 && e < t;
      }
      function Rt(e, t, i) {
        if (!rt(i))
          return !1;
        var l = typeof t;
        return (l == "number" ? kt(i) && Sn(t, i.length) : l == "string" && t in i) ? cn(i[t], e) : !1;
      }
      function Ks(e, t) {
        if (de(e))
          return !1;
        var i = typeof e;
        return i == "number" || i == "symbol" || i == "boolean" || e == null || Wt(e) ? !0 : qr.test(e) || !Kr.test(e) || t != null && e in Ye(t);
      }
      function Dd(e) {
        var t = typeof e;
        return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
      }
      function qs(e) {
        var t = Ti(e), i = g[t];
        if (typeof i != "function" || !(t in Se.prototype))
          return !1;
        if (e === i)
          return !0;
        var l = Ws(i);
        return !!l && e === l[0];
      }
      function kd(e) {
        return !!gl && gl in e;
      }
      var Fd = ni ? yn : fa;
      function Dr(e) {
        var t = e && e.constructor, i = typeof t == "function" && t.prototype || or;
        return e === i;
      }
      function po(e) {
        return e === e && !rt(e);
      }
      function ho(e, t) {
        return function(i) {
          return i == null ? !1 : i[e] === t && (t !== n || e in Ye(i));
        };
      }
      function Ud(e) {
        var t = Ri(e, function(l) {
          return i.size === b && i.clear(), l;
        }), i = t.cache;
        return t;
      }
      function Gd(e, t) {
        var i = e[1], l = t[1], u = i | l, h = u < (G | M | q), v = l == q && i == T || l == q && i == W && e[7].length <= t[8] || l == (q | W) && t[7].length <= t[8] && i == T;
        if (!(h || v))
          return e;
        l & G && (e[2] = t[2], u |= i & G ? 0 : E);
        var C = t[3];
        if (C) {
          var B = e[3];
          e[3] = B ? Jl(B, C, t[4]) : C, e[4] = B ? kn(e[3], m) : t[4];
        }
        return C = t[5], C && (B = e[5], e[5] = B ? Xl(B, C, t[6]) : C, e[6] = B ? kn(e[5], m) : t[6]), C = t[7], C && (e[7] = C), l & q && (e[8] = e[8] == null ? t[8] : Bt(e[8], t[8])), e[9] == null && (e[9] = t[9]), e[0] = t[0], e[1] = u, e;
      }
      function Hd(e) {
        var t = [];
        if (e != null)
          for (var i in Ye(e))
            t.push(i);
        return t;
      }
      function Vd(e) {
        return ii.call(e);
      }
      function mo(e, t, i) {
        return t = mt(t === n ? e.length - 1 : t, 0), function() {
          for (var l = arguments, u = -1, h = mt(l.length - t, 0), v = R(h); ++u < h; )
            v[u] = l[t + u];
          u = -1;
          for (var C = R(t + 1); ++u < t; )
            C[u] = l[u];
          return C[t] = i(v), Ht(e, this, C);
        };
      }
      function vo(e, t) {
        return t.length < 2 ? e : Jn(e, tn(t, 0, -1));
      }
      function zd(e, t) {
        for (var i = e.length, l = Bt(t.length, i), u = Dt(e); l--; ) {
          var h = t[l];
          e[l] = Sn(h, i) ? u[h] : n;
        }
        return e;
      }
      function Ys(e, t) {
        if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
          return e[t];
      }
      var Ao = bo(Gl), kr = rf || function(e, t) {
        return Ct.setTimeout(e, t);
      }, Js = bo(dd);
      function wo(e, t, i) {
        var l = t + "";
        return Js(e, Od(l, Wd(Pd(l), i)));
      }
      function bo(e) {
        var t = 0, i = 0;
        return function() {
          var l = of(), u = j - (l - i);
          if (i = l, u > 0) {
            if (++t >= Z)
              return arguments[0];
          } else
            t = 0;
          return e.apply(n, arguments);
        };
      }
      function Ii(e, t) {
        var i = -1, l = e.length, u = l - 1;
        for (t = t === n ? l : t; ++i < t; ) {
          var h = Rs(i, u), v = e[h];
          e[h] = e[i], e[i] = v;
        }
        return e.length = t, e;
      }
      var xo = Ud(function(e) {
        var t = [];
        return e.charCodeAt(0) === 46 && t.push(""), e.replace(Ji, function(i, l, u, h) {
          t.push(u ? h.replace(J, "$1") : l || i);
        }), t;
      });
      function pn(e) {
        if (typeof e == "string" || Wt(e))
          return e;
        var t = e + "";
        return t == "0" && 1 / e == -Ne ? "-0" : t;
      }
      function Zn(e) {
        if (e != null) {
          try {
            return ri.call(e);
          } catch {
          }
          try {
            return e + "";
          } catch {
          }
        }
        return "";
      }
      function Wd(e, t) {
        return Xt(sn, function(i) {
          var l = "_." + i[0];
          t & i[1] && !Zr(e, l) && e.push(l);
        }), e.sort();
      }
      function So(e) {
        if (e instanceof Se)
          return e.clone();
        var t = new $t(e.__wrapped__, e.__chain__);
        return t.__actions__ = Dt(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
      }
      function jd(e, t, i) {
        (i ? Rt(e, t, i) : t === n) ? t = 1 : t = mt(pe(t), 0);
        var l = e == null ? 0 : e.length;
        if (!l || t < 1)
          return [];
        for (var u = 0, h = 0, v = R(ui(l / t)); u < l; )
          v[h++] = tn(e, u, u += t);
        return v;
      }
      function Qd(e) {
        for (var t = -1, i = e == null ? 0 : e.length, l = 0, u = []; ++t < i; ) {
          var h = e[t];
          h && (u[l++] = h);
        }
        return u;
      }
      function Kd() {
        var e = arguments.length;
        if (!e)
          return [];
        for (var t = R(e - 1), i = arguments[0], l = e; l--; )
          t[l - 1] = arguments[l];
        return Dn(de(i) ? Dt(i) : [i], Et(t, 1));
      }
      var qd = me(function(e, t) {
        return ct(e) ? Pr(e, Et(t, 1, ct, !0)) : [];
      }), Yd = me(function(e, t) {
        var i = nn(t);
        return ct(i) && (i = n), ct(e) ? Pr(e, Et(t, 1, ct, !0), ie(i, 2)) : [];
      }), Jd = me(function(e, t) {
        var i = nn(t);
        return ct(i) && (i = n), ct(e) ? Pr(e, Et(t, 1, ct, !0), n, i) : [];
      });
      function Xd(e, t, i) {
        var l = e == null ? 0 : e.length;
        return l ? (t = i || t === n ? 1 : pe(t), tn(e, t < 0 ? 0 : t, l)) : [];
      }
      function Zd(e, t, i) {
        var l = e == null ? 0 : e.length;
        return l ? (t = i || t === n ? 1 : pe(t), t = l - t, tn(e, 0, t < 0 ? 0 : t)) : [];
      }
      function $d(e, t) {
        return e && e.length ? bi(e, ie(t, 3), !0, !0) : [];
      }
      function eg(e, t) {
        return e && e.length ? bi(e, ie(t, 3), !0) : [];
      }
      function tg(e, t, i, l) {
        var u = e == null ? 0 : e.length;
        return u ? (i && typeof i != "number" && Rt(e, t, i) && (i = 0, l = u), Kf(e, t, i, l)) : [];
      }
      function yo(e, t, i) {
        var l = e == null ? 0 : e.length;
        if (!l)
          return -1;
        var u = i == null ? 0 : pe(i);
        return u < 0 && (u = mt(l + u, 0)), $r(e, ie(t, 3), u);
      }
      function Co(e, t, i) {
        var l = e == null ? 0 : e.length;
        if (!l)
          return -1;
        var u = l - 1;
        return i !== n && (u = pe(i), u = i < 0 ? mt(l + u, 0) : Bt(u, l - 1)), $r(e, ie(t, 3), u, !0);
      }
      function Eo(e) {
        var t = e == null ? 0 : e.length;
        return t ? Et(e, 1) : [];
      }
      function ng(e) {
        var t = e == null ? 0 : e.length;
        return t ? Et(e, Ne) : [];
      }
      function rg(e, t) {
        var i = e == null ? 0 : e.length;
        return i ? (t = t === n ? 1 : pe(t), Et(e, t)) : [];
      }
      function ig(e) {
        for (var t = -1, i = e == null ? 0 : e.length, l = {}; ++t < i; ) {
          var u = e[t];
          l[u[0]] = u[1];
        }
        return l;
      }
      function To(e) {
        return e && e.length ? e[0] : n;
      }
      function sg(e, t, i) {
        var l = e == null ? 0 : e.length;
        if (!l)
          return -1;
        var u = i == null ? 0 : pe(i);
        return u < 0 && (u = mt(l + u, 0)), ir(e, t, u);
      }
      function ag(e) {
        var t = e == null ? 0 : e.length;
        return t ? tn(e, 0, -1) : [];
      }
      var lg = me(function(e) {
        var t = et(e, ks);
        return t.length && t[0] === e[0] ? Ls(t) : [];
      }), og = me(function(e) {
        var t = nn(e), i = et(e, ks);
        return t === nn(i) ? t = n : i.pop(), i.length && i[0] === e[0] ? Ls(i, ie(t, 2)) : [];
      }), cg = me(function(e) {
        var t = nn(e), i = et(e, ks);
        return t = typeof t == "function" ? t : n, t && i.pop(), i.length && i[0] === e[0] ? Ls(i, n, t) : [];
      });
      function ug(e, t) {
        return e == null ? "" : af.call(e, t);
      }
      function nn(e) {
        var t = e == null ? 0 : e.length;
        return t ? e[t - 1] : n;
      }
      function fg(e, t, i) {
        var l = e == null ? 0 : e.length;
        if (!l)
          return -1;
        var u = l;
        return i !== n && (u = pe(i), u = u < 0 ? mt(l + u, 0) : Bt(u, l - 1)), t === t ? zu(e, t, u) : $r(e, sl, u, !0);
      }
      function dg(e, t) {
        return e && e.length ? Dl(e, pe(t)) : n;
      }
      var gg = me(Lo);
      function Lo(e, t) {
        return e && e.length && t && t.length ? Ps(e, t) : e;
      }
      function pg(e, t, i) {
        return e && e.length && t && t.length ? Ps(e, t, ie(i, 2)) : e;
      }
      function hg(e, t, i) {
        return e && e.length && t && t.length ? Ps(e, t, n, i) : e;
      }
      var mg = xn(function(e, t) {
        var i = e == null ? 0 : e.length, l = ys(e, t);
        return Ul(e, et(t, function(u) {
          return Sn(u, i) ? +u : u;
        }).sort(Yl)), l;
      });
      function vg(e, t) {
        var i = [];
        if (!(e && e.length))
          return i;
        var l = -1, u = [], h = e.length;
        for (t = ie(t, 3); ++l < h; ) {
          var v = e[l];
          t(v, l, e) && (i.push(v), u.push(l));
        }
        return Ul(e, u), i;
      }
      function Xs(e) {
        return e == null ? e : uf.call(e);
      }
      function Ag(e, t, i) {
        var l = e == null ? 0 : e.length;
        return l ? (i && typeof i != "number" && Rt(e, t, i) ? (t = 0, i = l) : (t = t == null ? 0 : pe(t), i = i === n ? l : pe(i)), tn(e, t, i)) : [];
      }
      function wg(e, t) {
        return wi(e, t);
      }
      function bg(e, t, i) {
        return Os(e, t, ie(i, 2));
      }
      function xg(e, t) {
        var i = e == null ? 0 : e.length;
        if (i) {
          var l = wi(e, t);
          if (l < i && cn(e[l], t))
            return l;
        }
        return -1;
      }
      function Sg(e, t) {
        return wi(e, t, !0);
      }
      function yg(e, t, i) {
        return Os(e, t, ie(i, 2), !0);
      }
      function Cg(e, t) {
        var i = e == null ? 0 : e.length;
        if (i) {
          var l = wi(e, t, !0) - 1;
          if (cn(e[l], t))
            return l;
        }
        return -1;
      }
      function Eg(e) {
        return e && e.length ? Hl(e) : [];
      }
      function Tg(e, t) {
        return e && e.length ? Hl(e, ie(t, 2)) : [];
      }
      function Lg(e) {
        var t = e == null ? 0 : e.length;
        return t ? tn(e, 1, t) : [];
      }
      function Ig(e, t, i) {
        return e && e.length ? (t = i || t === n ? 1 : pe(t), tn(e, 0, t < 0 ? 0 : t)) : [];
      }
      function Bg(e, t, i) {
        var l = e == null ? 0 : e.length;
        return l ? (t = i || t === n ? 1 : pe(t), t = l - t, tn(e, t < 0 ? 0 : t, l)) : [];
      }
      function Mg(e, t) {
        return e && e.length ? bi(e, ie(t, 3), !1, !0) : [];
      }
      function Pg(e, t) {
        return e && e.length ? bi(e, ie(t, 3)) : [];
      }
      var Rg = me(function(e) {
        return Gn(Et(e, 1, ct, !0));
      }), _g = me(function(e) {
        var t = nn(e);
        return ct(t) && (t = n), Gn(Et(e, 1, ct, !0), ie(t, 2));
      }), Og = me(function(e) {
        var t = nn(e);
        return t = typeof t == "function" ? t : n, Gn(Et(e, 1, ct, !0), n, t);
      });
      function Ng(e) {
        return e && e.length ? Gn(e) : [];
      }
      function Dg(e, t) {
        return e && e.length ? Gn(e, ie(t, 2)) : [];
      }
      function kg(e, t) {
        return t = typeof t == "function" ? t : n, e && e.length ? Gn(e, n, t) : [];
      }
      function Zs(e) {
        if (!(e && e.length))
          return [];
        var t = 0;
        return e = Nn(e, function(i) {
          if (ct(i))
            return t = mt(i.length, t), !0;
        }), hs(t, function(i) {
          return et(e, ds(i));
        });
      }
      function Io(e, t) {
        if (!(e && e.length))
          return [];
        var i = Zs(e);
        return t == null ? i : et(i, function(l) {
          return Ht(t, n, l);
        });
      }
      var Fg = me(function(e, t) {
        return ct(e) ? Pr(e, t) : [];
      }), Ug = me(function(e) {
        return Ds(Nn(e, ct));
      }), Gg = me(function(e) {
        var t = nn(e);
        return ct(t) && (t = n), Ds(Nn(e, ct), ie(t, 2));
      }), Hg = me(function(e) {
        var t = nn(e);
        return t = typeof t == "function" ? t : n, Ds(Nn(e, ct), n, t);
      }), Vg = me(Zs);
      function zg(e, t) {
        return jl(e || [], t || [], Mr);
      }
      function Wg(e, t) {
        return jl(e || [], t || [], Or);
      }
      var jg = me(function(e) {
        var t = e.length, i = t > 1 ? e[t - 1] : n;
        return i = typeof i == "function" ? (e.pop(), i) : n, Io(e, i);
      });
      function Bo(e) {
        var t = g(e);
        return t.__chain__ = !0, t;
      }
      function Qg(e, t) {
        return t(e), e;
      }
      function Bi(e, t) {
        return t(e);
      }
      var Kg = xn(function(e) {
        var t = e.length, i = t ? e[0] : 0, l = this.__wrapped__, u = function(h) {
          return ys(h, e);
        };
        return t > 1 || this.__actions__.length || !(l instanceof Se) || !Sn(i) ? this.thru(u) : (l = l.slice(i, +i + (t ? 1 : 0)), l.__actions__.push({
          func: Bi,
          args: [u],
          thisArg: n
        }), new $t(l, this.__chain__).thru(function(h) {
          return t && !h.length && h.push(n), h;
        }));
      });
      function qg() {
        return Bo(this);
      }
      function Yg() {
        return new $t(this.value(), this.__chain__);
      }
      function Jg() {
        this.__values__ === n && (this.__values__ = zo(this.value()));
        var e = this.__index__ >= this.__values__.length, t = e ? n : this.__values__[this.__index__++];
        return { done: e, value: t };
      }
      function Xg() {
        return this;
      }
      function Zg(e) {
        for (var t, i = this; i instanceof pi; ) {
          var l = So(i);
          l.__index__ = 0, l.__values__ = n, t ? u.__wrapped__ = l : t = l;
          var u = l;
          i = i.__wrapped__;
        }
        return u.__wrapped__ = e, t;
      }
      function $g() {
        var e = this.__wrapped__;
        if (e instanceof Se) {
          var t = e;
          return this.__actions__.length && (t = new Se(this)), t = t.reverse(), t.__actions__.push({
            func: Bi,
            args: [Xs],
            thisArg: n
          }), new $t(t, this.__chain__);
        }
        return this.thru(Xs);
      }
      function ep() {
        return Wl(this.__wrapped__, this.__actions__);
      }
      var tp = xi(function(e, t, i) {
        Ue.call(e, i) ? ++e[i] : wn(e, i, 1);
      });
      function np(e, t, i) {
        var l = de(e) ? rl : Qf;
        return i && Rt(e, t, i) && (t = n), l(e, ie(t, 3));
      }
      function rp(e, t) {
        var i = de(e) ? Nn : Ll;
        return i(e, ie(t, 3));
      }
      var ip = to(yo), sp = to(Co);
      function ap(e, t) {
        return Et(Mi(e, t), 1);
      }
      function lp(e, t) {
        return Et(Mi(e, t), Ne);
      }
      function op(e, t, i) {
        return i = i === n ? 1 : pe(i), Et(Mi(e, t), i);
      }
      function Mo(e, t) {
        var i = de(e) ? Xt : Un;
        return i(e, ie(t, 3));
      }
      function Po(e, t) {
        var i = de(e) ? Tu : Tl;
        return i(e, ie(t, 3));
      }
      var cp = xi(function(e, t, i) {
        Ue.call(e, i) ? e[i].push(t) : wn(e, i, [t]);
      });
      function up(e, t, i, l) {
        e = kt(e) ? e : mr(e), i = i && !l ? pe(i) : 0;
        var u = e.length;
        return i < 0 && (i = mt(u + i, 0)), Ni(e) ? i <= u && e.indexOf(t, i) > -1 : !!u && ir(e, t, i) > -1;
      }
      var fp = me(function(e, t, i) {
        var l = -1, u = typeof t == "function", h = kt(e) ? R(e.length) : [];
        return Un(e, function(v) {
          h[++l] = u ? Ht(t, v, i) : Rr(v, t, i);
        }), h;
      }), dp = xi(function(e, t, i) {
        wn(e, i, t);
      });
      function Mi(e, t) {
        var i = de(e) ? et : _l;
        return i(e, ie(t, 3));
      }
      function gp(e, t, i, l) {
        return e == null ? [] : (de(t) || (t = t == null ? [] : [t]), i = l ? n : i, de(i) || (i = i == null ? [] : [i]), kl(e, t, i));
      }
      var pp = xi(function(e, t, i) {
        e[i ? 0 : 1].push(t);
      }, function() {
        return [[], []];
      });
      function hp(e, t, i) {
        var l = de(e) ? us : ll, u = arguments.length < 3;
        return l(e, ie(t, 4), i, u, Un);
      }
      function mp(e, t, i) {
        var l = de(e) ? Lu : ll, u = arguments.length < 3;
        return l(e, ie(t, 4), i, u, Tl);
      }
      function vp(e, t) {
        var i = de(e) ? Nn : Ll;
        return i(e, _i(ie(t, 3)));
      }
      function Ap(e) {
        var t = de(e) ? Sl : ud;
        return t(e);
      }
      function wp(e, t, i) {
        (i ? Rt(e, t, i) : t === n) ? t = 1 : t = pe(t);
        var l = de(e) ? Hf : fd;
        return l(e, t);
      }
      function bp(e) {
        var t = de(e) ? Vf : gd;
        return t(e);
      }
      function xp(e) {
        if (e == null)
          return 0;
        if (kt(e))
          return Ni(e) ? ar(e) : e.length;
        var t = Mt(e);
        return t == it || t == Te ? e.size : Bs(e).length;
      }
      function Sp(e, t, i) {
        var l = de(e) ? fs : pd;
        return i && Rt(e, t, i) && (t = n), l(e, ie(t, 3));
      }
      var yp = me(function(e, t) {
        if (e == null)
          return [];
        var i = t.length;
        return i > 1 && Rt(e, t[0], t[1]) ? t = [] : i > 2 && Rt(t[0], t[1], t[2]) && (t = [t[0]]), kl(e, Et(t, 1), []);
      }), Pi = nf || function() {
        return Ct.Date.now();
      };
      function Cp(e, t) {
        if (typeof t != "function")
          throw new Zt(d);
        return e = pe(e), function() {
          if (--e < 1)
            return t.apply(this, arguments);
        };
      }
      function Ro(e, t, i) {
        return t = i ? n : t, t = e && t == null ? e.length : t, bn(e, q, n, n, n, n, t);
      }
      function _o(e, t) {
        var i;
        if (typeof t != "function")
          throw new Zt(d);
        return e = pe(e), function() {
          return --e > 0 && (i = t.apply(this, arguments)), e <= 1 && (t = n), i;
        };
      }
      var $s = me(function(e, t, i) {
        var l = G;
        if (i.length) {
          var u = kn(i, pr($s));
          l |= P;
        }
        return bn(e, l, t, i, u);
      }), Oo = me(function(e, t, i) {
        var l = G | M;
        if (i.length) {
          var u = kn(i, pr(Oo));
          l |= P;
        }
        return bn(t, l, e, i, u);
      });
      function No(e, t, i) {
        t = i ? n : t;
        var l = bn(e, T, n, n, n, n, n, t);
        return l.placeholder = No.placeholder, l;
      }
      function Do(e, t, i) {
        t = i ? n : t;
        var l = bn(e, L, n, n, n, n, n, t);
        return l.placeholder = Do.placeholder, l;
      }
      function ko(e, t, i) {
        var l, u, h, v, C, B, F = 0, U = !1, H = !1, Y = !0;
        if (typeof e != "function")
          throw new Zt(d);
        t = rn(t) || 0, rt(i) && (U = !!i.leading, H = "maxWait" in i, h = H ? mt(rn(i.maxWait) || 0, t) : h, Y = "trailing" in i ? !!i.trailing : Y);
        function ne(ut) {
          var un = l, En = u;
          return l = u = n, F = ut, v = e.apply(En, un), v;
        }
        function se(ut) {
          return F = ut, C = kr(Ae, t), U ? ne(ut) : v;
        }
        function he(ut) {
          var un = ut - B, En = ut - F, nc = t - un;
          return H ? Bt(nc, h - En) : nc;
        }
        function ae(ut) {
          var un = ut - B, En = ut - F;
          return B === n || un >= t || un < 0 || H && En >= h;
        }
        function Ae() {
          var ut = Pi();
          if (ae(ut))
            return Ce(ut);
          C = kr(Ae, he(ut));
        }
        function Ce(ut) {
          return C = n, Y && l ? ne(ut) : (l = u = n, v);
        }
        function jt() {
          C !== n && Ql(C), F = 0, l = B = u = C = n;
        }
        function _t() {
          return C === n ? v : Ce(Pi());
        }
        function Qt() {
          var ut = Pi(), un = ae(ut);
          if (l = arguments, u = this, B = ut, un) {
            if (C === n)
              return se(B);
            if (H)
              return Ql(C), C = kr(Ae, t), ne(B);
          }
          return C === n && (C = kr(Ae, t)), v;
        }
        return Qt.cancel = jt, Qt.flush = _t, Qt;
      }
      var Ep = me(function(e, t) {
        return El(e, 1, t);
      }), Tp = me(function(e, t, i) {
        return El(e, rn(t) || 0, i);
      });
      function Lp(e) {
        return bn(e, N);
      }
      function Ri(e, t) {
        if (typeof e != "function" || t != null && typeof t != "function")
          throw new Zt(d);
        var i = function() {
          var l = arguments, u = t ? t.apply(this, l) : l[0], h = i.cache;
          if (h.has(u))
            return h.get(u);
          var v = e.apply(this, l);
          return i.cache = h.set(u, v) || h, v;
        };
        return i.cache = new (Ri.Cache || An)(), i;
      }
      Ri.Cache = An;
      function _i(e) {
        if (typeof e != "function")
          throw new Zt(d);
        return function() {
          var t = arguments;
          switch (t.length) {
            case 0:
              return !e.call(this);
            case 1:
              return !e.call(this, t[0]);
            case 2:
              return !e.call(this, t[0], t[1]);
            case 3:
              return !e.call(this, t[0], t[1], t[2]);
          }
          return !e.apply(this, t);
        };
      }
      function Ip(e) {
        return _o(2, e);
      }
      var Bp = hd(function(e, t) {
        t = t.length == 1 && de(t[0]) ? et(t[0], Vt(ie())) : et(Et(t, 1), Vt(ie()));
        var i = t.length;
        return me(function(l) {
          for (var u = -1, h = Bt(l.length, i); ++u < h; )
            l[u] = t[u].call(this, l[u]);
          return Ht(e, this, l);
        });
      }), ea = me(function(e, t) {
        var i = kn(t, pr(ea));
        return bn(e, P, n, t, i);
      }), Fo = me(function(e, t) {
        var i = kn(t, pr(Fo));
        return bn(e, k, n, t, i);
      }), Mp = xn(function(e, t) {
        return bn(e, W, n, n, n, t);
      });
      function Pp(e, t) {
        if (typeof e != "function")
          throw new Zt(d);
        return t = t === n ? t : pe(t), me(e, t);
      }
      function Rp(e, t) {
        if (typeof e != "function")
          throw new Zt(d);
        return t = t == null ? 0 : mt(pe(t), 0), me(function(i) {
          var l = i[t], u = Vn(i, 0, t);
          return l && Dn(u, l), Ht(e, this, u);
        });
      }
      function _p(e, t, i) {
        var l = !0, u = !0;
        if (typeof e != "function")
          throw new Zt(d);
        return rt(i) && (l = "leading" in i ? !!i.leading : l, u = "trailing" in i ? !!i.trailing : u), ko(e, t, {
          leading: l,
          maxWait: t,
          trailing: u
        });
      }
      function Op(e) {
        return Ro(e, 1);
      }
      function Np(e, t) {
        return ea(Fs(t), e);
      }
      function Dp() {
        if (!arguments.length)
          return [];
        var e = arguments[0];
        return de(e) ? e : [e];
      }
      function kp(e) {
        return en(e, y);
      }
      function Fp(e, t) {
        return t = typeof t == "function" ? t : n, en(e, y, t);
      }
      function Up(e) {
        return en(e, S | y);
      }
      function Gp(e, t) {
        return t = typeof t == "function" ? t : n, en(e, S | y, t);
      }
      function Hp(e, t) {
        return t == null || Cl(e, t, wt(t));
      }
      function cn(e, t) {
        return e === t || e !== e && t !== t;
      }
      var Vp = Ei(Ts), zp = Ei(function(e, t) {
        return e >= t;
      }), $n = Ml(/* @__PURE__ */ function() {
        return arguments;
      }()) ? Ml : function(e) {
        return lt(e) && Ue.call(e, "callee") && !ml.call(e, "callee");
      }, de = R.isArray, Wp = Xa ? Vt(Xa) : Zf;
      function kt(e) {
        return e != null && Oi(e.length) && !yn(e);
      }
      function ct(e) {
        return lt(e) && kt(e);
      }
      function jp(e) {
        return e === !0 || e === !1 || lt(e) && Pt(e) == Ke;
      }
      var zn = sf || fa, Qp = Za ? Vt(Za) : $f;
      function Kp(e) {
        return lt(e) && e.nodeType === 1 && !Fr(e);
      }
      function qp(e) {
        if (e == null)
          return !0;
        if (kt(e) && (de(e) || typeof e == "string" || typeof e.splice == "function" || zn(e) || hr(e) || $n(e)))
          return !e.length;
        var t = Mt(e);
        if (t == it || t == Te)
          return !e.size;
        if (Dr(e))
          return !Bs(e).length;
        for (var i in e)
          if (Ue.call(e, i))
            return !1;
        return !0;
      }
      function Yp(e, t) {
        return _r(e, t);
      }
      function Jp(e, t, i) {
        i = typeof i == "function" ? i : n;
        var l = i ? i(e, t) : n;
        return l === n ? _r(e, t, n, i) : !!l;
      }
      function ta(e) {
        if (!lt(e))
          return !1;
        var t = Pt(e);
        return t == dt || t == vt || typeof e.message == "string" && typeof e.name == "string" && !Fr(e);
      }
      function Xp(e) {
        return typeof e == "number" && Al(e);
      }
      function yn(e) {
        if (!rt(e))
          return !1;
        var t = Pt(e);
        return t == gt || t == Gt || t == bt || t == X;
      }
      function Uo(e) {
        return typeof e == "number" && e == pe(e);
      }
      function Oi(e) {
        return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Ge;
      }
      function rt(e) {
        var t = typeof e;
        return e != null && (t == "object" || t == "function");
      }
      function lt(e) {
        return e != null && typeof e == "object";
      }
      var Go = $a ? Vt($a) : td;
      function Zp(e, t) {
        return e === t || Is(e, t, js(t));
      }
      function $p(e, t, i) {
        return i = typeof i == "function" ? i : n, Is(e, t, js(t), i);
      }
      function eh(e) {
        return Ho(e) && e != +e;
      }
      function th(e) {
        if (Fd(e))
          throw new fe(o);
        return Pl(e);
      }
      function nh(e) {
        return e === null;
      }
      function rh(e) {
        return e == null;
      }
      function Ho(e) {
        return typeof e == "number" || lt(e) && Pt(e) == pt;
      }
      function Fr(e) {
        if (!lt(e) || Pt(e) != ot)
          return !1;
        var t = li(e);
        if (t === null)
          return !0;
        var i = Ue.call(t, "constructor") && t.constructor;
        return typeof i == "function" && i instanceof i && ri.call(i) == Zu;
      }
      var na = el ? Vt(el) : nd;
      function ih(e) {
        return Uo(e) && e >= -Ge && e <= Ge;
      }
      var Vo = tl ? Vt(tl) : rd;
      function Ni(e) {
        return typeof e == "string" || !de(e) && lt(e) && Pt(e) == we;
      }
      function Wt(e) {
        return typeof e == "symbol" || lt(e) && Pt(e) == ze;
      }
      var hr = nl ? Vt(nl) : id;
      function sh(e) {
        return e === n;
      }
      function ah(e) {
        return lt(e) && Mt(e) == Le;
      }
      function lh(e) {
        return lt(e) && Pt(e) == Xe;
      }
      var oh = Ei(Ms), ch = Ei(function(e, t) {
        return e <= t;
      });
      function zo(e) {
        if (!e)
          return [];
        if (kt(e))
          return Ni(e) ? ln(e) : Dt(e);
        if (Er && e[Er])
          return Gu(e[Er]());
        var t = Mt(e), i = t == it ? vs : t == Te ? ei : mr;
        return i(e);
      }
      function Cn(e) {
        if (!e)
          return e === 0 ? e : 0;
        if (e = rn(e), e === Ne || e === -Ne) {
          var t = e < 0 ? -1 : 1;
          return t * ye;
        }
        return e === e ? e : 0;
      }
      function pe(e) {
        var t = Cn(e), i = t % 1;
        return t === t ? i ? t - i : t : 0;
      }
      function Wo(e) {
        return e ? Yn(pe(e), 0, We) : 0;
      }
      function rn(e) {
        if (typeof e == "number")
          return e;
        if (Wt(e))
          return Be;
        if (rt(e)) {
          var t = typeof e.valueOf == "function" ? e.valueOf() : e;
          e = rt(t) ? t + "" : t;
        }
        if (typeof e != "string")
          return e === 0 ? e : +e;
        e = ol(e);
        var i = xe.test(e);
        return i || St.test(e) ? yu(e.slice(2), i ? 2 : 8) : Fe.test(e) ? Be : +e;
      }
      function jo(e) {
        return gn(e, Ft(e));
      }
      function uh(e) {
        return e ? Yn(pe(e), -Ge, Ge) : e === 0 ? e : 0;
      }
      function ke(e) {
        return e == null ? "" : zt(e);
      }
      var fh = dr(function(e, t) {
        if (Dr(t) || kt(t)) {
          gn(t, wt(t), e);
          return;
        }
        for (var i in t)
          Ue.call(t, i) && Mr(e, i, t[i]);
      }), Qo = dr(function(e, t) {
        gn(t, Ft(t), e);
      }), Di = dr(function(e, t, i, l) {
        gn(t, Ft(t), e, l);
      }), dh = dr(function(e, t, i, l) {
        gn(t, wt(t), e, l);
      }), gh = xn(ys);
      function ph(e, t) {
        var i = fr(e);
        return t == null ? i : yl(i, t);
      }
      var hh = me(function(e, t) {
        e = Ye(e);
        var i = -1, l = t.length, u = l > 2 ? t[2] : n;
        for (u && Rt(t[0], t[1], u) && (l = 1); ++i < l; )
          for (var h = t[i], v = Ft(h), C = -1, B = v.length; ++C < B; ) {
            var F = v[C], U = e[F];
            (U === n || cn(U, or[F]) && !Ue.call(e, F)) && (e[F] = h[F]);
          }
        return e;
      }), mh = me(function(e) {
        return e.push(n, oo), Ht(Ko, n, e);
      });
      function vh(e, t) {
        return il(e, ie(t, 3), dn);
      }
      function Ah(e, t) {
        return il(e, ie(t, 3), Es);
      }
      function wh(e, t) {
        return e == null ? e : Cs(e, ie(t, 3), Ft);
      }
      function bh(e, t) {
        return e == null ? e : Il(e, ie(t, 3), Ft);
      }
      function xh(e, t) {
        return e && dn(e, ie(t, 3));
      }
      function Sh(e, t) {
        return e && Es(e, ie(t, 3));
      }
      function yh(e) {
        return e == null ? [] : vi(e, wt(e));
      }
      function Ch(e) {
        return e == null ? [] : vi(e, Ft(e));
      }
      function ra(e, t, i) {
        var l = e == null ? n : Jn(e, t);
        return l === n ? i : l;
      }
      function Eh(e, t) {
        return e != null && fo(e, t, qf);
      }
      function ia(e, t) {
        return e != null && fo(e, t, Yf);
      }
      var Th = ro(function(e, t, i) {
        t != null && typeof t.toString != "function" && (t = ii.call(t)), e[t] = i;
      }, aa(Ut)), Lh = ro(function(e, t, i) {
        t != null && typeof t.toString != "function" && (t = ii.call(t)), Ue.call(e, t) ? e[t].push(i) : e[t] = [i];
      }, ie), Ih = me(Rr);
      function wt(e) {
        return kt(e) ? xl(e) : Bs(e);
      }
      function Ft(e) {
        return kt(e) ? xl(e, !0) : sd(e);
      }
      function Bh(e, t) {
        var i = {};
        return t = ie(t, 3), dn(e, function(l, u, h) {
          wn(i, t(l, u, h), l);
        }), i;
      }
      function Mh(e, t) {
        var i = {};
        return t = ie(t, 3), dn(e, function(l, u, h) {
          wn(i, u, t(l, u, h));
        }), i;
      }
      var Ph = dr(function(e, t, i) {
        Ai(e, t, i);
      }), Ko = dr(function(e, t, i, l) {
        Ai(e, t, i, l);
      }), Rh = xn(function(e, t) {
        var i = {};
        if (e == null)
          return i;
        var l = !1;
        t = et(t, function(h) {
          return h = Hn(h, e), l || (l = h.length > 1), h;
        }), gn(e, zs(e), i), l && (i = en(i, S | A | y, Td));
        for (var u = t.length; u--; )
          Ns(i, t[u]);
        return i;
      });
      function _h(e, t) {
        return qo(e, _i(ie(t)));
      }
      var Oh = xn(function(e, t) {
        return e == null ? {} : ld(e, t);
      });
      function qo(e, t) {
        if (e == null)
          return {};
        var i = et(zs(e), function(l) {
          return [l];
        });
        return t = ie(t), Fl(e, i, function(l, u) {
          return t(l, u[0]);
        });
      }
      function Nh(e, t, i) {
        t = Hn(t, e);
        var l = -1, u = t.length;
        for (u || (u = 1, e = n); ++l < u; ) {
          var h = e == null ? n : e[pn(t[l])];
          h === n && (l = u, h = i), e = yn(h) ? h.call(e) : h;
        }
        return e;
      }
      function Dh(e, t, i) {
        return e == null ? e : Or(e, t, i);
      }
      function kh(e, t, i, l) {
        return l = typeof l == "function" ? l : n, e == null ? e : Or(e, t, i, l);
      }
      var Yo = ao(wt), Jo = ao(Ft);
      function Fh(e, t, i) {
        var l = de(e), u = l || zn(e) || hr(e);
        if (t = ie(t, 4), i == null) {
          var h = e && e.constructor;
          u ? i = l ? new h() : [] : rt(e) ? i = yn(h) ? fr(li(e)) : {} : i = {};
        }
        return (u ? Xt : dn)(e, function(v, C, B) {
          return t(i, v, C, B);
        }), i;
      }
      function Uh(e, t) {
        return e == null ? !0 : Ns(e, t);
      }
      function Gh(e, t, i) {
        return e == null ? e : zl(e, t, Fs(i));
      }
      function Hh(e, t, i, l) {
        return l = typeof l == "function" ? l : n, e == null ? e : zl(e, t, Fs(i), l);
      }
      function mr(e) {
        return e == null ? [] : ms(e, wt(e));
      }
      function Vh(e) {
        return e == null ? [] : ms(e, Ft(e));
      }
      function zh(e, t, i) {
        return i === n && (i = t, t = n), i !== n && (i = rn(i), i = i === i ? i : 0), t !== n && (t = rn(t), t = t === t ? t : 0), Yn(rn(e), t, i);
      }
      function Wh(e, t, i) {
        return t = Cn(t), i === n ? (i = t, t = 0) : i = Cn(i), e = rn(e), Jf(e, t, i);
      }
      function jh(e, t, i) {
        if (i && typeof i != "boolean" && Rt(e, t, i) && (t = i = n), i === n && (typeof t == "boolean" ? (i = t, t = n) : typeof e == "boolean" && (i = e, e = n)), e === n && t === n ? (e = 0, t = 1) : (e = Cn(e), t === n ? (t = e, e = 0) : t = Cn(t)), e > t) {
          var l = e;
          e = t, t = l;
        }
        if (i || e % 1 || t % 1) {
          var u = wl();
          return Bt(e + u * (t - e + Su("1e-" + ((u + "").length - 1))), t);
        }
        return Rs(e, t);
      }
      var Qh = gr(function(e, t, i) {
        return t = t.toLowerCase(), e + (i ? Xo(t) : t);
      });
      function Xo(e) {
        return sa(ke(e).toLowerCase());
      }
      function Zo(e) {
        return e = ke(e), e && e.replace(at, Nu).replace(du, "");
      }
      function Kh(e, t, i) {
        e = ke(e), t = zt(t);
        var l = e.length;
        i = i === n ? l : Yn(pe(i), 0, l);
        var u = i;
        return i -= t.length, i >= 0 && e.slice(i, u) == t;
      }
      function qh(e) {
        return e = ke(e), e && qe.test(e) ? e.replace(Me, Du) : e;
      }
      function Yh(e) {
        return e = ke(e), e && Yr.test(e) ? e.replace(Sr, "\\$&") : e;
      }
      var Jh = gr(function(e, t, i) {
        return e + (i ? "-" : "") + t.toLowerCase();
      }), Xh = gr(function(e, t, i) {
        return e + (i ? " " : "") + t.toLowerCase();
      }), Zh = eo("toLowerCase");
      function $h(e, t, i) {
        e = ke(e), t = pe(t);
        var l = t ? ar(e) : 0;
        if (!t || l >= t)
          return e;
        var u = (t - l) / 2;
        return Ci(fi(u), i) + e + Ci(ui(u), i);
      }
      function em(e, t, i) {
        e = ke(e), t = pe(t);
        var l = t ? ar(e) : 0;
        return t && l < t ? e + Ci(t - l, i) : e;
      }
      function tm(e, t, i) {
        e = ke(e), t = pe(t);
        var l = t ? ar(e) : 0;
        return t && l < t ? Ci(t - l, i) + e : e;
      }
      function nm(e, t, i) {
        return i || t == null ? t = 0 : t && (t = +t), cf(ke(e).replace(nr, ""), t || 0);
      }
      function rm(e, t, i) {
        return (i ? Rt(e, t, i) : t === n) ? t = 1 : t = pe(t), _s(ke(e), t);
      }
      function im() {
        var e = arguments, t = ke(e[0]);
        return e.length < 3 ? t : t.replace(e[1], e[2]);
      }
      var sm = gr(function(e, t, i) {
        return e + (i ? "_" : "") + t.toLowerCase();
      });
      function am(e, t, i) {
        return i && typeof i != "number" && Rt(e, t, i) && (t = i = n), i = i === n ? We : i >>> 0, i ? (e = ke(e), e && (typeof t == "string" || t != null && !na(t)) && (t = zt(t), !t && sr(e)) ? Vn(ln(e), 0, i) : e.split(t, i)) : [];
      }
      var lm = gr(function(e, t, i) {
        return e + (i ? " " : "") + sa(t);
      });
      function om(e, t, i) {
        return e = ke(e), i = i == null ? 0 : Yn(pe(i), 0, e.length), t = zt(t), e.slice(i, i + t.length) == t;
      }
      function cm(e, t, i) {
        var l = g.templateSettings;
        i && Rt(e, t, i) && (t = n), e = ke(e), t = Di({}, t, l, lo);
        var u = Di({}, t.imports, l.imports, lo), h = wt(u), v = ms(u, h), C, B, F = 0, U = t.interpolate || yt, H = "__p += '", Y = As(
          (t.escape || yt).source + "|" + U.source + "|" + (U === an ? oe : yt).source + "|" + (t.evaluate || yt).source + "|$",
          "g"
        ), ne = "//# sourceURL=" + (Ue.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++vu + "]") + `
`;
        e.replace(Y, function(ae, Ae, Ce, jt, _t, Qt) {
          return Ce || (Ce = jt), H += e.slice(F, Qt).replace(On, ku), Ae && (C = !0, H += `' +
__e(` + Ae + `) +
'`), _t && (B = !0, H += `';
` + _t + `;
__p += '`), Ce && (H += `' +
((__t = (` + Ce + `)) == null ? '' : __t) +
'`), F = Qt + ae.length, ae;
        }), H += `';
`;
        var se = Ue.call(t, "variable") && t.variable;
        if (!se)
          H = `with (obj) {
` + H + `
}
`;
        else if (z.test(se))
          throw new fe(p);
        H = (B ? H.replace(At, "") : H).replace(Nt, "$1").replace(tt, "$1;"), H = "function(" + (se || "obj") + `) {
` + (se ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (C ? ", __e = _.escape" : "") + (B ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + H + `return __p
}`;
        var he = ec(function() {
          return Re(h, ne + "return " + H).apply(n, v);
        });
        if (he.source = H, ta(he))
          throw he;
        return he;
      }
      function um(e) {
        return ke(e).toLowerCase();
      }
      function fm(e) {
        return ke(e).toUpperCase();
      }
      function dm(e, t, i) {
        if (e = ke(e), e && (i || t === n))
          return ol(e);
        if (!e || !(t = zt(t)))
          return e;
        var l = ln(e), u = ln(t), h = cl(l, u), v = ul(l, u) + 1;
        return Vn(l, h, v).join("");
      }
      function gm(e, t, i) {
        if (e = ke(e), e && (i || t === n))
          return e.slice(0, dl(e) + 1);
        if (!e || !(t = zt(t)))
          return e;
        var l = ln(e), u = ul(l, ln(t)) + 1;
        return Vn(l, 0, u).join("");
      }
      function pm(e, t, i) {
        if (e = ke(e), e && (i || t === n))
          return e.replace(nr, "");
        if (!e || !(t = zt(t)))
          return e;
        var l = ln(e), u = cl(l, ln(t));
        return Vn(l, u).join("");
      }
      function hm(e, t) {
        var i = V, l = K;
        if (rt(t)) {
          var u = "separator" in t ? t.separator : u;
          i = "length" in t ? pe(t.length) : i, l = "omission" in t ? zt(t.omission) : l;
        }
        e = ke(e);
        var h = e.length;
        if (sr(e)) {
          var v = ln(e);
          h = v.length;
        }
        if (i >= h)
          return e;
        var C = i - ar(l);
        if (C < 1)
          return l;
        var B = v ? Vn(v, 0, C).join("") : e.slice(0, C);
        if (u === n)
          return B + l;
        if (v && (C += B.length - C), na(u)) {
          if (e.slice(C).search(u)) {
            var F, U = B;
            for (u.global || (u = As(u.source, ke(Ee.exec(u)) + "g")), u.lastIndex = 0; F = u.exec(U); )
              var H = F.index;
            B = B.slice(0, H === n ? C : H);
          }
        } else if (e.indexOf(zt(u), C) != C) {
          var Y = B.lastIndexOf(u);
          Y > -1 && (B = B.slice(0, Y));
        }
        return B + l;
      }
      function mm(e) {
        return e = ke(e), e && Pe.test(e) ? e.replace(De, Wu) : e;
      }
      var vm = gr(function(e, t, i) {
        return e + (i ? " " : "") + t.toUpperCase();
      }), sa = eo("toUpperCase");
      function $o(e, t, i) {
        return e = ke(e), t = i ? n : t, t === n ? Uu(e) ? Ku(e) : Mu(e) : e.match(t) || [];
      }
      var ec = me(function(e, t) {
        try {
          return Ht(e, n, t);
        } catch (i) {
          return ta(i) ? i : new fe(i);
        }
      }), Am = xn(function(e, t) {
        return Xt(t, function(i) {
          i = pn(i), wn(e, i, $s(e[i], e));
        }), e;
      });
      function wm(e) {
        var t = e == null ? 0 : e.length, i = ie();
        return e = t ? et(e, function(l) {
          if (typeof l[1] != "function")
            throw new Zt(d);
          return [i(l[0]), l[1]];
        }) : [], me(function(l) {
          for (var u = -1; ++u < t; ) {
            var h = e[u];
            if (Ht(h[0], this, l))
              return Ht(h[1], this, l);
          }
        });
      }
      function bm(e) {
        return jf(en(e, S));
      }
      function aa(e) {
        return function() {
          return e;
        };
      }
      function xm(e, t) {
        return e == null || e !== e ? t : e;
      }
      var Sm = no(), ym = no(!0);
      function Ut(e) {
        return e;
      }
      function la(e) {
        return Rl(typeof e == "function" ? e : en(e, S));
      }
      function Cm(e) {
        return Ol(en(e, S));
      }
      function Em(e, t) {
        return Nl(e, en(t, S));
      }
      var Tm = me(function(e, t) {
        return function(i) {
          return Rr(i, e, t);
        };
      }), Lm = me(function(e, t) {
        return function(i) {
          return Rr(e, i, t);
        };
      });
      function oa(e, t, i) {
        var l = wt(t), u = vi(t, l);
        i == null && !(rt(t) && (u.length || !l.length)) && (i = t, t = e, e = this, u = vi(t, wt(t)));
        var h = !(rt(i) && "chain" in i) || !!i.chain, v = yn(e);
        return Xt(u, function(C) {
          var B = t[C];
          e[C] = B, v && (e.prototype[C] = function() {
            var F = this.__chain__;
            if (h || F) {
              var U = e(this.__wrapped__), H = U.__actions__ = Dt(this.__actions__);
              return H.push({ func: B, args: arguments, thisArg: e }), U.__chain__ = F, U;
            }
            return B.apply(e, Dn([this.value()], arguments));
          });
        }), e;
      }
      function Im() {
        return Ct._ === this && (Ct._ = $u), this;
      }
      function ca() {
      }
      function Bm(e) {
        return e = pe(e), me(function(t) {
          return Dl(t, e);
        });
      }
      var Mm = Gs(et), Pm = Gs(rl), Rm = Gs(fs);
      function tc(e) {
        return Ks(e) ? ds(pn(e)) : od(e);
      }
      function _m(e) {
        return function(t) {
          return e == null ? n : Jn(e, t);
        };
      }
      var Om = io(), Nm = io(!0);
      function ua() {
        return [];
      }
      function fa() {
        return !1;
      }
      function Dm() {
        return {};
      }
      function km() {
        return "";
      }
      function Fm() {
        return !0;
      }
      function Um(e, t) {
        if (e = pe(e), e < 1 || e > Ge)
          return [];
        var i = We, l = Bt(e, We);
        t = ie(t), e -= We;
        for (var u = hs(l, t); ++i < e; )
          t(i);
        return u;
      }
      function Gm(e) {
        return de(e) ? et(e, pn) : Wt(e) ? [e] : Dt(xo(ke(e)));
      }
      function Hm(e) {
        var t = ++Xu;
        return ke(e) + t;
      }
      var Vm = yi(function(e, t) {
        return e + t;
      }, 0), zm = Hs("ceil"), Wm = yi(function(e, t) {
        return e / t;
      }, 1), jm = Hs("floor");
      function Qm(e) {
        return e && e.length ? mi(e, Ut, Ts) : n;
      }
      function Km(e, t) {
        return e && e.length ? mi(e, ie(t, 2), Ts) : n;
      }
      function qm(e) {
        return al(e, Ut);
      }
      function Ym(e, t) {
        return al(e, ie(t, 2));
      }
      function Jm(e) {
        return e && e.length ? mi(e, Ut, Ms) : n;
      }
      function Xm(e, t) {
        return e && e.length ? mi(e, ie(t, 2), Ms) : n;
      }
      var Zm = yi(function(e, t) {
        return e * t;
      }, 1), $m = Hs("round"), ev = yi(function(e, t) {
        return e - t;
      }, 0);
      function tv(e) {
        return e && e.length ? ps(e, Ut) : 0;
      }
      function nv(e, t) {
        return e && e.length ? ps(e, ie(t, 2)) : 0;
      }
      return g.after = Cp, g.ary = Ro, g.assign = fh, g.assignIn = Qo, g.assignInWith = Di, g.assignWith = dh, g.at = gh, g.before = _o, g.bind = $s, g.bindAll = Am, g.bindKey = Oo, g.castArray = Dp, g.chain = Bo, g.chunk = jd, g.compact = Qd, g.concat = Kd, g.cond = wm, g.conforms = bm, g.constant = aa, g.countBy = tp, g.create = ph, g.curry = No, g.curryRight = Do, g.debounce = ko, g.defaults = hh, g.defaultsDeep = mh, g.defer = Ep, g.delay = Tp, g.difference = qd, g.differenceBy = Yd, g.differenceWith = Jd, g.drop = Xd, g.dropRight = Zd, g.dropRightWhile = $d, g.dropWhile = eg, g.fill = tg, g.filter = rp, g.flatMap = ap, g.flatMapDeep = lp, g.flatMapDepth = op, g.flatten = Eo, g.flattenDeep = ng, g.flattenDepth = rg, g.flip = Lp, g.flow = Sm, g.flowRight = ym, g.fromPairs = ig, g.functions = yh, g.functionsIn = Ch, g.groupBy = cp, g.initial = ag, g.intersection = lg, g.intersectionBy = og, g.intersectionWith = cg, g.invert = Th, g.invertBy = Lh, g.invokeMap = fp, g.iteratee = la, g.keyBy = dp, g.keys = wt, g.keysIn = Ft, g.map = Mi, g.mapKeys = Bh, g.mapValues = Mh, g.matches = Cm, g.matchesProperty = Em, g.memoize = Ri, g.merge = Ph, g.mergeWith = Ko, g.method = Tm, g.methodOf = Lm, g.mixin = oa, g.negate = _i, g.nthArg = Bm, g.omit = Rh, g.omitBy = _h, g.once = Ip, g.orderBy = gp, g.over = Mm, g.overArgs = Bp, g.overEvery = Pm, g.overSome = Rm, g.partial = ea, g.partialRight = Fo, g.partition = pp, g.pick = Oh, g.pickBy = qo, g.property = tc, g.propertyOf = _m, g.pull = gg, g.pullAll = Lo, g.pullAllBy = pg, g.pullAllWith = hg, g.pullAt = mg, g.range = Om, g.rangeRight = Nm, g.rearg = Mp, g.reject = vp, g.remove = vg, g.rest = Pp, g.reverse = Xs, g.sampleSize = wp, g.set = Dh, g.setWith = kh, g.shuffle = bp, g.slice = Ag, g.sortBy = yp, g.sortedUniq = Eg, g.sortedUniqBy = Tg, g.split = am, g.spread = Rp, g.tail = Lg, g.take = Ig, g.takeRight = Bg, g.takeRightWhile = Mg, g.takeWhile = Pg, g.tap = Qg, g.throttle = _p, g.thru = Bi, g.toArray = zo, g.toPairs = Yo, g.toPairsIn = Jo, g.toPath = Gm, g.toPlainObject = jo, g.transform = Fh, g.unary = Op, g.union = Rg, g.unionBy = _g, g.unionWith = Og, g.uniq = Ng, g.uniqBy = Dg, g.uniqWith = kg, g.unset = Uh, g.unzip = Zs, g.unzipWith = Io, g.update = Gh, g.updateWith = Hh, g.values = mr, g.valuesIn = Vh, g.without = Fg, g.words = $o, g.wrap = Np, g.xor = Ug, g.xorBy = Gg, g.xorWith = Hg, g.zip = Vg, g.zipObject = zg, g.zipObjectDeep = Wg, g.zipWith = jg, g.entries = Yo, g.entriesIn = Jo, g.extend = Qo, g.extendWith = Di, oa(g, g), g.add = Vm, g.attempt = ec, g.camelCase = Qh, g.capitalize = Xo, g.ceil = zm, g.clamp = zh, g.clone = kp, g.cloneDeep = Up, g.cloneDeepWith = Gp, g.cloneWith = Fp, g.conformsTo = Hp, g.deburr = Zo, g.defaultTo = xm, g.divide = Wm, g.endsWith = Kh, g.eq = cn, g.escape = qh, g.escapeRegExp = Yh, g.every = np, g.find = ip, g.findIndex = yo, g.findKey = vh, g.findLast = sp, g.findLastIndex = Co, g.findLastKey = Ah, g.floor = jm, g.forEach = Mo, g.forEachRight = Po, g.forIn = wh, g.forInRight = bh, g.forOwn = xh, g.forOwnRight = Sh, g.get = ra, g.gt = Vp, g.gte = zp, g.has = Eh, g.hasIn = ia, g.head = To, g.identity = Ut, g.includes = up, g.indexOf = sg, g.inRange = Wh, g.invoke = Ih, g.isArguments = $n, g.isArray = de, g.isArrayBuffer = Wp, g.isArrayLike = kt, g.isArrayLikeObject = ct, g.isBoolean = jp, g.isBuffer = zn, g.isDate = Qp, g.isElement = Kp, g.isEmpty = qp, g.isEqual = Yp, g.isEqualWith = Jp, g.isError = ta, g.isFinite = Xp, g.isFunction = yn, g.isInteger = Uo, g.isLength = Oi, g.isMap = Go, g.isMatch = Zp, g.isMatchWith = $p, g.isNaN = eh, g.isNative = th, g.isNil = rh, g.isNull = nh, g.isNumber = Ho, g.isObject = rt, g.isObjectLike = lt, g.isPlainObject = Fr, g.isRegExp = na, g.isSafeInteger = ih, g.isSet = Vo, g.isString = Ni, g.isSymbol = Wt, g.isTypedArray = hr, g.isUndefined = sh, g.isWeakMap = ah, g.isWeakSet = lh, g.join = ug, g.kebabCase = Jh, g.last = nn, g.lastIndexOf = fg, g.lowerCase = Xh, g.lowerFirst = Zh, g.lt = oh, g.lte = ch, g.max = Qm, g.maxBy = Km, g.mean = qm, g.meanBy = Ym, g.min = Jm, g.minBy = Xm, g.stubArray = ua, g.stubFalse = fa, g.stubObject = Dm, g.stubString = km, g.stubTrue = Fm, g.multiply = Zm, g.nth = dg, g.noConflict = Im, g.noop = ca, g.now = Pi, g.pad = $h, g.padEnd = em, g.padStart = tm, g.parseInt = nm, g.random = jh, g.reduce = hp, g.reduceRight = mp, g.repeat = rm, g.replace = im, g.result = Nh, g.round = $m, g.runInContext = I, g.sample = Ap, g.size = xp, g.snakeCase = sm, g.some = Sp, g.sortedIndex = wg, g.sortedIndexBy = bg, g.sortedIndexOf = xg, g.sortedLastIndex = Sg, g.sortedLastIndexBy = yg, g.sortedLastIndexOf = Cg, g.startCase = lm, g.startsWith = om, g.subtract = ev, g.sum = tv, g.sumBy = nv, g.template = cm, g.times = Um, g.toFinite = Cn, g.toInteger = pe, g.toLength = Wo, g.toLower = um, g.toNumber = rn, g.toSafeInteger = uh, g.toString = ke, g.toUpper = fm, g.trim = dm, g.trimEnd = gm, g.trimStart = pm, g.truncate = hm, g.unescape = mm, g.uniqueId = Hm, g.upperCase = vm, g.upperFirst = sa, g.each = Mo, g.eachRight = Po, g.first = To, oa(g, function() {
        var e = {};
        return dn(g, function(t, i) {
          Ue.call(g.prototype, i) || (e[i] = t);
        }), e;
      }(), { chain: !1 }), g.VERSION = a, Xt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
        g[e].placeholder = g;
      }), Xt(["drop", "take"], function(e, t) {
        Se.prototype[e] = function(i) {
          i = i === n ? 1 : mt(pe(i), 0);
          var l = this.__filtered__ && !t ? new Se(this) : this.clone();
          return l.__filtered__ ? l.__takeCount__ = Bt(i, l.__takeCount__) : l.__views__.push({
            size: Bt(i, We),
            type: e + (l.__dir__ < 0 ? "Right" : "")
          }), l;
        }, Se.prototype[e + "Right"] = function(i) {
          return this.reverse()[e](i).reverse();
        };
      }), Xt(["filter", "map", "takeWhile"], function(e, t) {
        var i = t + 1, l = i == te || i == ue;
        Se.prototype[e] = function(u) {
          var h = this.clone();
          return h.__iteratees__.push({
            iteratee: ie(u, 3),
            type: i
          }), h.__filtered__ = h.__filtered__ || l, h;
        };
      }), Xt(["head", "last"], function(e, t) {
        var i = "take" + (t ? "Right" : "");
        Se.prototype[e] = function() {
          return this[i](1).value()[0];
        };
      }), Xt(["initial", "tail"], function(e, t) {
        var i = "drop" + (t ? "" : "Right");
        Se.prototype[e] = function() {
          return this.__filtered__ ? new Se(this) : this[i](1);
        };
      }), Se.prototype.compact = function() {
        return this.filter(Ut);
      }, Se.prototype.find = function(e) {
        return this.filter(e).head();
      }, Se.prototype.findLast = function(e) {
        return this.reverse().find(e);
      }, Se.prototype.invokeMap = me(function(e, t) {
        return typeof e == "function" ? new Se(this) : this.map(function(i) {
          return Rr(i, e, t);
        });
      }), Se.prototype.reject = function(e) {
        return this.filter(_i(ie(e)));
      }, Se.prototype.slice = function(e, t) {
        e = pe(e);
        var i = this;
        return i.__filtered__ && (e > 0 || t < 0) ? new Se(i) : (e < 0 ? i = i.takeRight(-e) : e && (i = i.drop(e)), t !== n && (t = pe(t), i = t < 0 ? i.dropRight(-t) : i.take(t - e)), i);
      }, Se.prototype.takeRightWhile = function(e) {
        return this.reverse().takeWhile(e).reverse();
      }, Se.prototype.toArray = function() {
        return this.take(We);
      }, dn(Se.prototype, function(e, t) {
        var i = /^(?:filter|find|map|reject)|While$/.test(t), l = /^(?:head|last)$/.test(t), u = g[l ? "take" + (t == "last" ? "Right" : "") : t], h = l || /^find/.test(t);
        u && (g.prototype[t] = function() {
          var v = this.__wrapped__, C = l ? [1] : arguments, B = v instanceof Se, F = C[0], U = B || de(v), H = function(Ae) {
            var Ce = u.apply(g, Dn([Ae], C));
            return l && Y ? Ce[0] : Ce;
          };
          U && i && typeof F == "function" && F.length != 1 && (B = U = !1);
          var Y = this.__chain__, ne = !!this.__actions__.length, se = h && !Y, he = B && !ne;
          if (!h && U) {
            v = he ? v : new Se(this);
            var ae = e.apply(v, C);
            return ae.__actions__.push({ func: Bi, args: [H], thisArg: n }), new $t(ae, Y);
          }
          return se && he ? e.apply(this, C) : (ae = this.thru(H), se ? l ? ae.value()[0] : ae.value() : ae);
        });
      }), Xt(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
        var t = ti[e], i = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", l = /^(?:pop|shift)$/.test(e);
        g.prototype[e] = function() {
          var u = arguments;
          if (l && !this.__chain__) {
            var h = this.value();
            return t.apply(de(h) ? h : [], u);
          }
          return this[i](function(v) {
            return t.apply(de(v) ? v : [], u);
          });
        };
      }), dn(Se.prototype, function(e, t) {
        var i = g[t];
        if (i) {
          var l = i.name + "";
          Ue.call(ur, l) || (ur[l] = []), ur[l].push({ name: t, func: i });
        }
      }), ur[Si(n, M).name] = [{
        name: "wrapper",
        func: n
      }], Se.prototype.clone = mf, Se.prototype.reverse = vf, Se.prototype.value = Af, g.prototype.at = Kg, g.prototype.chain = qg, g.prototype.commit = Yg, g.prototype.next = Jg, g.prototype.plant = Zg, g.prototype.reverse = $g, g.prototype.toJSON = g.prototype.valueOf = g.prototype.value = ep, g.prototype.first = g.prototype.head, Er && (g.prototype[Er] = Xg), g;
    }, lr = qu();
    jn ? ((jn.exports = lr)._ = lr, ls._ = lr) : Ct._ = lr;
  }).call(Ur);
})(Vi, Vi.exports);
var Ia = Vi.exports;
const Vr = /* @__PURE__ */ lv(Ia), wv = "font-size: 10px;padding: 2px 4px;border-radius: 3px;letter-spacing:1px;", sc = wv + "color: black; background: grey;";
function bv(s) {
  return new Proxy(s, {
    apply: function(r, n, a) {
      console.log("%c%s", sc, "↓↓↓↓↓QT Event↓↓↓↓↓↓"), console.log("raw: "), console.log(JSON.stringify(a)), console.log("object: "), console.log(a), console.log("%c%s", sc, "↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑"), r.apply(n, a);
    }
  });
}
const xv = {}, ac = function(s) {
  const r = s.split(".")[1];
  return JSON.parse(xv.Buffer.from(r, "base64").toString("utf8"));
}, Sv = !1;
var Ot = /* @__PURE__ */ ((s) => (s.EXPOSE = "EXP", s.CLICK = "CLK", s.OTHER = "OTHER", s))(Ot || {});
const da = "qt-auto-expose", yv = "container", Cv = "qt-auto-click", ga = "data";
function Yi() {
  const s = () => {
    if (window.aplus)
      return window.aplus;
  }, r = () => {
    if (window.aplus_queue)
      return process.env.NODE_ENV === "development" && Sv && (window.aplus_queue.push = bv(window.aplus_queue.push)), window.aplus_queue;
  };
  function n() {
    var L;
    (L = r()) == null || L.push({
      action: "aplus.appendMetaInfo",
      arguments: ["DEBUG", !0]
    });
  }
  function a() {
    var L;
    (L = r()) == null || L.push({
      action: "aplus.appendMetaInfo",
      arguments: ["DEBUG", !1]
    });
  }
  function c(L) {
    Object.entries(L).forEach(([P, k]) => {
      var q;
      (q = r()) == null || q.push({
        action: "aplus.appendMetaInfo",
        arguments: [P, k]
      });
    });
  }
  function o(L) {
    let P = L;
    if (Object.keys(L).includes("is_agree_share") && typeof L.is_agree_share == "boolean" && (P = {
      ...L,
      is_agree_share: L.is_agree_share ? "Y" : "N"
    }), c({ globalproperty: P }), !Object.keys(L).includes("is_agree_share"))
      return;
    const k = localStorage.getItem("MME-TOKEN");
    if (k)
      try {
        const W = ac(k.replace(/^bearer\s+/, "")).ciamUid, N = L.is_agree_share;
        if (!(W && Vr.isBoolean(N)))
          return;
        G(W, N);
      } catch (q) {
        console.log("err in set global property: ", q);
      }
  }
  function d(L, P, k) {
    return new Proxy(L, {
      apply: async function(q, W, N) {
        var V, K;
        (V = r()) == null || V.push({
          action: "aplus.appendMetaInfo",
          arguments: ["_hold", "BLOCK"]
        });
        try {
          const Z = await q.apply(W, N);
          return P && P(Z), Z;
        } catch (Z) {
          k && k(Z);
        } finally {
          (K = r()) == null || K.push({
            action: "aplus.appendMetaInfo",
            arguments: ["_hold", "START"]
          });
        }
      }
    });
  }
  function p(L) {
    var P;
    (P = r()) == null || P.push({
      action: "aplus.appendMetaInfo",
      arguments: [
        "pageConfig",
        {
          hashMode: !1,
          ...Object.fromEntries(
            Vr.map(L, (k) => [
              k.path,
              {
                pageName: k.pageName,
                pageTitle: k.pageTitle,
                skipMe: k.skipMe,
                regRule: k.regRule
              }
            ])
          )
        }
      ]
    });
  }
  const f = wr((L, P) => {
    var k;
    (k = r()) == null || k.push({
      action: "aplus.sendPV",
      arguments: [
        {
          is_auto: !1
        },
        {
          page_title: L.pageTitle,
          page_name: L.pageName,
          ...P ?? {}
        }
      ]
    });
  }, []);
  function b(L) {
    var q, W;
    const P = L.filter(
      (N) => N.type === "EXP"
      /* EXPOSE */
    ), k = L.filter(
      (N) => N.type === "CLK"
      /* CLICK */
    );
    P.length && ((q = r()) == null || q.push({
      action: "aplus.appendMetaInfo",
      arguments: [
        "aplus-auto-exp",
        P.map(
          (N) => N.isScroll ? {
            cssSelector: `.${da}-${N.logKey}`,
            // be aware the key <logkey> is lowercase here by API doc
            logkey: N.logKey,
            props: Vr.uniq([...N.propertyNames, "page_title", "page_name"]).map(
              (V) => `${ga}-${V.toLowerCase()}`
            ),
            positionSelector: `.${da}-${N.logKey}-${yv}`
          } : {
            cssSelector: `.${da}-${N.logKey}`,
            // be aware the key <logkey> is lowercase here by API doc
            logkey: N.logKey,
            props: Vr.uniq([...N.propertyNames, "page_title", "page_name"]).map(
              (V) => `${ga}-${V.toLowerCase()}`
            )
          }
        )
      ]
    })), k.length && ((W = r()) == null || W.push({
      action: "aplus.appendMetaInfo",
      arguments: [
        "aplus-auto-clk",
        k.map((N) => ({
          cssSelector: `.${Cv}-${N.logKey}`,
          logkey: N.logKey,
          props: Vr.uniq([...N.propertyNames, "page_title", "page_name"]).map(
            (V) => `${ga}-${V.toLowerCase()}`
          )
        }))
      ]
    }));
  }
  function m(L, P, k) {
    var q, W;
    (q = r()) == null || q.push({
      action: "aplus.setMetaInfo",
      arguments: ["aplus-disable-apv", !0]
    }), (W = r()) == null || W.push({
      action: "aplus.record",
      arguments: [P, L, k]
    });
  }
  function S(L) {
    m("OTHER", "$$_user_profile", L);
  }
  const A = {};
  class y {
    logKey;
    eventType;
    properties;
    constructor(P, k) {
      this.logKey = P, this.eventType = k, A[P] = this, this.properties = {};
    }
    setEventMeta(P) {
      const { eventType: k, logKey: q, pageName: W } = P;
      q && (this.logKey = q), k && (this.eventType = k), W && (this.properties = { ...this.properties, page_name: W });
    }
    collect(P, k) {
      this.properties[P] = k;
    }
    stop() {
      A[this.logKey] = null;
    }
    send() {
      m(this.eventType, this.logKey, this.properties), A[this.logKey] = null;
    }
  }
  function _(L, P) {
    return Object.keys(A).find((q) => q === L) || (A[L] = new y(L, P)), A[L];
  }
  function O(L) {
    return `ow_qt_global_is_agree_share_${L}`;
  }
  function G(L, P) {
    localStorage.setItem(O(L), P ? "true" : "false");
  }
  function M(L) {
    if (!L)
      return;
    const P = localStorage.getItem(O(L));
    P === "true" && c({
      is_agree_share: !0
    }), P === "false" && c({
      is_agree_share: !1
    });
  }
  const E = wr((L) => {
    if (!r())
      return;
    process.env.NODE_ENV === "development" && n(), L && p(L), o({ belong_apply: "one_web" });
    const P = localStorage.getItem("MME-TOKEN");
    if (P) {
      const k = P.split(/\s/)[1];
      if (k) {
        const q = ac(k);
        c({ _user_id: q.ciamUid }), o({ me_id: q.ciamUid }), M(q.ciamUid);
      }
    }
  }, []);
  function T() {
    var L;
    (L = r()) == null || L.push({
      action: "aplus.setMetaInfo",
      arguments: ["aplus-jsbridge-only", !0]
    });
  }
  return {
    getAplus: s,
    getAplusQueue: r,
    enableDebug: n,
    disableDebug: a,
    appendMetaInfo: c,
    setGlobalProperty: o,
    appendMetaInfoAsync: d,
    setupAutoPv: p,
    triggerPv: f,
    setupAutoEvents: b,
    triggerEvent: m,
    setUserProfile: S,
    useAsyncEvent: _,
    updateIsAgreeShareByCache: M,
    initQtGlobal: E,
    setBridgeOnly: T
  };
}
const Ev = (s) => {
  var O;
  const [r, n] = Oe([]), a = () => {
    s.handleCloseBurgerMenu(!1);
  }, c = Qr("(min-width: 1024px)"), [o, d] = Oe(""), [p, f] = Oe(""), b = document.querySelector("wc-common-header"), { triggerEvent: m } = Yi(), S = Ie(null);
  _e(() => {
  }, [p]), _e(() => {
    s.searchEnabled || f("");
  }, [s.searchEnabled]), _e(() => {
    var M;
    d(c ? "g-animate-slideLeftIn" : "g-animate-slideInDown");
    const G = b ? (M = b == null ? void 0 : b.shadowRoot) == null ? void 0 : M.querySelector(".burger-menu-hidden") : document.querySelector(".burger-menu-hidden");
    G && G.classList.add("g-hidden");
  }, []), _e(() => {
    s.isBurgerMenuOpen ? d(c ? "g-translate-x-0" : "g-translate-y-0") : d(c ? "g--translate-x-full" : "g--translate-y-full");
  }, [c, s.isBurgerMenuOpen]);
  const A = (G) => {
    G.Link ? window.location.href = G.Link : G.Type === "b-展开车型列表浮层" && s.showVehicles();
  }, y = () => {
    var E;
    const G = !s.isBurgerMenuOpen, M = b ? (E = b == null ? void 0 : b.shadowRoot) == null ? void 0 : E.querySelector(".burger-menu-hidden") : document.querySelector(".burger-menu-hidden");
    M && G && M.classList.add("g-hidden");
  }, _ = wr((G) => {
    s.search.suggestionAPI && fetch(`${s.search.suggestionAPI}?q=${encodeURIComponent(G)}`).then((M) => M.json()).then((M) => {
      n(M.data);
    }).catch((M) => console.error("Error fetching suggestions:", M));
  }, [s]);
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      className: "g-fixed g-top-16 lg:g-top-[72px] g-left-0 g-bottom-0 g-right-0 g-h-[calc(100%-64px)] lg:g-h-[calc(100%-72px)] g-z-[10700] g-bg-black/20 g-transition-opacity burger-menu-hidden " + (s.isBurgerMenuOpen ? "g-delay-0" : "g-delay-500"),
      onClick: a,
      onTransitionEnd: y,
      children: /* @__PURE__ */ x.jsxs(
        "div",
        {
          className: "g-w-full lg:g-w-[488px] g-px-16 lg:g-pl-[66px] lg:g-pr-[68px] g-bg-black g-overflow-y-auto g-h-full scroll-bar-none g-opacity-90 g-duration-500 g-transition " + o,
          onClick: (G) => G.stopPropagation(),
          children: [
            !c && /* @__PURE__ */ x.jsx("div", { className: "g-w-full g-pt-5", children: /* @__PURE__ */ x.jsxs("div", { className: "g-h-10 g-mx-auto g-border-b g-border-neutral-300/40 g-flex g-items-center", children: [
              /* @__PURE__ */ x.jsx(
                "img",
                {
                  src: Tc,
                  alt: "Search",
                  className: "g-mr-3 g-w-6 g-h-6",
                  onClick: () => {
                    m(Ot.CLICK, "top_button_clk", {
                      button_name: "搜索"
                    });
                  }
                }
              ),
              /* @__PURE__ */ x.jsx("form", { action: `${s.search.searchResultURL}`, role: "search", method: "get", className: "g-flex-1", children: /* @__PURE__ */ x.jsx(
                "input",
                {
                  type: "text",
                  name: "q",
                  className: "g-bg-transparent g-outline-none g-border-none g-p-0 g-text-white g-w-full",
                  placeholder: s.searchEnabled ? s.search.placeholder : "",
                  onChange: Ia.debounce((G) => {
                    f(G.target.value), _(G.target.value);
                  }, 500),
                  ref: S,
                  onFocus: () => s.updateSearchStatus(!0)
                }
              ) }),
              p && /* @__PURE__ */ x.jsx("span", { className: "g-w-3 g-h-3", onClick: () => {
                f(""), n([]), S.current && (S.current.value = "", S.current.focus());
              }, children: /* @__PURE__ */ x.jsx("svg", { viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ x.jsx(
                "path",
                {
                  d: "M970.105263 512A458.105263 458.105263 0 1 1 512 53.894737a458.105263 458.105263 0 0 1 458.105263 458.105263z m-458.105263 48.505263l145.785263 145.785263a34.357895 34.357895 0 0 0 48.505263-48.505263L560.505263 512l145.758316-145.758316a34.357895 34.357895 0 0 0-48.505263-48.505263L512 463.494737l-145.758316-145.839158a34.357895 34.357895 0 0 0-48.505263 48.505263L463.494737 512l-145.839158 145.758316a34.357895 34.357895 0 0 0 48.505263 48.505263L512 560.505263z",
                  fill: "#888888"
                }
              ) }) })
            ] }) }),
            s.searchEnabled ? /* @__PURE__ */ x.jsx("div", { children: /* @__PURE__ */ x.jsx("ul", { className: "g-pt-6 md:g-pt-12", children: r == null ? void 0 : r.map((G, M) => /* @__PURE__ */ x.jsx(
              "li",
              {
                className: "g-font-pingFangNormal g-text-sm g-font-medium g-break-words g-mb-6 last-of-type:g-mb-0 g-text-white/60",
                children: /* @__PURE__ */ x.jsx("a", { href: `${s.search.searchResultURL}?q=${G.trim()}&type=suggestion`, children: G.trim() })
              },
              M
            )) }) }) : /* @__PURE__ */ x.jsx("nav", { className: "g-text-white g-font-pingFangNormal", children: (O = s.menuData.data) == null ? void 0 : O.attributes.FirstLevelMenu.map((G, M) => /* @__PURE__ */ x.jsxs("div", { className: "g-py-9 g-border-b g-border-neutral-300/20 g-flex last-of-type:g-border-none", children: [
              /* @__PURE__ */ x.jsx("div", { className: "g-text-base g-font-medium g-flex-1 lg:g-w-[190px]", children: G.Level1MenuLabel }),
              /* @__PURE__ */ x.jsx("ul", { className: "g-flex-1", children: G.Level2Menu.map((E, T) => /* @__PURE__ */ x.jsx(
                "li",
                {
                  className: "g-text-white lg:g-text-sm g-leading-6 lg:g-leading-7 g-font-medium g-mb-4 lg:g-mb-5 g-opacity-60 hover:g-opacity-100 lg:g--translate-y-0.5 last-of-type:g-mb-0",
                  children: /* @__PURE__ */ x.jsx(
                    "span",
                    {
                      onClick: () => A(E),
                      className: "lg:g-p-0.5 g-cursor-pointer",
                      children: E.Label
                    }
                  )
                },
                T
              )) })
            ] }, M)) })
          ]
        }
      )
    }
  );
};
var er = /* @__PURE__ */ ((s) => (s.HOMEPAGE = "homepage", s.CAMPAIGNS = "campaigns", s.UNKNOWN = "unknown", s))(er || {}), Je = /* @__PURE__ */ ((s) => (s.AMG = "amg", s.MAYBACH = "maybach", s.G_CLASS = "gClass", s))(Je || {});
const Tv = () => !!document.querySelector(".homepage_renovation") && (window.location.pathname === "/" || window.location.pathname === "/homepage" || window.location.pathname === "/homepage.html" || window.location.pathname === "/renovation-homepage.html" || window.location.pathname === "/renovation-homepage"), lc = (s) => s.startsWith("/") ? !0 : new URL(s).host === window.location.host, Lc = (s) => {
  const r = new Image();
  r.src = s;
}, Wr = (s) => {
  s.stopPropagation();
}, Ic = (s, r) => {
  r && Wr(r), window.location.href = s;
};
function Lv(s, r) {
  let n, a;
  return function(...c) {
    const o = this;
    a ? (clearTimeout(n), n = setTimeout(() => {
      Date.now() - a >= r && (s.apply(o, c), a = Date.now());
    }, r - (Date.now() - a))) : (s.apply(o, c), a = Date.now());
  };
}
const Iv = () => {
  localStorage == null || localStorage.setItem(vv, window.location.href);
}, Bv = async (s, r) => {
  const n = s + "/api/ecommerce/customers/nsts/" + r, a = {
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    }
  };
  try {
    const c = await fetch(n, a);
    if (!c.ok)
      throw new Error(`HTTP error! status: ${c.status}`);
    const o = await c.json();
    if (!o.data || !o.data.classCode)
      throw new Error("No classCode found");
    return o.data.classCode;
  } catch (c) {
    console.error("Error fetching customer data:", c);
  }
}, Mv = (s) => {
  const r = typeof document < "u" ? document.cookie.split(";") : [];
  for (let n = 0; n < r.length; n++) {
    const a = r[n].trim().split("=");
    if (a[0] === s)
      return a[1];
  }
  return null;
}, Bc = () => {
  const s = Ie({
    [Je.AMG]: !1,
    [Je.MAYBACH]: !1,
    [Je.G_CLASS]: !1
  }), r = (b) => b.includes(br) ? b.split(br)[0] : b;
  return {
    getVehicleTreeData: (b) => {
      var M, E, T, L, P, k, q, W, N, V, K, Z, j, te, re, ue, Ne, Ge, ye, Be, We;
      const m = [], S = {}, A = {}, y = {};
      for (let je = 0; je < b.length; je++) {
        const He = b[je].OWVehicleClass, sn = [];
        for (let Qe = 0; Qe < He.length; Qe++) {
          const Ve = He[Qe].OWVehicleModel, bt = [];
          for (let Ke = 0; Ke < Ve.length; Ke++) {
            const ce = (M = Ve[Ke].vehicleDetail.data) == null ? void 0 : M.attributes.vehicleData;
            let vt;
            ce != null && ce.msrp ? vt = ce.msrp : ((T = (E = ce == null ? void 0 : ce.model) == null ? void 0 : E.data) == null ? void 0 : T.attributes.hideMsrp) !== !0 && (vt = (k = (P = (L = ce == null ? void 0 : ce.model) == null ? void 0 : L.data) == null ? void 0 : P.attributes.publishedMsrp) == null ? void 0 : k.toString());
            const dt = {
              id: Ve[Ke].id,
              name: ((ce == null ? void 0 : ce.nameCN) ?? ((W = (q = ce == null ? void 0 : ce.model) == null ? void 0 : q.data) == null ? void 0 : W.attributes.cnName) ?? "").replaceAll("\\n", `
`),
              nstCode: (ce == null ? void 0 : ce.nstCode) || ((V = (N = ce == null ? void 0 : ce.model) == null ? void 0 : N.data) == null ? void 0 : V.attributes.publishedNst),
              msrp: vt,
              nameImagePC: (Z = (K = Ve[Ke].vehicleDetail.data) == null ? void 0 : K.attributes.nameImagePC.data) == null ? void 0 : Z.attributes.url,
              nameImageMobile: (te = (j = Ve[Ke].vehicleDetail.data) == null ? void 0 : j.attributes.nameImageMobile.data) == null ? void 0 : te.attributes.url,
              vehicleImagePC: (re = ce == null ? void 0 : ce.vehicleImagePC.data) == null ? void 0 : re.attributes.url,
              vehicleImageMobile: (ue = ce == null ? void 0 : ce.vehicleImageMobile.data) == null ? void 0 : ue.attributes.url,
              detailLink: (Ge = (Ne = Ve[Ke].vehicleDetail.data) == null ? void 0 : Ne.attributes.detailLink.data) == null ? void 0 : Ge.attributes.link.link,
              CTAs: ((ye = Ve[Ke].vehicleDetail.data) == null ? void 0 : ye.attributes.CTAs.map((gt) => {
                var Gt, it, pt, Tt, ot, Q;
                return {
                  label: gt.label,
                  link: ((pt = (it = (Gt = gt.link.data) == null ? void 0 : Gt.attributes) == null ? void 0 : it.link) == null ? void 0 : pt.link) || "#",
                  type: ((Q = (ot = (Tt = gt.link.data) == null ? void 0 : Tt.attributes) == null ? void 0 : ot.link) == null ? void 0 : Q.type) || ""
                };
              }).filter((gt) => gt.link)) || [],
              recommend: Ve[Ke].recommend,
              model: (We = (Be = ce == null ? void 0 : ce.model) == null ? void 0 : Be.data) == null ? void 0 : We.attributes
            };
            bt.push(dt), Ve[Ke].addToAMG && (s.current.amg = !0, S[He[Qe].title] ? S[He[Qe].title].push(dt) : S[He[Qe].title] = [dt]), Ve[Ke].addToGClass && (s.current.gClass = !0, y[He[Qe].title] ? y[He[Qe].title].push(dt) : y[He[Qe].title] = [dt]), Ve[Ke].addToMaybach && (s.current.maybach = !0, A[He[Qe].title] ? A[He[Qe].title].push(dt) : A[He[Qe].title] = [dt]);
          }
          bt.length && sn.push({
            name: He[Qe].title,
            recommend: He[Qe].recommend,
            // modelList: modelList.length === 2 ? modelList.concat(modelList[0]) : modelList,
            modelList: bt
          });
        }
        sn.length && m.push({
          name: b[je].title,
          isBrand: !1,
          classList: sn
        });
      }
      const _ = Object.keys(S).map((je) => ({ name: je, modelList: S[je], recommend: !1 })), O = Object.keys(A).map((je) => ({ name: je, modelList: A[je], recommend: !1 })), G = Object.keys(y).map((je) => ({ name: je, modelList: y[je], recommend: !1 }));
      return _.length && m.push({ name: Je.AMG, isBrand: !0, classList: _ }), O.length && m.push({ name: Je.MAYBACH, isBrand: !0, classList: O }), G.length && m.push({ name: Je.G_CLASS, isBrand: !0, classList: G }), m;
    },
    hasBrand: s,
    getDefaultBodyAndClass: (b) => {
      const m = [0, 0];
      e: for (let S = 0; S < b.length; S++) {
        const A = b[S].OWVehicleClass;
        for (let y = 0; y < A.length; y++)
          if (A[y].recommend === !0) {
            m[0] = S, m[1] = y;
            break e;
          }
      }
      return m;
    },
    getViewModal: (b, m) => b.length === 1 ? 0 : m === void 0 ? b.findIndex((S) => S.recommend) : m,
    getQtTabName: (b, m = "") => ({
      [Je.AMG]: "AMG",
      [Je.MAYBACH]: "Maybach",
      [Je.G_CLASS]: "G class"
    })[b] || m,
    formatPrice: (b) => b.replace(/(\d+(\.\d+)?)/, " $1 "),
    isSingleLetter: (b) => r(b).length === 1,
    getClassLetters: r,
    navigateToBrandPage: (b) => {
      const m = {
        [Je.AMG]: fv,
        [Je.MAYBACH]: gv,
        [Je.G_CLASS]: dv
      };
      window.location.href = m[b];
    }
  };
}, Pv = ({ close: s }) => /* @__PURE__ */ x.jsx("div", { className: "global-header-modal-container", children: /* @__PURE__ */ x.jsxs("div", { className: "global-header-modal-container-box", onClick: (r) => r.stopPropagation(), children: [
  /* @__PURE__ */ x.jsx("div", { className: "global-header-modal-container-box__title" }),
  /* @__PURE__ */ x.jsxs("div", { className: "global-header-modal-container-box__content scroll-bar-none", children: [
    /* @__PURE__ */ x.jsx("p", { children: "产品（含配置、细节等）以经销商展示、销售中国大陆具体车型及产品为准。" }),
    /* @__PURE__ */ x.jsx("p", { children: "本产品页中的价格（如：整车、零件、金融产品等）均为厂商建议零售价格。具体价格、产品配置、交易细节等，请与经销商确定。" })
  ] }),
  /* @__PURE__ */ x.jsx("svg", { className: "icon global-header-modal-container-box__close", onClick: s, viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "p-id": "4237", width: "16", height: "16", children: /* @__PURE__ */ x.jsx("path", { d: "M512 466.752l265.386667-265.386667a32 32 0 0 1 45.226666 45.269334L557.269333 512l265.386667 265.386667a32 32 0 0 1-45.269333 45.226666L512 557.269333l-265.386667 265.386667a32 32 0 0 1-45.226666-45.269333L466.730667 512 201.365333 246.613333a32 32 0 0 1 45.269334-45.226666L512 466.730667z", fill: "#8a8a8a", "p-id": "4238" }) })
] }) }), Mc = () => {
  const [s, r] = Oe(!1), [n, a] = Oe(null);
  _e(() => {
    if (s) {
      const p = document.createElement("div"), f = document.querySelector("wc-common-header");
      return f != null && f.shadowRoot ? f.shadowRoot.appendChild(p) : document.body.appendChild(p), a(p), document.querySelector("html").classList.add("vehicle-list__overflow-hidden"), p.addEventListener("wheel", Wr, { passive: !1 }), p.addEventListener("touchmove", Wr, { passive: !1 }), () => {
        document.querySelector("html").classList.remove("vehicle-list__overflow-hidden"), p.removeEventListener("wheel", Wr), p.removeEventListener("touchmove", Wr), f != null && f.shadowRoot && p.parentNode === (f == null ? void 0 : f.shadowRoot) ? f.shadowRoot.removeChild(p) : document.body.removeChild(p), a(null);
      };
    }
  }, [s]);
  const c = () => {
    r(!0);
  }, o = () => {
    r(!1);
  }, d = n ? av(/* @__PURE__ */ x.jsx(Pv, { close: o }), n) : null;
  return {
    showOverlay: c,
    overlay: d
  };
}, oc = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAAAm1JREFUeF7tmsFSFDEQhv/2jie8o09goT4DVOl1t1aeQ30I5DlYYD1Coa+gpeUTCHc5yZ2fSlWgdrd2JiG9w2TXf66TzqS//N1JemLQ00rAxKedgAAlFCJAAuRLIlKQFCQF+QhIQT5+ykFSkBTkIyAF+fgpB0lBUpCPQK0KIrkN4AuAEOZDM/vRqaeFnfeWg0iOAYziuCdmNiz0oVOzPgGdAngbvftmZrudelrYuRsQyTcAPgHYaBvDPACS04CuAPws9KHJ7BrAvjd0lwHoAsBWhnNPzIx37eYAZZgXNbk0s+dFltFoGYD+AMgZRB+ALszsRd+Awmr0AcDTRIi9m34/p6C/AL57HFlg+w/AgZn98vTrVlDpx+cArW+SdgA6BPBey3wDQZIvARzHjeLIGwqlE5Wy6y3EUgOr5b0A1XoWq0UhqXFIQVJQSiPt76tVEMnXAE4AhOPJoK9VrmZAAc4gzu/YzPZ8WiizrhnQVwA70a0zM5s5qpS5+3ArN6BY7viYKnc8fGgIIbbZBIjkeaLPUO74vErljgJG9yYzCiIZJvYmo8OVKndk+NPYpBRQFeWOV7Hc0VpRnHI9N6xDpfJZS4iFimTbE0IslDtclcrcwXpmv8iW5Hok6SLvM4xIaplv40QyhO5R3CiG/2a/M7guvUm1IbZ0Tws7FCAdVgulE82kICloRRWkon1i4kjqt09in/Pf3O7Qr+eEEnR5IQFI118SgHSByreTWGyt2x3pZV6XODPKGRNdA+4iPh+xTx1WdVj1yU0KkoKkIB8BKcjHTzlICpKCfASkIB8/5SApSAryEZCCfPyUgxL8bgFOOd5JxWhK4QAAAABJRU5ErkJggg==", Rv = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWYAAAAICAYAAADKr1WIAAAAAXNSR0IArs4c6QAAAN9JREFUaEPt2LFqQkEQheF/IgnERptglzJVbCwU0efJm/jcJywsgQSNy1W7/9azs/Dd5TBMccOX5BXYAseqOt3QyqMKKKCAAl2gpkgk+WhhDGyAl9ajqr6m9PKMAgoooMBvgeFgTrIA9sABWP2FNJh9WgoooMB9BP4N5iRPwGefjtfA7NK1BvN9fohdFFBAgbPBnOSth3GbkJcjTAbziJI1CiigwHWBn2BO8tx3xm133HbIw2uO69dYoYACCigwKlBJ3vveeAfMRw9ap4ACCijwGAGn4se42lUBBRSYLPANeMYbN4/5j6QAAAAASUVORK5CYII=", _v = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWYAAAAICAYAAADKr1WIAAAAAXNSR0IArs4c6QAAANtJREFUaEPt2TEKwlAQhOGZc3sTz6OIFmm08gZio42CoisPnhCF4OZhuj+l7A7hK4awWjwIIIAAAn8RiIiZpIWkje1ra6hbF9lDAAEEEPgUiIh5/eUmqSslbXs/1oliHivGPAIIIDAg0Cvm/sRB0lLSyvY5g0cxZ5SYQQABBBICA8X83nxI2tZTx872cyiSYk5gM4IAAghkBH4Ucz/iVL6g66nj+J3tEUGZ92IGAQQQQCAvEJLKDbr8YdjZvpdVijkPyCQCCCAwpcBF0rrcozllTMlMNgIIINAg8ALc3TEkw7+6FQAAAABJRU5ErkJggg==", ya = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAAAftJREFUeF7t2jFOxDAQBdA/lJwKek6BREGJ4BggSgokTgE1t6LEyFIsRatsHGfm26vl06EkTublZ+xADPpZFTD5rAsIqJIQAQnI10SUICVICfIJKEE+P/UgJUgJ8gkoQT4/9SAlSAnyCShBPj/1ICVICfIJjEhQSukCwAOANzP7YVaQUroEcA/g1cx+o88V3oMmnHcAtwC+AdywkCacTwDXAD4A3EUjMYAeATzP7iQF6QCnnO7JzF4iU8QAypEvd7VcayjSEZzQc5QLDwfKAzMLYI69lDwKEAupN06ugwYUjTQChw4UhTQKpwuQF2kkTjegvUijcboCtSKdAk53oK1Ip4IzBKiGNK1FqAvNlpU2dZpfu5ApJV8Arg5eS/Kv+d2KsgpvwRmWoHKRRx6leQ2U14cWpGEJ2oA0HGd4glb6Ud4kID1iKw+7mnQdZ3Eq//fT/JZF4JZ9WmYiz75dZ7GWwlv29QDUju0GtKfgPcfUCm7d3gXIU6jn2FaMpf3pQBEFRoyxF4sKFFlY5FgtWDQgRkGMMWtYFCBmIcyxu/SgHgX0OEfBCk9QSkn/eq78ISx/2aGPFzYg6fOX2gxwDtvDe9A5oMxrEFDljgpIQL6HXglSgpQgn4AS5PNTD1KClCCfgBLk81MPUoKUIJ+AEuTzUw9SgpQgn0Dl6D8RilBYQWY7EwAAAABJRU5ErkJggg==", Pc = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAVdJREFUSEu9lr8uBUEUh78jQiIRChUancp7iIRIlBoFDRLewBuQULmFRikREryHSqdBpSAScUUcOWtG5l7u3rPL2HLnt+eb83+FkkdVx4E5YAaYAkaC/B64BM6AExG56WRGfjpQ1VFgC1gCessuAbwBB6YXkbt27TeAqs4Ch8BgF8Ptx0/AooicpgctAFVdB3aAnorGo/wd2BCR3fjiCxBufvwL4ylkPnpSAELMr2qEpZOjFq5Jy0kE7APLXcLynGgawEAXfUNEViSU4rWjWh5FZDh4/AAMOaprwgCrwJ4jqU1gO+g2gX7HN2sGOAemHWKrkNhQ1oCeSrswgH005gBUDZGZvDXAi9PdOoDmvwCyh8ib5DohKpLsLdM6gKJMreTyNVroTM+oqOrB56ioMOxegaPQLwtAX0nvtA67ALFFk2dcx5tkXTgJJN/KTCD5ln6auL/4bfkAgli9LZpnI5AAAAAASUVORK5CYII=";
function cc(s = [], r) {
  for (const n of s)
    for (const a of n.classes)
      for (const c of a.models)
        if (c.publishedNst === r)
          return {
            bodyStyleEnName: n.enName,
            classEnName: a.enName
          };
  return null;
}
const Rc = async (s, r, n, a, c, o) => {
  var m, S;
  const d = r.publishedNst || c, p = (m = cc(a, d)) == null ? void 0 : m.bodyStyleEnName, f = (S = cc(a, d)) == null ? void 0 : S.classEnName, b = await Bv(o, d);
  switch (n) {
    case "test_drive":
      return `${s}?model=${r.enName}&body=${p}&class=${f}`;
    case "online_purchase":
      return `${s}?nstCode=${r.publishedNst}`;
    case "financial_calculator":
      return `${s}?nstCode=${r.publishedNst}&msrp=${r.publishedMsrp}&modelName=${r.enName}&class=${f}&body=${p}`;
    case "view_3D_vehicle":
      return `${s}?classId=${b}&nstCode=${d}`;
    case "online_purchase_select_model":
      return `${s}?classId=${b}&code=${r.publishedNst}`;
    default:
      return s;
  }
}, Ba = () => sessionStorage.getItem(
  "isFromSalesApp"
  /* IS_FROM_SALES_APP */
) === "true", _c = () => sessionStorage.getItem(
  "isFromDouYinMNP"
  /* IS_FROM_DOU_YIN_MNP */
) === "true", Ov = () => Ba() || _c(), Nv = () => sessionStorage.getItem(
  "isDisplayCTA"
  /* IS_DISPLAY_CTA */
) === "true", zi = (s) => {
  const [r, n] = Oe(!1), a = Av.some((c) => s == null ? void 0 : s.includes(c));
  return _e(() => {
    if (!s) {
      n(!0);
      return;
    }
    const c = Ba(), o = Nv();
    let d = !1;
    c && (d = !0, o && (d = !a)), n(d);
  }, [a, s]), { isHiddenCTA: r };
}, Dv = () => {
  const [s, r] = Oe({
    isInApp: !1,
    isInSalesApp: !1,
    isInDouYinMnp: !1
  });
  return _e(() => {
    if (typeof window < "u") {
      const n = () => {
        const c = {
          isInApp: Ov(),
          isInSalesApp: Ba(),
          isInDouYinMnp: _c()
        };
        r(c);
      };
      n();
      const a = setTimeout(n, 100);
      return () => clearTimeout(a);
    }
  }, []), s;
}, Oc = () => {
  const { isInSalesApp: s } = Dv();
  return s;
}, Nc = (s) => {
  if (s.classList.length)
    return s.name === Je.AMG ? /* @__PURE__ */ x.jsx("div", { className: "body-style-brand-amg" }) : s.name === Je.MAYBACH ? /* @__PURE__ */ x.jsx("div", { className: "body-style-brand-maybach" }) : s.name === Je.G_CLASS ? /* @__PURE__ */ x.jsx("div", { className: "body-style-brand-g" }) : /* @__PURE__ */ x.jsx("span", { children: s.name });
}, kv = (s) => {
  var dt, gt, Gt, it, pt, Tt, ot, Q, X, ge, Te, we, ze, be, Le, Xe, st, xt, Lt, mn, fn, In, Bn, Mn, Pn;
  const {
    isSingleLetter: r,
    getClassLetters: n,
    navigateToBrandPage: a,
    getVehicleTreeData: c,
    getDefaultBodyAndClass: o,
    hasBrand: { current: d },
    formatPrice: p
  } = Bc(), { showOverlay: f, overlay: b } = Mc(), m = Ie(null), S = Ie(null), A = Ie(null), [y, _] = Oe(0), [O, G] = Oe(0), [M, E] = Oe(0), T = Ie([]), L = Ie(null), P = "body-style-active", k = Ie(null), [q, W] = Oe(!1), [N, V] = Oe({ left: null, active: null, right: null }), K = Oc(), Z = ((Gt = (gt = (dt = N.active) == null ? void 0 : dt.CTAs) == null ? void 0 : gt[0]) == null ? void 0 : Gt.link) || "", j = ((Tt = (pt = (it = N.active) == null ? void 0 : it.CTAs) == null ? void 0 : pt[1]) == null ? void 0 : Tt.link) || "", { isHiddenCTA: te } = zi(Z), { isHiddenCTA: re } = zi(j), ue = ((Q = (ot = N.active) == null ? void 0 : ot.CTAs) == null ? void 0 : Q.filter(($, le) => le === 0 ? !te : le === 1 ? !re : !0)) || [], Ne = s.vehicleListData.vehicleList.data, Ge = s.vehicleListData.bodyStyles, ye = wr(() => {
    if (Ne && Ne.attributes.OWVehicleBody.length > 0) {
      const At = [d.amg, d.maybach, d.gClass, !0].filter((De) => De).length + Ne.attributes.OWVehicleBody.length, tt = window.innerHeight * 0.7 / At < 68;
      if (k.current && A.current) {
        const De = A.current.querySelectorAll("li");
        if (tt) {
          k.current.classList.add("global-header-body-style-column");
          const Me = (window.innerHeight - 72 - 37 * 2) / At;
          Me <= 48 ? (A.current.classList.remove("global-header-body-style-ul"), De.forEach((Pe, qe) => {
            y === qe ? Pe.classList.add(P) : Pe.classList.remove(P), Pe.classList.add("global-header-body-style-ul-li-mb-6");
          })) : Me < 68 ? (A.current.classList.add("global-header-body-style-ul"), De.forEach((Pe, qe) => {
            y === qe ? Pe.classList.add(P) : Pe.classList.remove(P), Pe.classList.add("global-header-body-style-ul-li");
          })) : (A.current.classList.remove("global-header-body-style-ul"), De.forEach((Pe, qe) => {
            y === qe ? Pe.classList.add(P) : Pe.classList.remove(P), Pe.classList.remove("global-header-body-style-ul-li", "global-header-body-style-ul-li-mb-6");
          }));
        } else
          k.current.classList.remove("global-header-body-style-column"), A.current.classList.remove("global-header-body-style-ul"), De.forEach((Me, Pe) => {
            y === Pe ? Me.classList.add(P) : Me.classList.remove(P), Me.classList.remove("global-header-body-style-ul-li", "global-header-body-style-ul-li-mb-6");
          });
      }
      W(tt);
    }
  }, [Ne, d.amg, d.maybach, d.gClass, y]);
  _e(() => {
    if (Ne) {
      const $ = Ne.attributes.OWVehicleBody;
      if ($.length) {
        L.current = c($);
        const [le, At] = o($), tt = new URLSearchParams(window.location.search).get("body");
        let De = le;
        if (tt && Ge) {
          let Me = -1;
          if (tt in Hi) {
            const Pe = Hi[tt];
            Me = Ge.findIndex(
              (qe) => qe.enName === Pe
            ), Me < 0 && L.current && (Me = L.current.findIndex(
              (qe) => qe.name === Pe
            ));
          }
          Me < 0 && L.current && (Me = L.current.findIndex(
            (Pe) => Pe.name === tt
          )), Me >= 0 && (De = Me);
        }
        Be(De, At), T.current = $.map((Me) => {
          const Pe = Me.OWVehicleClass.findIndex((an) => an.recommend), qe = Pe >= 0 ? Pe : 0, Rn = Me.OWVehicleClass[qe].OWVehicleModel.findIndex((an) => an.recommend), _n = Rn >= 0 ? Rn : 0;
          return { classIdx: qe, modelIdx: _n };
        }), window.addEventListener("resize", ye);
      }
      return () => {
        window.removeEventListener("resize", ye);
      };
    }
  }, []);
  const Be = ($, le, At = !1) => {
    _($);
    let Nt = 0, tt = 0;
    if (le !== void 0)
      tt = le;
    else {
      const De = L.current[$];
      De.isBrand || (tt = De.classList.findIndex((Me) => Me.recommend));
    }
    At && (tt = 0), le !== void 0 && T.current[$] && (T.current[$].classIdx = le, T.current[$].modelIdx = L.current[$].classList[le].modelList.findIndex((De) => De.recommend)), T.current[$] && (tt = T.current[$].classIdx, Nt = T.current[$].modelIdx >= 0 ? T.current[$].modelIdx : 0), G(tt || 0), E(Nt || 0);
  };
  _e(() => {
    ye();
  }, [Ne, d.amg, d.maybach, d.gClass, y, ye]);
  const We = ($) => {
    Be(y, $);
  }, [je, He] = Oe("hidden");
  _e(() => {
    if (s.displayOnHomepage) {
      He("display-on-homepage g-flex");
      return;
    }
    if (s.isVehicleListOpened === void 0) {
      He("g-hidden");
      return;
    }
    s.isVehicleListOpened ? He("open g-flex") : He("close g-flex");
  }, [s.isVehicleListOpened, s.displayOnHomepage]), _e(() => {
    var $;
    ($ = L.current) == null || $[y].classList[O].modelList.forEach(
      (le) => le.vehicleImagePC && Lc(le.vehicleImagePC)
    );
  }, [y, O]);
  const sn = ($) => {
    a($);
  }, Qe = ($) => {
    if (!L.current)
      return console.error("processedVehicleListData is not initialized"), null;
    for (const le of L.current)
      for (const At of le.classList)
        if (At.modelList.some((tt) => tt.name === $))
          return le.name;
    return console.warn(`Model with name "${$}" not found`), null;
  }, Ve = ($) => [Je.AMG, Je.MAYBACH, Je.G_CLASS].includes($), bt = async ($, le, At, Nt) => {
    var tt;
    if (le) {
      let De = le;
      const Me = L.current[y], Pe = Me.classList[O], qe = Pe.modelList[M], Rn = Qe(qe.name), _n = Ve(Me.name) ? Rn : Me.name;
      if (s.onClick) {
        const an = {
          market_segment: _n || "",
          vehicle_series_name: Pe.name,
          vehicle_model_name: qe.name,
          button_name: At
        };
        s.onClick(an);
      }
      if (K && ((tt = qe.model) != null && tt.enName) && le.includes("/test-drive") && s.navigateToTestDrive) {
        s.navigateToTestDrive(qe.model.enName);
        return;
      }
      Nt && qe.model ? De = await Rc(
        le,
        qe.model,
        Nt,
        Ge,
        qe.nstCode || "",
        s.occUrl || ""
      ) : (At === "在线预订" && (De = `${le}?nstCode=${qe.nstCode}&isModelLevel=true`), At === "预约品鉴" && (De = `${le}?model=${qe.name}&body=${Me.name}&class=${Pe.name}`), le.includes("/presale-testdrive") && K && (De = `${le.replace(/\.html/, ".woHeaderFooter.html")}&source=salesapp`)), Ic(De, $);
    }
    window.location.href.includes("/purchase/") && setTimeout(() => {
      window.location.reload();
    }, 100);
  }, Ke = () => {
    var $;
    ($ = s.closeVehicleModal) == null || $.call(s);
  }, ce = wr(() => {
    const $ = L.current[y].classList[O].modelList;
    $.length === 1 ? V({ left: null, active: $[0], right: null }) : V({
      left: $[(M - 1 + $.length) % $.length],
      active: $[M],
      right: $[(M + 1 + $.length) % $.length]
    });
    const le = $[M].vehicleImagePC;
    le && m.current && (m.current.style.backgroundImage = `url(${le})`);
  }, [M, y, O]), vt = ($) => {
    const le = L.current[y].classList[O].modelList, At = (M + $ + le.length) % le.length;
    E(At);
  };
  return _e(() => {
    window.navigator.userAgent.includes("Mac OS") && window.innerWidth > 1024 && S.current && S.current.querySelectorAll(".class-letter-text").forEach(($) => {
      $.style.lineHeight = "43px";
    }), ce();
  }, [M, y, O, ce]), /* @__PURE__ */ x.jsxs(
    "div",
    {
      className: "antialiased global-header-vehicles-container " + je,
      ref: m,
      style: s.isComponent ? { position: "relative", top: 0 } : { position: "fixed" },
      children: [
        /* @__PURE__ */ x.jsxs("div", { className: "global-header-vehicles-container__list", children: [
          /* @__PURE__ */ x.jsxs("div", { className: "global-header-vehicles-container__list-body", children: [
            /* @__PURE__ */ x.jsx("div", { className: "global-header-vehicles-container__list-body-scroll", ref: k, children: /* @__PURE__ */ x.jsxs("ul", { className: "global-header-vehicles-container__list-body-scroll-box", ref: A, children: [
              L.current && L.current.map(($, le) => /* @__PURE__ */ x.jsx(
                "li",
                {
                  onClick: () => {
                    Be(le, void 0, !0);
                  },
                  children: Nc($)
                },
                le
              )),
              /* @__PURE__ */ x.jsx("li", { children: /* @__PURE__ */ x.jsxs("a", { href: uv, children: [
                "全部车型 ",
                q
              ] }) }),
              q && /* @__PURE__ */ x.jsxs("li", { children: [
                /* @__PURE__ */ x.jsx("img", { className: "body-style-filter", alt: "Filter", referrerPolicy: "no-referrer", src: oc }),
                /* @__PURE__ */ x.jsx("a", { href: Gi, className: "cursor-pointer", children: "车型筛选" })
              ] })
            ] }) }),
            !q && /* @__PURE__ */ x.jsx("div", { className: "global-header-vehicles-container__list-body-filter", children: /* @__PURE__ */ x.jsxs("a", { className: "global-header-vehicles-container__list-body-filter-box", href: Gi, children: [
              /* @__PURE__ */ x.jsx("img", { alt: "Filter", referrerPolicy: "no-referrer", src: oc }),
              /* @__PURE__ */ x.jsx("div", { className: "global-header-vehicles-container__list-body-filter-box-text", children: "车型筛选" })
            ] }) })
          ] }),
          /* @__PURE__ */ x.jsxs(
            "ul",
            {
              className: `global-header-vehicles-container__list-class ${(X = L.current) != null && X[y].isBrand ? "" : "global-header-vehicles-container__list-class-wo-brand"}`,
              ref: S,
              children: [
                (ge = L.current) != null && ge[y].isBrand ? /* @__PURE__ */ x.jsxs(
                  "div",
                  {
                    className: "global-header-vehicles-container__list-class-brand",
                    onClick: () => sn(L.current[y].name),
                    children: [
                      ((Te = L.current) == null ? void 0 : Te[y].name) === Je.AMG && /* @__PURE__ */ x.jsx("div", { className: "global-header-vehicles-container__list-class-brand-amg" }),
                      ((we = L.current) == null ? void 0 : we[y].name) === Je.MAYBACH && /* @__PURE__ */ x.jsx("div", { className: "global-header-vehicles-container__list-class-brand-maybach" }),
                      ((ze = L.current) == null ? void 0 : ze[y].name) === Je.G_CLASS && /* @__PURE__ */ x.jsx("div", { className: "global-header-vehicles-container__list-class-brand-g" }),
                      /* @__PURE__ */ x.jsx("div", { className: "global-header-vehicles-container__list-class-brand-title", children: ((be = L.current) == null ? void 0 : be[y].name) === Je.G_CLASS ? "越野传奇" : "品牌中心" })
                    ]
                  }
                ) : null,
                (Le = L.current) == null ? void 0 : Le[y].classList.map(($, le) => /* @__PURE__ */ x.jsxs(
                  "li",
                  {
                    className: `global-header-vehicles-container__list-class-box ${le === O ? "global-header-vehicles-container__list-class-box-active" : ""}`,
                    onClick: () => We(le),
                    children: [
                      /* @__PURE__ */ x.jsx("div", { className: `class-letter ${r($.name) ? "" : "class-letter-multiple"}`, children: /* @__PURE__ */ x.jsx("span", { className: "class-letter-text", children: n($.name) }) }),
                      $.name.includes(br) && /* @__PURE__ */ x.jsx("div", { className: "class-level", children: /* @__PURE__ */ x.jsx("span", { className: "class-level-text", children: br }) })
                    ]
                  },
                  $.name
                ))
              ]
            }
          )
        ] }),
        /* @__PURE__ */ x.jsxs("div", { className: "global-header-vehicles-container__model select-none", children: [
          s.displayOnHomepage !== !0 && !s.isComponent && /* @__PURE__ */ x.jsx("div", { className: "global-header-vehicles-container__model-close", onClick: Ke, children: /* @__PURE__ */ x.jsx("img", { src: ya, alt: "Close" }) }),
          /* @__PURE__ */ x.jsxs("div", { className: "global-header-vehicles-container__model-box", children: [
            /* @__PURE__ */ x.jsxs(
              "div",
              {
                className: "global-header-vehicles-container__model-box-between",
                style: { visibility: N.left ? "visible" : "hidden" },
                onClick: () => vt(-1),
                children: [
                  /* @__PURE__ */ x.jsx("div", { className: "global-header-vehicles-container__model-box-between-arrow", children: /* @__PURE__ */ x.jsx("img", { src: Rv }) }),
                  /* @__PURE__ */ x.jsx("pre", { children: (Xe = N.left) == null ? void 0 : Xe.name })
                ]
              }
            ),
            /* @__PURE__ */ x.jsxs(
              "div",
              {
                className: "global-header-vehicles-container__model-box-active",
                style: { fontSize: (st = N.active) != null && st.nameImagePC ? "0px" : "" },
                children: [
                  (xt = N.active) != null && xt.nameImagePC ? /* @__PURE__ */ x.jsx("img", { src: (Lt = N.active) == null ? void 0 : Lt.nameImagePC, alt: "modelName" }) : /* @__PURE__ */ x.jsx("pre", { children: (mn = N.active) == null ? void 0 : mn.name }),
                  (fn = N.active) != null && fn.msrp ? /* @__PURE__ */ x.jsxs("div", { className: "global-header-vehicles-container__model-tip", children: [
                    "厂家建议零售价 ",
                    p((In = N.active) == null ? void 0 : In.msrp),
                    "起",
                    /* @__PURE__ */ x.jsx("img", { src: Pc, onClick: f })
                  ] }) : /* @__PURE__ */ x.jsx("div", { className: "global-header-vehicles-container__model-tip", children: "具体车型配置以经销商实车为准" }),
                  ((Bn = N.active) == null ? void 0 : Bn.detailLink) && /* @__PURE__ */ x.jsxs("div", { className: "global-header-vehicles-mobile-container-wrapper__model-name-more cursor-pointer", children: [
                    /* @__PURE__ */ x.jsx(
                      "span",
                      {
                        className: "global-header-vehicles-mobile-container-wrapper__model-name-more-text",
                        onClick: ($) => bt($, N.active.detailLink, "了解更多"),
                        children: "了解更多"
                      }
                    ),
                    /* @__PURE__ */ x.jsx(
                      "svg",
                      {
                        className: "icon",
                        viewBox: "0 0 1024 1024",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "p-id": "4356",
                        width: "10",
                        height: "10",
                        children: /* @__PURE__ */ x.jsx(
                          "path",
                          {
                            d: "M320 885.333333c-8.533333 0-17.066667-4.266667-23.466667-10.666666-12.8-12.8-10.666667-34.133333 2.133334-44.8L654.933333 512 298.666667 194.133333c-12.8-10.666667-14.933333-32-2.133334-44.8 10.666667-12.8 32-14.933333 44.8-2.133333l384 341.333333c6.4 6.4 10.666667 14.933333 10.666667 23.466667 0 8.533333-4.266667 17.066667-10.666667 23.466667l-384 341.333333c-6.4 6.4-12.8 8.533333-21.333333 8.533333z",
                            fill: "#ffffff",
                            "p-id": "4357"
                          }
                        )
                      }
                    )
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ x.jsxs(
              "div",
              {
                className: "global-header-vehicles-container__model-box-between",
                onClick: () => vt(1),
                style: { visibility: N.right ? "visible" : "hidden" },
                children: [
                  /* @__PURE__ */ x.jsx("div", { className: "global-header-vehicles-container__model-box-between-arrow", children: /* @__PURE__ */ x.jsx("img", { src: _v }) }),
                  /* @__PURE__ */ x.jsx("pre", { children: (Mn = N.right) == null ? void 0 : Mn.name })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ x.jsx(
            "div",
            {
              className: "global-header-vehicles-container__model-link " + ((Pn = N.active) != null && Pn.detailLink ? "cursor-pointer" : ""),
              onClick: ($) => {
                var le;
                return bt($, (le = N.active) == null ? void 0 : le.detailLink, "了解更多");
              }
            }
          ),
          !!ue.length && /* @__PURE__ */ x.jsxs("div", { className: "global-header-vehicles-container__model-bottom-cta", children: [
            /* @__PURE__ */ x.jsx(
              "div",
              {
                className: `global-header-vehicles-container__model-bottom-cta-purchase ${ue.length === 1 ? "global-header-vehicles-container__model-bottom-cta-single ow-btn-solid-white" : "ow-btn-transparent-white "} ${ue[0].link ? "cursor-pointer" : ""}`,
                onClick: ($) => bt(
                  $,
                  ue[0].link,
                  ue[0].label,
                  ue[0].type
                ),
                children: ue[0].label
              }
            ),
            ue.length > 1 && /* @__PURE__ */ x.jsx(
              "div",
              {
                className: `global-header-vehicles-container__model-bottom-cta-drive ${ue[1].link ? "cursor-pointer" : ""} ow-btn-solid-white `,
                onClick: ($) => bt(
                  $,
                  ue[1].link,
                  ue[1].label,
                  ue[1].type
                ),
                children: ue[1].label
              }
            )
          ] }),
          b
        ] })
      ]
    }
  );
};
function uc(s) {
  return s !== null && typeof s == "object" && "constructor" in s && s.constructor === Object;
}
function Ma(s, r) {
  s === void 0 && (s = {}), r === void 0 && (r = {}), Object.keys(r).forEach((n) => {
    typeof s[n] > "u" ? s[n] = r[n] : uc(r[n]) && uc(s[n]) && Object.keys(r[n]).length > 0 && Ma(s[n], r[n]);
  });
}
const Dc = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function xr() {
  const s = typeof document < "u" ? document : {};
  return Ma(s, Dc), s;
}
const Fv = {
  document: Dc,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(s) {
    return typeof setTimeout > "u" ? (s(), null) : setTimeout(s, 0);
  },
  cancelAnimationFrame(s) {
    typeof setTimeout > "u" || clearTimeout(s);
  }
};
function qt() {
  const s = typeof window < "u" ? window : {};
  return Ma(s, Fv), s;
}
function Uv(s) {
  return s === void 0 && (s = ""), s.trim().split(" ").filter((r) => !!r.trim());
}
function Gv(s) {
  const r = s;
  Object.keys(r).forEach((n) => {
    try {
      r[n] = null;
    } catch {
    }
    try {
      delete r[n];
    } catch {
    }
  });
}
function Ca(s, r) {
  return r === void 0 && (r = 0), setTimeout(s, r);
}
function Wi() {
  return Date.now();
}
function Hv(s) {
  const r = qt();
  let n;
  return r.getComputedStyle && (n = r.getComputedStyle(s, null)), !n && s.currentStyle && (n = s.currentStyle), n || (n = s.style), n;
}
function Vv(s, r) {
  r === void 0 && (r = "x");
  const n = qt();
  let a, c, o;
  const d = Hv(s);
  return n.WebKitCSSMatrix ? (c = d.transform || d.webkitTransform, c.split(",").length > 6 && (c = c.split(", ").map((p) => p.replace(",", ".")).join(", ")), o = new n.WebKitCSSMatrix(c === "none" ? "" : c)) : (o = d.MozTransform || d.OTransform || d.MsTransform || d.msTransform || d.transform || d.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), a = o.toString().split(",")), r === "x" && (n.WebKitCSSMatrix ? c = o.m41 : a.length === 16 ? c = parseFloat(a[12]) : c = parseFloat(a[4])), r === "y" && (n.WebKitCSSMatrix ? c = o.m42 : a.length === 16 ? c = parseFloat(a[13]) : c = parseFloat(a[5])), c || 0;
}
function ki(s) {
  return typeof s == "object" && s !== null && s.constructor && Object.prototype.toString.call(s).slice(8, -1) === "Object";
}
function zv(s) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? s instanceof HTMLElement : s && (s.nodeType === 1 || s.nodeType === 11);
}
function Kt() {
  const s = Object(arguments.length <= 0 ? void 0 : arguments[0]), r = ["__proto__", "constructor", "prototype"];
  for (let n = 1; n < arguments.length; n += 1) {
    const a = n < 0 || arguments.length <= n ? void 0 : arguments[n];
    if (a != null && !zv(a)) {
      const c = Object.keys(Object(a)).filter((o) => r.indexOf(o) < 0);
      for (let o = 0, d = c.length; o < d; o += 1) {
        const p = c[o], f = Object.getOwnPropertyDescriptor(a, p);
        f !== void 0 && f.enumerable && (ki(s[p]) && ki(a[p]) ? a[p].__swiper__ ? s[p] = a[p] : Kt(s[p], a[p]) : !ki(s[p]) && ki(a[p]) ? (s[p] = {}, a[p].__swiper__ ? s[p] = a[p] : Kt(s[p], a[p])) : s[p] = a[p]);
      }
    }
  }
  return s;
}
function Fi(s, r, n) {
  s.style.setProperty(r, n);
}
function kc(s) {
  let {
    swiper: r,
    targetPosition: n,
    side: a
  } = s;
  const c = qt(), o = -r.translate;
  let d = null, p;
  const f = r.params.speed;
  r.wrapperEl.style.scrollSnapType = "none", c.cancelAnimationFrame(r.cssModeFrameID);
  const b = n > o ? "next" : "prev", m = (A, y) => b === "next" && A >= y || b === "prev" && A <= y, S = () => {
    p = (/* @__PURE__ */ new Date()).getTime(), d === null && (d = p);
    const A = Math.max(Math.min((p - d) / f, 1), 0), y = 0.5 - Math.cos(A * Math.PI) / 2;
    let _ = o + y * (n - o);
    if (m(_, n) && (_ = n), r.wrapperEl.scrollTo({
      [a]: _
    }), m(_, n)) {
      r.wrapperEl.style.overflow = "hidden", r.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        r.wrapperEl.style.overflow = "", r.wrapperEl.scrollTo({
          [a]: _
        });
      }), c.cancelAnimationFrame(r.cssModeFrameID);
      return;
    }
    r.cssModeFrameID = c.requestAnimationFrame(S);
  };
  S();
}
function hn(s, r) {
  r === void 0 && (r = "");
  const n = [...s.children];
  return s instanceof HTMLSlotElement && n.push(...s.assignedElements()), r ? n.filter((a) => a.matches(r)) : n;
}
function Wv(s, r) {
  const n = r.contains(s);
  return !n && r instanceof HTMLSlotElement ? [...r.assignedElements()].includes(s) : n;
}
function ji(s) {
  try {
    console.warn(s);
    return;
  } catch {
  }
}
function Qi(s, r) {
  r === void 0 && (r = []);
  const n = document.createElement(s);
  return n.classList.add(...Array.isArray(r) ? r : Uv(r)), n;
}
function jv(s, r) {
  const n = [];
  for (; s.previousElementSibling; ) {
    const a = s.previousElementSibling;
    r ? a.matches(r) && n.push(a) : n.push(a), s = a;
  }
  return n;
}
function Qv(s, r) {
  const n = [];
  for (; s.nextElementSibling; ) {
    const a = s.nextElementSibling;
    r ? a.matches(r) && n.push(a) : n.push(a), s = a;
  }
  return n;
}
function Wn(s, r) {
  return qt().getComputedStyle(s, null).getPropertyValue(r);
}
function Ki(s) {
  let r = s, n;
  if (r) {
    for (n = 0; (r = r.previousSibling) !== null; )
      r.nodeType === 1 && (n += 1);
    return n;
  }
}
function Fc(s, r) {
  const n = [];
  let a = s.parentElement;
  for (; a; )
    r ? a.matches(r) && n.push(a) : n.push(a), a = a.parentElement;
  return n;
}
function Ea(s, r, n) {
  const a = qt();
  return s[r === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(a.getComputedStyle(s, null).getPropertyValue(r === "width" ? "margin-right" : "margin-top")) + parseFloat(a.getComputedStyle(s, null).getPropertyValue(r === "width" ? "margin-left" : "margin-bottom"));
}
function Tn(s) {
  return (Array.isArray(s) ? s : [s]).filter((r) => !!r);
}
let pa;
function Kv() {
  const s = qt(), r = xr();
  return {
    smoothScroll: r.documentElement && r.documentElement.style && "scrollBehavior" in r.documentElement.style,
    touch: !!("ontouchstart" in s || s.DocumentTouch && r instanceof s.DocumentTouch)
  };
}
function Uc() {
  return pa || (pa = Kv()), pa;
}
let ha;
function qv(s) {
  let {
    userAgent: r
  } = s === void 0 ? {} : s;
  const n = Uc(), a = qt(), c = a.navigator.platform, o = r || a.navigator.userAgent, d = {
    ios: !1,
    android: !1
  }, p = a.screen.width, f = a.screen.height, b = o.match(/(Android);?[\s\/]+([\d.]+)?/);
  let m = o.match(/(iPad).*OS\s([\d_]+)/);
  const S = o.match(/(iPod)(.*OS\s([\d_]+))?/), A = !m && o.match(/(iPhone\sOS|iOS)\s([\d_]+)/), y = c === "Win32";
  let _ = c === "MacIntel";
  const O = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !m && _ && n.touch && O.indexOf(`${p}x${f}`) >= 0 && (m = o.match(/(Version)\/([\d.]+)/), m || (m = [0, 1, "13_0_0"]), _ = !1), b && !y && (d.os = "android", d.android = !0), (m || A || S) && (d.os = "ios", d.ios = !0), d;
}
function Gc(s) {
  return s === void 0 && (s = {}), ha || (ha = qv(s)), ha;
}
let ma;
function Yv() {
  const s = qt(), r = Gc();
  let n = !1;
  function a() {
    const p = s.navigator.userAgent.toLowerCase();
    return p.indexOf("safari") >= 0 && p.indexOf("chrome") < 0 && p.indexOf("android") < 0;
  }
  if (a()) {
    const p = String(s.navigator.userAgent);
    if (p.includes("Version/")) {
      const [f, b] = p.split("Version/")[1].split(" ")[0].split(".").map((m) => Number(m));
      n = f < 16 || f === 16 && b < 2;
    }
  }
  const c = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(s.navigator.userAgent), o = a(), d = o || c && r.ios;
  return {
    isSafari: n || o,
    needPerspectiveFix: n,
    need3dFix: d,
    isWebView: c
  };
}
function Jv() {
  return ma || (ma = Yv()), ma;
}
function Xv(s) {
  let {
    swiper: r,
    on: n,
    emit: a
  } = s;
  const c = qt();
  let o = null, d = null;
  const p = () => {
    !r || r.destroyed || !r.initialized || (a("beforeResize"), a("resize"));
  }, f = () => {
    !r || r.destroyed || !r.initialized || (o = new ResizeObserver((S) => {
      d = c.requestAnimationFrame(() => {
        const {
          width: A,
          height: y
        } = r;
        let _ = A, O = y;
        S.forEach((G) => {
          let {
            contentBoxSize: M,
            contentRect: E,
            target: T
          } = G;
          T && T !== r.el || (_ = E ? E.width : (M[0] || M).inlineSize, O = E ? E.height : (M[0] || M).blockSize);
        }), (_ !== A || O !== y) && p();
      });
    }), o.observe(r.el));
  }, b = () => {
    d && c.cancelAnimationFrame(d), o && o.unobserve && r.el && (o.unobserve(r.el), o = null);
  }, m = () => {
    !r || r.destroyed || !r.initialized || a("orientationchange");
  };
  n("init", () => {
    if (r.params.resizeObserver && typeof c.ResizeObserver < "u") {
      f();
      return;
    }
    c.addEventListener("resize", p), c.addEventListener("orientationchange", m);
  }), n("destroy", () => {
    b(), c.removeEventListener("resize", p), c.removeEventListener("orientationchange", m);
  });
}
function Zv(s) {
  let {
    swiper: r,
    extendParams: n,
    on: a,
    emit: c
  } = s;
  const o = [], d = qt(), p = function(m, S) {
    S === void 0 && (S = {});
    const A = d.MutationObserver || d.WebkitMutationObserver, y = new A((_) => {
      if (r.__preventObserver__) return;
      if (_.length === 1) {
        c("observerUpdate", _[0]);
        return;
      }
      const O = function() {
        c("observerUpdate", _[0]);
      };
      d.requestAnimationFrame ? d.requestAnimationFrame(O) : d.setTimeout(O, 0);
    });
    y.observe(m, {
      attributes: typeof S.attributes > "u" ? !0 : S.attributes,
      childList: r.isElement || (typeof S.childList > "u" ? !0 : S).childList,
      characterData: typeof S.characterData > "u" ? !0 : S.characterData
    }), o.push(y);
  }, f = () => {
    if (r.params.observer) {
      if (r.params.observeParents) {
        const m = Fc(r.hostEl);
        for (let S = 0; S < m.length; S += 1)
          p(m[S]);
      }
      p(r.hostEl, {
        childList: r.params.observeSlideChildren
      }), p(r.wrapperEl, {
        attributes: !1
      });
    }
  }, b = () => {
    o.forEach((m) => {
      m.disconnect();
    }), o.splice(0, o.length);
  };
  n({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), a("init", f), a("destroy", b);
}
var $v = {
  on(s, r, n) {
    const a = this;
    if (!a.eventsListeners || a.destroyed || typeof r != "function") return a;
    const c = n ? "unshift" : "push";
    return s.split(" ").forEach((o) => {
      a.eventsListeners[o] || (a.eventsListeners[o] = []), a.eventsListeners[o][c](r);
    }), a;
  },
  once(s, r, n) {
    const a = this;
    if (!a.eventsListeners || a.destroyed || typeof r != "function") return a;
    function c() {
      a.off(s, c), c.__emitterProxy && delete c.__emitterProxy;
      for (var o = arguments.length, d = new Array(o), p = 0; p < o; p++)
        d[p] = arguments[p];
      r.apply(a, d);
    }
    return c.__emitterProxy = r, a.on(s, c, n);
  },
  onAny(s, r) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof s != "function") return n;
    const a = r ? "unshift" : "push";
    return n.eventsAnyListeners.indexOf(s) < 0 && n.eventsAnyListeners[a](s), n;
  },
  offAny(s) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || !r.eventsAnyListeners) return r;
    const n = r.eventsAnyListeners.indexOf(s);
    return n >= 0 && r.eventsAnyListeners.splice(n, 1), r;
  },
  off(s, r) {
    const n = this;
    return !n.eventsListeners || n.destroyed || !n.eventsListeners || s.split(" ").forEach((a) => {
      typeof r > "u" ? n.eventsListeners[a] = [] : n.eventsListeners[a] && n.eventsListeners[a].forEach((c, o) => {
        (c === r || c.__emitterProxy && c.__emitterProxy === r) && n.eventsListeners[a].splice(o, 1);
      });
    }), n;
  },
  emit() {
    const s = this;
    if (!s.eventsListeners || s.destroyed || !s.eventsListeners) return s;
    let r, n, a;
    for (var c = arguments.length, o = new Array(c), d = 0; d < c; d++)
      o[d] = arguments[d];
    return typeof o[0] == "string" || Array.isArray(o[0]) ? (r = o[0], n = o.slice(1, o.length), a = s) : (r = o[0].events, n = o[0].data, a = o[0].context || s), n.unshift(a), (Array.isArray(r) ? r : r.split(" ")).forEach((f) => {
      s.eventsAnyListeners && s.eventsAnyListeners.length && s.eventsAnyListeners.forEach((b) => {
        b.apply(a, [f, ...n]);
      }), s.eventsListeners && s.eventsListeners[f] && s.eventsListeners[f].forEach((b) => {
        b.apply(a, n);
      });
    }), s;
  }
};
function eA() {
  const s = this;
  let r, n;
  const a = s.el;
  typeof s.params.width < "u" && s.params.width !== null ? r = s.params.width : r = a.clientWidth, typeof s.params.height < "u" && s.params.height !== null ? n = s.params.height : n = a.clientHeight, !(r === 0 && s.isHorizontal() || n === 0 && s.isVertical()) && (r = r - parseInt(Wn(a, "padding-left") || 0, 10) - parseInt(Wn(a, "padding-right") || 0, 10), n = n - parseInt(Wn(a, "padding-top") || 0, 10) - parseInt(Wn(a, "padding-bottom") || 0, 10), Number.isNaN(r) && (r = 0), Number.isNaN(n) && (n = 0), Object.assign(s, {
    width: r,
    height: n,
    size: s.isHorizontal() ? r : n
  }));
}
function tA() {
  const s = this;
  function r(V, K) {
    return parseFloat(V.getPropertyValue(s.getDirectionLabel(K)) || 0);
  }
  const n = s.params, {
    wrapperEl: a,
    slidesEl: c,
    size: o,
    rtlTranslate: d,
    wrongRTL: p
  } = s, f = s.virtual && n.virtual.enabled, b = f ? s.virtual.slides.length : s.slides.length, m = hn(c, `.${s.params.slideClass}, swiper-slide`), S = f ? s.virtual.slides.length : m.length;
  let A = [];
  const y = [], _ = [];
  let O = n.slidesOffsetBefore;
  typeof O == "function" && (O = n.slidesOffsetBefore.call(s));
  let G = n.slidesOffsetAfter;
  typeof G == "function" && (G = n.slidesOffsetAfter.call(s));
  const M = s.snapGrid.length, E = s.slidesGrid.length;
  let T = n.spaceBetween, L = -O, P = 0, k = 0;
  if (typeof o > "u")
    return;
  typeof T == "string" && T.indexOf("%") >= 0 ? T = parseFloat(T.replace("%", "")) / 100 * o : typeof T == "string" && (T = parseFloat(T)), s.virtualSize = -T, m.forEach((V) => {
    d ? V.style.marginLeft = "" : V.style.marginRight = "", V.style.marginBottom = "", V.style.marginTop = "";
  }), n.centeredSlides && n.cssMode && (Fi(a, "--swiper-centered-offset-before", ""), Fi(a, "--swiper-centered-offset-after", ""));
  const q = n.grid && n.grid.rows > 1 && s.grid;
  q ? s.grid.initSlides(m) : s.grid && s.grid.unsetSlides();
  let W;
  const N = n.slidesPerView === "auto" && n.breakpoints && Object.keys(n.breakpoints).filter((V) => typeof n.breakpoints[V].slidesPerView < "u").length > 0;
  for (let V = 0; V < S; V += 1) {
    W = 0;
    let K;
    if (m[V] && (K = m[V]), q && s.grid.updateSlide(V, K, m), !(m[V] && Wn(K, "display") === "none")) {
      if (n.slidesPerView === "auto") {
        N && (m[V].style[s.getDirectionLabel("width")] = "");
        const Z = getComputedStyle(K), j = K.style.transform, te = K.style.webkitTransform;
        if (j && (K.style.transform = "none"), te && (K.style.webkitTransform = "none"), n.roundLengths)
          W = s.isHorizontal() ? Ea(K, "width") : Ea(K, "height");
        else {
          const re = r(Z, "width"), ue = r(Z, "padding-left"), Ne = r(Z, "padding-right"), Ge = r(Z, "margin-left"), ye = r(Z, "margin-right"), Be = Z.getPropertyValue("box-sizing");
          if (Be && Be === "border-box")
            W = re + Ge + ye;
          else {
            const {
              clientWidth: We,
              offsetWidth: je
            } = K;
            W = re + ue + Ne + Ge + ye + (je - We);
          }
        }
        j && (K.style.transform = j), te && (K.style.webkitTransform = te), n.roundLengths && (W = Math.floor(W));
      } else
        W = (o - (n.slidesPerView - 1) * T) / n.slidesPerView, n.roundLengths && (W = Math.floor(W)), m[V] && (m[V].style[s.getDirectionLabel("width")] = `${W}px`);
      m[V] && (m[V].swiperSlideSize = W), _.push(W), n.centeredSlides ? (L = L + W / 2 + P / 2 + T, P === 0 && V !== 0 && (L = L - o / 2 - T), V === 0 && (L = L - o / 2 - T), Math.abs(L) < 1 / 1e3 && (L = 0), n.roundLengths && (L = Math.floor(L)), k % n.slidesPerGroup === 0 && A.push(L), y.push(L)) : (n.roundLengths && (L = Math.floor(L)), (k - Math.min(s.params.slidesPerGroupSkip, k)) % s.params.slidesPerGroup === 0 && A.push(L), y.push(L), L = L + W + T), s.virtualSize += W + T, P = W, k += 1;
    }
  }
  if (s.virtualSize = Math.max(s.virtualSize, o) + G, d && p && (n.effect === "slide" || n.effect === "coverflow") && (a.style.width = `${s.virtualSize + T}px`), n.setWrapperSize && (a.style[s.getDirectionLabel("width")] = `${s.virtualSize + T}px`), q && s.grid.updateWrapperSize(W, A), !n.centeredSlides) {
    const V = [];
    for (let K = 0; K < A.length; K += 1) {
      let Z = A[K];
      n.roundLengths && (Z = Math.floor(Z)), A[K] <= s.virtualSize - o && V.push(Z);
    }
    A = V, Math.floor(s.virtualSize - o) - Math.floor(A[A.length - 1]) > 1 && A.push(s.virtualSize - o);
  }
  if (f && n.loop) {
    const V = _[0] + T;
    if (n.slidesPerGroup > 1) {
      const K = Math.ceil((s.virtual.slidesBefore + s.virtual.slidesAfter) / n.slidesPerGroup), Z = V * n.slidesPerGroup;
      for (let j = 0; j < K; j += 1)
        A.push(A[A.length - 1] + Z);
    }
    for (let K = 0; K < s.virtual.slidesBefore + s.virtual.slidesAfter; K += 1)
      n.slidesPerGroup === 1 && A.push(A[A.length - 1] + V), y.push(y[y.length - 1] + V), s.virtualSize += V;
  }
  if (A.length === 0 && (A = [0]), T !== 0) {
    const V = s.isHorizontal() && d ? "marginLeft" : s.getDirectionLabel("marginRight");
    m.filter((K, Z) => !n.cssMode || n.loop ? !0 : Z !== m.length - 1).forEach((K) => {
      K.style[V] = `${T}px`;
    });
  }
  if (n.centeredSlides && n.centeredSlidesBounds) {
    let V = 0;
    _.forEach((Z) => {
      V += Z + (T || 0);
    }), V -= T;
    const K = V > o ? V - o : 0;
    A = A.map((Z) => Z <= 0 ? -O : Z > K ? K + G : Z);
  }
  if (n.centerInsufficientSlides) {
    let V = 0;
    _.forEach((Z) => {
      V += Z + (T || 0);
    }), V -= T;
    const K = (n.slidesOffsetBefore || 0) + (n.slidesOffsetAfter || 0);
    if (V + K < o) {
      const Z = (o - V - K) / 2;
      A.forEach((j, te) => {
        A[te] = j - Z;
      }), y.forEach((j, te) => {
        y[te] = j + Z;
      });
    }
  }
  if (Object.assign(s, {
    slides: m,
    snapGrid: A,
    slidesGrid: y,
    slidesSizesGrid: _
  }), n.centeredSlides && n.cssMode && !n.centeredSlidesBounds) {
    Fi(a, "--swiper-centered-offset-before", `${-A[0]}px`), Fi(a, "--swiper-centered-offset-after", `${s.size / 2 - _[_.length - 1] / 2}px`);
    const V = -s.snapGrid[0], K = -s.slidesGrid[0];
    s.snapGrid = s.snapGrid.map((Z) => Z + V), s.slidesGrid = s.slidesGrid.map((Z) => Z + K);
  }
  if (S !== b && s.emit("slidesLengthChange"), A.length !== M && (s.params.watchOverflow && s.checkOverflow(), s.emit("snapGridLengthChange")), y.length !== E && s.emit("slidesGridLengthChange"), n.watchSlidesProgress && s.updateSlidesOffset(), s.emit("slidesUpdated"), !f && !n.cssMode && (n.effect === "slide" || n.effect === "fade")) {
    const V = `${n.containerModifierClass}backface-hidden`, K = s.el.classList.contains(V);
    S <= n.maxBackfaceHiddenSlides ? K || s.el.classList.add(V) : K && s.el.classList.remove(V);
  }
}
function nA(s) {
  const r = this, n = [], a = r.virtual && r.params.virtual.enabled;
  let c = 0, o;
  typeof s == "number" ? r.setTransition(s) : s === !0 && r.setTransition(r.params.speed);
  const d = (p) => a ? r.slides[r.getSlideIndexByData(p)] : r.slides[p];
  if (r.params.slidesPerView !== "auto" && r.params.slidesPerView > 1)
    if (r.params.centeredSlides)
      (r.visibleSlides || []).forEach((p) => {
        n.push(p);
      });
    else
      for (o = 0; o < Math.ceil(r.params.slidesPerView); o += 1) {
        const p = r.activeIndex + o;
        if (p > r.slides.length && !a) break;
        n.push(d(p));
      }
  else
    n.push(d(r.activeIndex));
  for (o = 0; o < n.length; o += 1)
    if (typeof n[o] < "u") {
      const p = n[o].offsetHeight;
      c = p > c ? p : c;
    }
  (c || c === 0) && (r.wrapperEl.style.height = `${c}px`);
}
function rA() {
  const s = this, r = s.slides, n = s.isElement ? s.isHorizontal() ? s.wrapperEl.offsetLeft : s.wrapperEl.offsetTop : 0;
  for (let a = 0; a < r.length; a += 1)
    r[a].swiperSlideOffset = (s.isHorizontal() ? r[a].offsetLeft : r[a].offsetTop) - n - s.cssOverflowAdjustment();
}
const fc = (s, r, n) => {
  r && !s.classList.contains(n) ? s.classList.add(n) : !r && s.classList.contains(n) && s.classList.remove(n);
};
function iA(s) {
  s === void 0 && (s = this && this.translate || 0);
  const r = this, n = r.params, {
    slides: a,
    rtlTranslate: c,
    snapGrid: o
  } = r;
  if (a.length === 0) return;
  typeof a[0].swiperSlideOffset > "u" && r.updateSlidesOffset();
  let d = -s;
  c && (d = s), r.visibleSlidesIndexes = [], r.visibleSlides = [];
  let p = n.spaceBetween;
  typeof p == "string" && p.indexOf("%") >= 0 ? p = parseFloat(p.replace("%", "")) / 100 * r.size : typeof p == "string" && (p = parseFloat(p));
  for (let f = 0; f < a.length; f += 1) {
    const b = a[f];
    let m = b.swiperSlideOffset;
    n.cssMode && n.centeredSlides && (m -= a[0].swiperSlideOffset);
    const S = (d + (n.centeredSlides ? r.minTranslate() : 0) - m) / (b.swiperSlideSize + p), A = (d - o[0] + (n.centeredSlides ? r.minTranslate() : 0) - m) / (b.swiperSlideSize + p), y = -(d - m), _ = y + r.slidesSizesGrid[f], O = y >= 0 && y <= r.size - r.slidesSizesGrid[f], G = y >= 0 && y < r.size - 1 || _ > 1 && _ <= r.size || y <= 0 && _ >= r.size;
    G && (r.visibleSlides.push(b), r.visibleSlidesIndexes.push(f)), fc(b, G, n.slideVisibleClass), fc(b, O, n.slideFullyVisibleClass), b.progress = c ? -S : S, b.originalProgress = c ? -A : A;
  }
}
function sA(s) {
  const r = this;
  if (typeof s > "u") {
    const m = r.rtlTranslate ? -1 : 1;
    s = r && r.translate && r.translate * m || 0;
  }
  const n = r.params, a = r.maxTranslate() - r.minTranslate();
  let {
    progress: c,
    isBeginning: o,
    isEnd: d,
    progressLoop: p
  } = r;
  const f = o, b = d;
  if (a === 0)
    c = 0, o = !0, d = !0;
  else {
    c = (s - r.minTranslate()) / a;
    const m = Math.abs(s - r.minTranslate()) < 1, S = Math.abs(s - r.maxTranslate()) < 1;
    o = m || c <= 0, d = S || c >= 1, m && (c = 0), S && (c = 1);
  }
  if (n.loop) {
    const m = r.getSlideIndexByData(0), S = r.getSlideIndexByData(r.slides.length - 1), A = r.slidesGrid[m], y = r.slidesGrid[S], _ = r.slidesGrid[r.slidesGrid.length - 1], O = Math.abs(s);
    O >= A ? p = (O - A) / _ : p = (O + _ - y) / _, p > 1 && (p -= 1);
  }
  Object.assign(r, {
    progress: c,
    progressLoop: p,
    isBeginning: o,
    isEnd: d
  }), (n.watchSlidesProgress || n.centeredSlides && n.autoHeight) && r.updateSlidesProgress(s), o && !f && r.emit("reachBeginning toEdge"), d && !b && r.emit("reachEnd toEdge"), (f && !o || b && !d) && r.emit("fromEdge"), r.emit("progress", c);
}
const va = (s, r, n) => {
  r && !s.classList.contains(n) ? s.classList.add(n) : !r && s.classList.contains(n) && s.classList.remove(n);
};
function aA() {
  const s = this, {
    slides: r,
    params: n,
    slidesEl: a,
    activeIndex: c
  } = s, o = s.virtual && n.virtual.enabled, d = s.grid && n.grid && n.grid.rows > 1, p = (S) => hn(a, `.${n.slideClass}${S}, swiper-slide${S}`)[0];
  let f, b, m;
  if (o)
    if (n.loop) {
      let S = c - s.virtual.slidesBefore;
      S < 0 && (S = s.virtual.slides.length + S), S >= s.virtual.slides.length && (S -= s.virtual.slides.length), f = p(`[data-swiper-slide-index="${S}"]`);
    } else
      f = p(`[data-swiper-slide-index="${c}"]`);
  else
    d ? (f = r.filter((S) => S.column === c)[0], m = r.filter((S) => S.column === c + 1)[0], b = r.filter((S) => S.column === c - 1)[0]) : f = r[c];
  f && (d || (m = Qv(f, `.${n.slideClass}, swiper-slide`)[0], n.loop && !m && (m = r[0]), b = jv(f, `.${n.slideClass}, swiper-slide`)[0], n.loop && !b === 0 && (b = r[r.length - 1]))), r.forEach((S) => {
    va(S, S === f, n.slideActiveClass), va(S, S === m, n.slideNextClass), va(S, S === b, n.slidePrevClass);
  }), s.emitSlidesClasses();
}
const Ui = (s, r) => {
  if (!s || s.destroyed || !s.params) return;
  const n = () => s.isElement ? "swiper-slide" : `.${s.params.slideClass}`, a = r.closest(n());
  if (a) {
    let c = a.querySelector(`.${s.params.lazyPreloaderClass}`);
    !c && s.isElement && (a.shadowRoot ? c = a.shadowRoot.querySelector(`.${s.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      a.shadowRoot && (c = a.shadowRoot.querySelector(`.${s.params.lazyPreloaderClass}`), c && c.remove());
    })), c && c.remove();
  }
}, Aa = (s, r) => {
  if (!s.slides[r]) return;
  const n = s.slides[r].querySelector('[loading="lazy"]');
  n && n.removeAttribute("loading");
}, Ta = (s) => {
  if (!s || s.destroyed || !s.params) return;
  let r = s.params.lazyPreloadPrevNext;
  const n = s.slides.length;
  if (!n || !r || r < 0) return;
  r = Math.min(r, n);
  const a = s.params.slidesPerView === "auto" ? s.slidesPerViewDynamic() : Math.ceil(s.params.slidesPerView), c = s.activeIndex;
  if (s.params.grid && s.params.grid.rows > 1) {
    const d = c, p = [d - r];
    p.push(...Array.from({
      length: r
    }).map((f, b) => d + a + b)), s.slides.forEach((f, b) => {
      p.includes(f.column) && Aa(s, b);
    });
    return;
  }
  const o = c + a - 1;
  if (s.params.rewind || s.params.loop)
    for (let d = c - r; d <= o + r; d += 1) {
      const p = (d % n + n) % n;
      (p < c || p > o) && Aa(s, p);
    }
  else
    for (let d = Math.max(c - r, 0); d <= Math.min(o + r, n - 1); d += 1)
      d !== c && (d > o || d < c) && Aa(s, d);
};
function lA(s) {
  const {
    slidesGrid: r,
    params: n
  } = s, a = s.rtlTranslate ? s.translate : -s.translate;
  let c;
  for (let o = 0; o < r.length; o += 1)
    typeof r[o + 1] < "u" ? a >= r[o] && a < r[o + 1] - (r[o + 1] - r[o]) / 2 ? c = o : a >= r[o] && a < r[o + 1] && (c = o + 1) : a >= r[o] && (c = o);
  return n.normalizeSlideIndex && (c < 0 || typeof c > "u") && (c = 0), c;
}
function oA(s) {
  const r = this, n = r.rtlTranslate ? r.translate : -r.translate, {
    snapGrid: a,
    params: c,
    activeIndex: o,
    realIndex: d,
    snapIndex: p
  } = r;
  let f = s, b;
  const m = (y) => {
    let _ = y - r.virtual.slidesBefore;
    return _ < 0 && (_ = r.virtual.slides.length + _), _ >= r.virtual.slides.length && (_ -= r.virtual.slides.length), _;
  };
  if (typeof f > "u" && (f = lA(r)), a.indexOf(n) >= 0)
    b = a.indexOf(n);
  else {
    const y = Math.min(c.slidesPerGroupSkip, f);
    b = y + Math.floor((f - y) / c.slidesPerGroup);
  }
  if (b >= a.length && (b = a.length - 1), f === o && !r.params.loop) {
    b !== p && (r.snapIndex = b, r.emit("snapIndexChange"));
    return;
  }
  if (f === o && r.params.loop && r.virtual && r.params.virtual.enabled) {
    r.realIndex = m(f);
    return;
  }
  const S = r.grid && c.grid && c.grid.rows > 1;
  let A;
  if (r.virtual && c.virtual.enabled && c.loop)
    A = m(f);
  else if (S) {
    const y = r.slides.filter((O) => O.column === f)[0];
    let _ = parseInt(y.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(_) && (_ = Math.max(r.slides.indexOf(y), 0)), A = Math.floor(_ / c.grid.rows);
  } else if (r.slides[f]) {
    const y = r.slides[f].getAttribute("data-swiper-slide-index");
    y ? A = parseInt(y, 10) : A = f;
  } else
    A = f;
  Object.assign(r, {
    previousSnapIndex: p,
    snapIndex: b,
    previousRealIndex: d,
    realIndex: A,
    previousIndex: o,
    activeIndex: f
  }), r.initialized && Ta(r), r.emit("activeIndexChange"), r.emit("snapIndexChange"), (r.initialized || r.params.runCallbacksOnInit) && (d !== A && r.emit("realIndexChange"), r.emit("slideChange"));
}
function cA(s, r) {
  const n = this, a = n.params;
  let c = s.closest(`.${a.slideClass}, swiper-slide`);
  !c && n.isElement && r && r.length > 1 && r.includes(s) && [...r.slice(r.indexOf(s) + 1, r.length)].forEach((p) => {
    !c && p.matches && p.matches(`.${a.slideClass}, swiper-slide`) && (c = p);
  });
  let o = !1, d;
  if (c) {
    for (let p = 0; p < n.slides.length; p += 1)
      if (n.slides[p] === c) {
        o = !0, d = p;
        break;
      }
  }
  if (c && o)
    n.clickedSlide = c, n.virtual && n.params.virtual.enabled ? n.clickedIndex = parseInt(c.getAttribute("data-swiper-slide-index"), 10) : n.clickedIndex = d;
  else {
    n.clickedSlide = void 0, n.clickedIndex = void 0;
    return;
  }
  a.slideToClickedSlide && n.clickedIndex !== void 0 && n.clickedIndex !== n.activeIndex && n.slideToClickedSlide();
}
var uA = {
  updateSize: eA,
  updateSlides: tA,
  updateAutoHeight: nA,
  updateSlidesOffset: rA,
  updateSlidesProgress: iA,
  updateProgress: sA,
  updateSlidesClasses: aA,
  updateActiveIndex: oA,
  updateClickedSlide: cA
};
function fA(s) {
  s === void 0 && (s = this.isHorizontal() ? "x" : "y");
  const r = this, {
    params: n,
    rtlTranslate: a,
    translate: c,
    wrapperEl: o
  } = r;
  if (n.virtualTranslate)
    return a ? -c : c;
  if (n.cssMode)
    return c;
  let d = Vv(o, s);
  return d += r.cssOverflowAdjustment(), a && (d = -d), d || 0;
}
function dA(s, r) {
  const n = this, {
    rtlTranslate: a,
    params: c,
    wrapperEl: o,
    progress: d
  } = n;
  let p = 0, f = 0;
  const b = 0;
  n.isHorizontal() ? p = a ? -s : s : f = s, c.roundLengths && (p = Math.floor(p), f = Math.floor(f)), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? p : f, c.cssMode ? o[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -p : -f : c.virtualTranslate || (n.isHorizontal() ? p -= n.cssOverflowAdjustment() : f -= n.cssOverflowAdjustment(), o.style.transform = `translate3d(${p}px, ${f}px, ${b}px)`);
  let m;
  const S = n.maxTranslate() - n.minTranslate();
  S === 0 ? m = 0 : m = (s - n.minTranslate()) / S, m !== d && n.updateProgress(s), n.emit("setTranslate", n.translate, r);
}
function gA() {
  return -this.snapGrid[0];
}
function pA() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function hA(s, r, n, a, c) {
  s === void 0 && (s = 0), r === void 0 && (r = this.params.speed), n === void 0 && (n = !0), a === void 0 && (a = !0);
  const o = this, {
    params: d,
    wrapperEl: p
  } = o;
  if (o.animating && d.preventInteractionOnTransition)
    return !1;
  const f = o.minTranslate(), b = o.maxTranslate();
  let m;
  if (a && s > f ? m = f : a && s < b ? m = b : m = s, o.updateProgress(m), d.cssMode) {
    const S = o.isHorizontal();
    if (r === 0)
      p[S ? "scrollLeft" : "scrollTop"] = -m;
    else {
      if (!o.support.smoothScroll)
        return kc({
          swiper: o,
          targetPosition: -m,
          side: S ? "left" : "top"
        }), !0;
      p.scrollTo({
        [S ? "left" : "top"]: -m,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return r === 0 ? (o.setTransition(0), o.setTranslate(m), n && (o.emit("beforeTransitionStart", r, c), o.emit("transitionEnd"))) : (o.setTransition(r), o.setTranslate(m), n && (o.emit("beforeTransitionStart", r, c), o.emit("transitionStart")), o.animating || (o.animating = !0, o.onTranslateToWrapperTransitionEnd || (o.onTranslateToWrapperTransitionEnd = function(A) {
    !o || o.destroyed || A.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.onTranslateToWrapperTransitionEnd = null, delete o.onTranslateToWrapperTransitionEnd, o.animating = !1, n && o.emit("transitionEnd"));
  }), o.wrapperEl.addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd))), !0;
}
var mA = {
  getTranslate: fA,
  setTranslate: dA,
  minTranslate: gA,
  maxTranslate: pA,
  translateTo: hA
};
function vA(s, r) {
  const n = this;
  n.params.cssMode || (n.wrapperEl.style.transitionDuration = `${s}ms`, n.wrapperEl.style.transitionDelay = s === 0 ? "0ms" : ""), n.emit("setTransition", s, r);
}
function Hc(s) {
  let {
    swiper: r,
    runCallbacks: n,
    direction: a,
    step: c
  } = s;
  const {
    activeIndex: o,
    previousIndex: d
  } = r;
  let p = a;
  if (p || (o > d ? p = "next" : o < d ? p = "prev" : p = "reset"), r.emit(`transition${c}`), n && o !== d) {
    if (p === "reset") {
      r.emit(`slideResetTransition${c}`);
      return;
    }
    r.emit(`slideChangeTransition${c}`), p === "next" ? r.emit(`slideNextTransition${c}`) : r.emit(`slidePrevTransition${c}`);
  }
}
function AA(s, r) {
  s === void 0 && (s = !0);
  const n = this, {
    params: a
  } = n;
  a.cssMode || (a.autoHeight && n.updateAutoHeight(), Hc({
    swiper: n,
    runCallbacks: s,
    direction: r,
    step: "Start"
  }));
}
function wA(s, r) {
  s === void 0 && (s = !0);
  const n = this, {
    params: a
  } = n;
  n.animating = !1, !a.cssMode && (n.setTransition(0), Hc({
    swiper: n,
    runCallbacks: s,
    direction: r,
    step: "End"
  }));
}
var bA = {
  setTransition: vA,
  transitionStart: AA,
  transitionEnd: wA
};
function xA(s, r, n, a, c) {
  s === void 0 && (s = 0), n === void 0 && (n = !0), typeof s == "string" && (s = parseInt(s, 10));
  const o = this;
  let d = s;
  d < 0 && (d = 0);
  const {
    params: p,
    snapGrid: f,
    slidesGrid: b,
    previousIndex: m,
    activeIndex: S,
    rtlTranslate: A,
    wrapperEl: y,
    enabled: _
  } = o;
  if (!_ && !a && !c || o.destroyed || o.animating && p.preventInteractionOnTransition)
    return !1;
  typeof r > "u" && (r = o.params.speed);
  const O = Math.min(o.params.slidesPerGroupSkip, d);
  let G = O + Math.floor((d - O) / o.params.slidesPerGroup);
  G >= f.length && (G = f.length - 1);
  const M = -f[G];
  if (p.normalizeSlideIndex)
    for (let P = 0; P < b.length; P += 1) {
      const k = -Math.floor(M * 100), q = Math.floor(b[P] * 100), W = Math.floor(b[P + 1] * 100);
      typeof b[P + 1] < "u" ? k >= q && k < W - (W - q) / 2 ? d = P : k >= q && k < W && (d = P + 1) : k >= q && (d = P);
    }
  if (o.initialized && d !== S && (!o.allowSlideNext && (A ? M > o.translate && M > o.minTranslate() : M < o.translate && M < o.minTranslate()) || !o.allowSlidePrev && M > o.translate && M > o.maxTranslate() && (S || 0) !== d))
    return !1;
  d !== (m || 0) && n && o.emit("beforeSlideChangeStart"), o.updateProgress(M);
  let E;
  d > S ? E = "next" : d < S ? E = "prev" : E = "reset";
  const T = o.virtual && o.params.virtual.enabled;
  if (!(T && c) && (A && -M === o.translate || !A && M === o.translate))
    return o.updateActiveIndex(d), p.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), p.effect !== "slide" && o.setTranslate(M), E !== "reset" && (o.transitionStart(n, E), o.transitionEnd(n, E)), !1;
  if (p.cssMode) {
    const P = o.isHorizontal(), k = A ? M : -M;
    if (r === 0)
      T && (o.wrapperEl.style.scrollSnapType = "none", o._immediateVirtual = !0), T && !o._cssModeVirtualInitialSet && o.params.initialSlide > 0 ? (o._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        y[P ? "scrollLeft" : "scrollTop"] = k;
      })) : y[P ? "scrollLeft" : "scrollTop"] = k, T && requestAnimationFrame(() => {
        o.wrapperEl.style.scrollSnapType = "", o._immediateVirtual = !1;
      });
    else {
      if (!o.support.smoothScroll)
        return kc({
          swiper: o,
          targetPosition: k,
          side: P ? "left" : "top"
        }), !0;
      y.scrollTo({
        [P ? "left" : "top"]: k,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return o.setTransition(r), o.setTranslate(M), o.updateActiveIndex(d), o.updateSlidesClasses(), o.emit("beforeTransitionStart", r, a), o.transitionStart(n, E), r === 0 ? o.transitionEnd(n, E) : o.animating || (o.animating = !0, o.onSlideToWrapperTransitionEnd || (o.onSlideToWrapperTransitionEnd = function(k) {
    !o || o.destroyed || k.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.onSlideToWrapperTransitionEnd = null, delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(n, E));
  }), o.wrapperEl.addEventListener("transitionend", o.onSlideToWrapperTransitionEnd)), !0;
}
function SA(s, r, n, a) {
  s === void 0 && (s = 0), n === void 0 && (n = !0), typeof s == "string" && (s = parseInt(s, 10));
  const c = this;
  if (c.destroyed) return;
  typeof r > "u" && (r = c.params.speed);
  const o = c.grid && c.params.grid && c.params.grid.rows > 1;
  let d = s;
  if (c.params.loop)
    if (c.virtual && c.params.virtual.enabled)
      d = d + c.virtual.slidesBefore;
    else {
      let p;
      if (o) {
        const A = d * c.params.grid.rows;
        p = c.slides.filter((y) => y.getAttribute("data-swiper-slide-index") * 1 === A)[0].column;
      } else
        p = c.getSlideIndexByData(d);
      const f = o ? Math.ceil(c.slides.length / c.params.grid.rows) : c.slides.length, {
        centeredSlides: b
      } = c.params;
      let m = c.params.slidesPerView;
      m === "auto" ? m = c.slidesPerViewDynamic() : (m = Math.ceil(parseFloat(c.params.slidesPerView, 10)), b && m % 2 === 0 && (m = m + 1));
      let S = f - p < m;
      if (b && (S = S || p < Math.ceil(m / 2)), a && b && c.params.slidesPerView !== "auto" && !o && (S = !1), S) {
        const A = b ? p < c.activeIndex ? "prev" : "next" : p - c.activeIndex - 1 < c.params.slidesPerView ? "next" : "prev";
        c.loopFix({
          direction: A,
          slideTo: !0,
          activeSlideIndex: A === "next" ? p + 1 : p - f + 1,
          slideRealIndex: A === "next" ? c.realIndex : void 0
        });
      }
      if (o) {
        const A = d * c.params.grid.rows;
        d = c.slides.filter((y) => y.getAttribute("data-swiper-slide-index") * 1 === A)[0].column;
      } else
        d = c.getSlideIndexByData(d);
    }
  return requestAnimationFrame(() => {
    c.slideTo(d, r, n, a);
  }), c;
}
function yA(s, r, n) {
  r === void 0 && (r = !0);
  const a = this, {
    enabled: c,
    params: o,
    animating: d
  } = a;
  if (!c || a.destroyed) return a;
  typeof s > "u" && (s = a.params.speed);
  let p = o.slidesPerGroup;
  o.slidesPerView === "auto" && o.slidesPerGroup === 1 && o.slidesPerGroupAuto && (p = Math.max(a.slidesPerViewDynamic("current", !0), 1));
  const f = a.activeIndex < o.slidesPerGroupSkip ? 1 : p, b = a.virtual && o.virtual.enabled;
  if (o.loop) {
    if (d && !b && o.loopPreventsSliding) return !1;
    if (a.loopFix({
      direction: "next"
    }), a._clientLeft = a.wrapperEl.clientLeft, a.activeIndex === a.slides.length - 1 && o.cssMode)
      return requestAnimationFrame(() => {
        a.slideTo(a.activeIndex + f, s, r, n);
      }), !0;
  }
  return o.rewind && a.isEnd ? a.slideTo(0, s, r, n) : a.slideTo(a.activeIndex + f, s, r, n);
}
function CA(s, r, n) {
  r === void 0 && (r = !0);
  const a = this, {
    params: c,
    snapGrid: o,
    slidesGrid: d,
    rtlTranslate: p,
    enabled: f,
    animating: b
  } = a;
  if (!f || a.destroyed) return a;
  typeof s > "u" && (s = a.params.speed);
  const m = a.virtual && c.virtual.enabled;
  if (c.loop) {
    if (b && !m && c.loopPreventsSliding) return !1;
    a.loopFix({
      direction: "prev"
    }), a._clientLeft = a.wrapperEl.clientLeft;
  }
  const S = p ? a.translate : -a.translate;
  function A(M) {
    return M < 0 ? -Math.floor(Math.abs(M)) : Math.floor(M);
  }
  const y = A(S), _ = o.map((M) => A(M));
  let O = o[_.indexOf(y) - 1];
  if (typeof O > "u" && c.cssMode) {
    let M;
    o.forEach((E, T) => {
      y >= E && (M = T);
    }), typeof M < "u" && (O = o[M > 0 ? M - 1 : M]);
  }
  let G = 0;
  if (typeof O < "u" && (G = d.indexOf(O), G < 0 && (G = a.activeIndex - 1), c.slidesPerView === "auto" && c.slidesPerGroup === 1 && c.slidesPerGroupAuto && (G = G - a.slidesPerViewDynamic("previous", !0) + 1, G = Math.max(G, 0))), c.rewind && a.isBeginning) {
    const M = a.params.virtual && a.params.virtual.enabled && a.virtual ? a.virtual.slides.length - 1 : a.slides.length - 1;
    return a.slideTo(M, s, r, n);
  } else if (c.loop && a.activeIndex === 0 && c.cssMode)
    return requestAnimationFrame(() => {
      a.slideTo(G, s, r, n);
    }), !0;
  return a.slideTo(G, s, r, n);
}
function EA(s, r, n) {
  r === void 0 && (r = !0);
  const a = this;
  if (!a.destroyed)
    return typeof s > "u" && (s = a.params.speed), a.slideTo(a.activeIndex, s, r, n);
}
function TA(s, r, n, a) {
  r === void 0 && (r = !0), a === void 0 && (a = 0.5);
  const c = this;
  if (c.destroyed) return;
  typeof s > "u" && (s = c.params.speed);
  let o = c.activeIndex;
  const d = Math.min(c.params.slidesPerGroupSkip, o), p = d + Math.floor((o - d) / c.params.slidesPerGroup), f = c.rtlTranslate ? c.translate : -c.translate;
  if (f >= c.snapGrid[p]) {
    const b = c.snapGrid[p], m = c.snapGrid[p + 1];
    f - b > (m - b) * a && (o += c.params.slidesPerGroup);
  } else {
    const b = c.snapGrid[p - 1], m = c.snapGrid[p];
    f - b <= (m - b) * a && (o -= c.params.slidesPerGroup);
  }
  return o = Math.max(o, 0), o = Math.min(o, c.slidesGrid.length - 1), c.slideTo(o, s, r, n);
}
function LA() {
  const s = this;
  if (s.destroyed) return;
  const {
    params: r,
    slidesEl: n
  } = s, a = r.slidesPerView === "auto" ? s.slidesPerViewDynamic() : r.slidesPerView;
  let c = s.clickedIndex, o;
  const d = s.isElement ? "swiper-slide" : `.${r.slideClass}`;
  if (r.loop) {
    if (s.animating) return;
    o = parseInt(s.clickedSlide.getAttribute("data-swiper-slide-index"), 10), r.centeredSlides ? c < s.loopedSlides - a / 2 || c > s.slides.length - s.loopedSlides + a / 2 ? (s.loopFix(), c = s.getSlideIndex(hn(n, `${d}[data-swiper-slide-index="${o}"]`)[0]), Ca(() => {
      s.slideTo(c);
    })) : s.slideTo(c) : c > s.slides.length - a ? (s.loopFix(), c = s.getSlideIndex(hn(n, `${d}[data-swiper-slide-index="${o}"]`)[0]), Ca(() => {
      s.slideTo(c);
    })) : s.slideTo(c);
  } else
    s.slideTo(c);
}
var IA = {
  slideTo: xA,
  slideToLoop: SA,
  slideNext: yA,
  slidePrev: CA,
  slideReset: EA,
  slideToClosest: TA,
  slideToClickedSlide: LA
};
function BA(s) {
  const r = this, {
    params: n,
    slidesEl: a
  } = r;
  if (!n.loop || r.virtual && r.params.virtual.enabled) return;
  const c = () => {
    hn(a, `.${n.slideClass}, swiper-slide`).forEach((S, A) => {
      S.setAttribute("data-swiper-slide-index", A);
    });
  }, o = r.grid && n.grid && n.grid.rows > 1, d = n.slidesPerGroup * (o ? n.grid.rows : 1), p = r.slides.length % d !== 0, f = o && r.slides.length % n.grid.rows !== 0, b = (m) => {
    for (let S = 0; S < m; S += 1) {
      const A = r.isElement ? Qi("swiper-slide", [n.slideBlankClass]) : Qi("div", [n.slideClass, n.slideBlankClass]);
      r.slidesEl.append(A);
    }
  };
  if (p) {
    if (n.loopAddBlankSlides) {
      const m = d - r.slides.length % d;
      b(m), r.recalcSlides(), r.updateSlides();
    } else
      ji("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    c();
  } else if (f) {
    if (n.loopAddBlankSlides) {
      const m = n.grid.rows - r.slides.length % n.grid.rows;
      b(m), r.recalcSlides(), r.updateSlides();
    } else
      ji("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    c();
  } else
    c();
  r.loopFix({
    slideRealIndex: s,
    direction: n.centeredSlides ? void 0 : "next"
  });
}
function MA(s) {
  let {
    slideRealIndex: r,
    slideTo: n = !0,
    direction: a,
    setTranslate: c,
    activeSlideIndex: o,
    byController: d,
    byMousewheel: p
  } = s === void 0 ? {} : s;
  const f = this;
  if (!f.params.loop) return;
  f.emit("beforeLoopFix");
  const {
    slides: b,
    allowSlidePrev: m,
    allowSlideNext: S,
    slidesEl: A,
    params: y
  } = f, {
    centeredSlides: _
  } = y;
  if (f.allowSlidePrev = !0, f.allowSlideNext = !0, f.virtual && y.virtual.enabled) {
    n && (!y.centeredSlides && f.snapIndex === 0 ? f.slideTo(f.virtual.slides.length, 0, !1, !0) : y.centeredSlides && f.snapIndex < y.slidesPerView ? f.slideTo(f.virtual.slides.length + f.snapIndex, 0, !1, !0) : f.snapIndex === f.snapGrid.length - 1 && f.slideTo(f.virtual.slidesBefore, 0, !1, !0)), f.allowSlidePrev = m, f.allowSlideNext = S, f.emit("loopFix");
    return;
  }
  let O = y.slidesPerView;
  O === "auto" ? O = f.slidesPerViewDynamic() : (O = Math.ceil(parseFloat(y.slidesPerView, 10)), _ && O % 2 === 0 && (O = O + 1));
  const G = y.slidesPerGroupAuto ? O : y.slidesPerGroup;
  let M = G;
  M % G !== 0 && (M += G - M % G), M += y.loopAdditionalSlides, f.loopedSlides = M;
  const E = f.grid && y.grid && y.grid.rows > 1;
  b.length < O + M ? ji("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : E && y.grid.fill === "row" && ji("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const T = [], L = [];
  let P = f.activeIndex;
  typeof o > "u" ? o = f.getSlideIndex(b.filter((j) => j.classList.contains(y.slideActiveClass))[0]) : P = o;
  const k = a === "next" || !a, q = a === "prev" || !a;
  let W = 0, N = 0;
  const V = E ? Math.ceil(b.length / y.grid.rows) : b.length, Z = (E ? b[o].column : o) + (_ && typeof c > "u" ? -O / 2 + 0.5 : 0);
  if (Z < M) {
    W = Math.max(M - Z, G);
    for (let j = 0; j < M - Z; j += 1) {
      const te = j - Math.floor(j / V) * V;
      if (E) {
        const re = V - te - 1;
        for (let ue = b.length - 1; ue >= 0; ue -= 1)
          b[ue].column === re && T.push(ue);
      } else
        T.push(V - te - 1);
    }
  } else if (Z + O > V - M) {
    N = Math.max(Z - (V - M * 2), G);
    for (let j = 0; j < N; j += 1) {
      const te = j - Math.floor(j / V) * V;
      E ? b.forEach((re, ue) => {
        re.column === te && L.push(ue);
      }) : L.push(te);
    }
  }
  if (f.__preventObserver__ = !0, requestAnimationFrame(() => {
    f.__preventObserver__ = !1;
  }), q && T.forEach((j) => {
    b[j].swiperLoopMoveDOM = !0, A.prepend(b[j]), b[j].swiperLoopMoveDOM = !1;
  }), k && L.forEach((j) => {
    b[j].swiperLoopMoveDOM = !0, A.append(b[j]), b[j].swiperLoopMoveDOM = !1;
  }), f.recalcSlides(), y.slidesPerView === "auto" ? f.updateSlides() : E && (T.length > 0 && q || L.length > 0 && k) && f.slides.forEach((j, te) => {
    f.grid.updateSlide(te, j, f.slides);
  }), y.watchSlidesProgress && f.updateSlidesOffset(), n) {
    if (T.length > 0 && q) {
      if (typeof r > "u") {
        const j = f.slidesGrid[P], re = f.slidesGrid[P + W] - j;
        p ? f.setTranslate(f.translate - re) : (f.slideTo(P + Math.ceil(W), 0, !1, !0), c && (f.touchEventsData.startTranslate = f.touchEventsData.startTranslate - re, f.touchEventsData.currentTranslate = f.touchEventsData.currentTranslate - re));
      } else if (c) {
        const j = E ? T.length / y.grid.rows : T.length;
        f.slideTo(f.activeIndex + j, 0, !1, !0), f.touchEventsData.currentTranslate = f.translate;
      }
    } else if (L.length > 0 && k)
      if (typeof r > "u") {
        const j = f.slidesGrid[P], re = f.slidesGrid[P - N] - j;
        p ? f.setTranslate(f.translate - re) : (f.slideTo(P - N, 0, !1, !0), c && (f.touchEventsData.startTranslate = f.touchEventsData.startTranslate - re, f.touchEventsData.currentTranslate = f.touchEventsData.currentTranslate - re));
      } else {
        const j = E ? L.length / y.grid.rows : L.length;
        f.slideTo(f.activeIndex - j, 0, !1, !0);
      }
  }
  if (f.allowSlidePrev = m, f.allowSlideNext = S, f.controller && f.controller.control && !d) {
    const j = {
      slideRealIndex: r,
      direction: a,
      setTranslate: c,
      activeSlideIndex: o,
      byController: !0
    };
    Array.isArray(f.controller.control) ? f.controller.control.forEach((te) => {
      !te.destroyed && te.params.loop && te.loopFix({
        ...j,
        slideTo: te.params.slidesPerView === y.slidesPerView ? n : !1
      });
    }) : f.controller.control instanceof f.constructor && f.controller.control.params.loop && f.controller.control.loopFix({
      ...j,
      slideTo: f.controller.control.params.slidesPerView === y.slidesPerView ? n : !1
    });
  }
  f.emit("loopFix");
}
function PA() {
  const s = this, {
    params: r,
    slidesEl: n
  } = s;
  if (!r.loop || s.virtual && s.params.virtual.enabled) return;
  s.recalcSlides();
  const a = [];
  s.slides.forEach((c) => {
    const o = typeof c.swiperSlideIndex > "u" ? c.getAttribute("data-swiper-slide-index") * 1 : c.swiperSlideIndex;
    a[o] = c;
  }), s.slides.forEach((c) => {
    c.removeAttribute("data-swiper-slide-index");
  }), a.forEach((c) => {
    n.append(c);
  }), s.recalcSlides(), s.slideTo(s.realIndex, 0);
}
var RA = {
  loopCreate: BA,
  loopFix: MA,
  loopDestroy: PA
};
function _A(s) {
  const r = this;
  if (!r.params.simulateTouch || r.params.watchOverflow && r.isLocked || r.params.cssMode) return;
  const n = r.params.touchEventsTarget === "container" ? r.el : r.wrapperEl;
  r.isElement && (r.__preventObserver__ = !0), n.style.cursor = "move", n.style.cursor = s ? "grabbing" : "grab", r.isElement && requestAnimationFrame(() => {
    r.__preventObserver__ = !1;
  });
}
function OA() {
  const s = this;
  s.params.watchOverflow && s.isLocked || s.params.cssMode || (s.isElement && (s.__preventObserver__ = !0), s[s.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", s.isElement && requestAnimationFrame(() => {
    s.__preventObserver__ = !1;
  }));
}
var NA = {
  setGrabCursor: _A,
  unsetGrabCursor: OA
};
function DA(s, r) {
  r === void 0 && (r = this);
  function n(a) {
    if (!a || a === xr() || a === qt()) return null;
    a.assignedSlot && (a = a.assignedSlot);
    const c = a.closest(s);
    return !c && !a.getRootNode ? null : c || n(a.getRootNode().host);
  }
  return n(r);
}
function dc(s, r, n) {
  const a = qt(), {
    params: c
  } = s, o = c.edgeSwipeDetection, d = c.edgeSwipeThreshold;
  return o && (n <= d || n >= a.innerWidth - d) ? o === "prevent" ? (r.preventDefault(), !0) : !1 : !0;
}
function kA(s) {
  const r = this, n = xr();
  let a = s;
  a.originalEvent && (a = a.originalEvent);
  const c = r.touchEventsData;
  if (a.type === "pointerdown") {
    if (c.pointerId !== null && c.pointerId !== a.pointerId)
      return;
    c.pointerId = a.pointerId;
  } else a.type === "touchstart" && a.targetTouches.length === 1 && (c.touchId = a.targetTouches[0].identifier);
  if (a.type === "touchstart") {
    dc(r, a, a.targetTouches[0].pageX);
    return;
  }
  const {
    params: o,
    touches: d,
    enabled: p
  } = r;
  if (!p || !o.simulateTouch && a.pointerType === "mouse" || r.animating && o.preventInteractionOnTransition)
    return;
  !r.animating && o.cssMode && o.loop && r.loopFix();
  let f = a.target;
  if (o.touchEventsTarget === "wrapper" && !Wv(f, r.wrapperEl) || "which" in a && a.which === 3 || "button" in a && a.button > 0 || c.isTouched && c.isMoved) return;
  const b = !!o.noSwipingClass && o.noSwipingClass !== "", m = a.composedPath ? a.composedPath() : a.path;
  b && a.target && a.target.shadowRoot && m && (f = m[0]);
  const S = o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`, A = !!(a.target && a.target.shadowRoot);
  if (o.noSwiping && (A ? DA(S, f) : f.closest(S))) {
    r.allowClick = !0;
    return;
  }
  if (o.swipeHandler && !f.closest(o.swipeHandler))
    return;
  d.currentX = a.pageX, d.currentY = a.pageY;
  const y = d.currentX, _ = d.currentY;
  if (!dc(r, a, y))
    return;
  Object.assign(c, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), d.startX = y, d.startY = _, c.touchStartTime = Wi(), r.allowClick = !0, r.updateSize(), r.swipeDirection = void 0, o.threshold > 0 && (c.allowThresholdMove = !1);
  let O = !0;
  f.matches(c.focusableElements) && (O = !1, f.nodeName === "SELECT" && (c.isTouched = !1)), n.activeElement && n.activeElement.matches(c.focusableElements) && n.activeElement !== f && (a.pointerType === "mouse" || a.pointerType !== "mouse" && !f.matches(c.focusableElements)) && n.activeElement.blur();
  const G = O && r.allowTouchMove && o.touchStartPreventDefault;
  (o.touchStartForcePreventDefault || G) && !f.isContentEditable && a.preventDefault(), o.freeMode && o.freeMode.enabled && r.freeMode && r.animating && !o.cssMode && r.freeMode.onTouchStart(), r.emit("touchStart", a);
}
function FA(s) {
  const r = xr(), n = this, a = n.touchEventsData, {
    params: c,
    touches: o,
    rtlTranslate: d,
    enabled: p
  } = n;
  if (!p || !c.simulateTouch && s.pointerType === "mouse") return;
  let f = s;
  if (f.originalEvent && (f = f.originalEvent), f.type === "pointermove" && (a.touchId !== null || f.pointerId !== a.pointerId))
    return;
  let b;
  if (f.type === "touchmove") {
    if (b = [...f.changedTouches].filter((k) => k.identifier === a.touchId)[0], !b || b.identifier !== a.touchId) return;
  } else
    b = f;
  if (!a.isTouched) {
    a.startMoving && a.isScrolling && n.emit("touchMoveOpposite", f);
    return;
  }
  const m = b.pageX, S = b.pageY;
  if (f.preventedByNestedSwiper) {
    o.startX = m, o.startY = S;
    return;
  }
  if (!n.allowTouchMove) {
    f.target.matches(a.focusableElements) || (n.allowClick = !1), a.isTouched && (Object.assign(o, {
      startX: m,
      startY: S,
      currentX: m,
      currentY: S
    }), a.touchStartTime = Wi());
    return;
  }
  if (c.touchReleaseOnEdges && !c.loop) {
    if (n.isVertical()) {
      if (S < o.startY && n.translate <= n.maxTranslate() || S > o.startY && n.translate >= n.minTranslate()) {
        a.isTouched = !1, a.isMoved = !1;
        return;
      }
    } else if (m < o.startX && n.translate <= n.maxTranslate() || m > o.startX && n.translate >= n.minTranslate())
      return;
  }
  if (r.activeElement && r.activeElement.matches(a.focusableElements) && r.activeElement !== f.target && f.pointerType !== "mouse" && r.activeElement.blur(), r.activeElement && f.target === r.activeElement && f.target.matches(a.focusableElements)) {
    a.isMoved = !0, n.allowClick = !1;
    return;
  }
  a.allowTouchCallbacks && n.emit("touchMove", f), o.previousX = o.currentX, o.previousY = o.currentY, o.currentX = m, o.currentY = S;
  const A = o.currentX - o.startX, y = o.currentY - o.startY;
  if (n.params.threshold && Math.sqrt(A ** 2 + y ** 2) < n.params.threshold) return;
  if (typeof a.isScrolling > "u") {
    let k;
    n.isHorizontal() && o.currentY === o.startY || n.isVertical() && o.currentX === o.startX ? a.isScrolling = !1 : A * A + y * y >= 25 && (k = Math.atan2(Math.abs(y), Math.abs(A)) * 180 / Math.PI, a.isScrolling = n.isHorizontal() ? k > c.touchAngle : 90 - k > c.touchAngle);
  }
  if (a.isScrolling && n.emit("touchMoveOpposite", f), typeof a.startMoving > "u" && (o.currentX !== o.startX || o.currentY !== o.startY) && (a.startMoving = !0), a.isScrolling || f.type === "touchmove" && a.preventTouchMoveFromPointerMove) {
    a.isTouched = !1;
    return;
  }
  if (!a.startMoving)
    return;
  n.allowClick = !1, !c.cssMode && f.cancelable && f.preventDefault(), c.touchMoveStopPropagation && !c.nested && f.stopPropagation();
  let _ = n.isHorizontal() ? A : y, O = n.isHorizontal() ? o.currentX - o.previousX : o.currentY - o.previousY;
  c.oneWayMovement && (_ = Math.abs(_) * (d ? 1 : -1), O = Math.abs(O) * (d ? 1 : -1)), o.diff = _, _ *= c.touchRatio, d && (_ = -_, O = -O);
  const G = n.touchesDirection;
  n.swipeDirection = _ > 0 ? "prev" : "next", n.touchesDirection = O > 0 ? "prev" : "next";
  const M = n.params.loop && !c.cssMode, E = n.touchesDirection === "next" && n.allowSlideNext || n.touchesDirection === "prev" && n.allowSlidePrev;
  if (!a.isMoved) {
    if (M && E && n.loopFix({
      direction: n.swipeDirection
    }), a.startTranslate = n.getTranslate(), n.setTransition(0), n.animating) {
      const k = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      n.wrapperEl.dispatchEvent(k);
    }
    a.allowMomentumBounce = !1, c.grabCursor && (n.allowSlideNext === !0 || n.allowSlidePrev === !0) && n.setGrabCursor(!0), n.emit("sliderFirstMove", f);
  }
  let T;
  if ((/* @__PURE__ */ new Date()).getTime(), a.isMoved && a.allowThresholdMove && G !== n.touchesDirection && M && E && Math.abs(_) >= 1) {
    Object.assign(o, {
      startX: m,
      startY: S,
      currentX: m,
      currentY: S,
      startTranslate: a.currentTranslate
    }), a.loopSwapReset = !0, a.startTranslate = a.currentTranslate;
    return;
  }
  n.emit("sliderMove", f), a.isMoved = !0, a.currentTranslate = _ + a.startTranslate;
  let L = !0, P = c.resistanceRatio;
  if (c.touchReleaseOnEdges && (P = 0), _ > 0 ? (M && E && !T && a.allowThresholdMove && a.currentTranslate > (c.centeredSlides ? n.minTranslate() - n.slidesSizesGrid[n.activeIndex + 1] - (c.slidesPerView !== "auto" && n.slides.length - c.slidesPerView >= 2 ? n.slidesSizesGrid[n.activeIndex + 1] + n.params.spaceBetween : 0) - n.params.spaceBetween : n.minTranslate()) && n.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), a.currentTranslate > n.minTranslate() && (L = !1, c.resistance && (a.currentTranslate = n.minTranslate() - 1 + (-n.minTranslate() + a.startTranslate + _) ** P))) : _ < 0 && (M && E && !T && a.allowThresholdMove && a.currentTranslate < (c.centeredSlides ? n.maxTranslate() + n.slidesSizesGrid[n.slidesSizesGrid.length - 1] + n.params.spaceBetween + (c.slidesPerView !== "auto" && n.slides.length - c.slidesPerView >= 2 ? n.slidesSizesGrid[n.slidesSizesGrid.length - 1] + n.params.spaceBetween : 0) : n.maxTranslate()) && n.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: n.slides.length - (c.slidesPerView === "auto" ? n.slidesPerViewDynamic() : Math.ceil(parseFloat(c.slidesPerView, 10)))
  }), a.currentTranslate < n.maxTranslate() && (L = !1, c.resistance && (a.currentTranslate = n.maxTranslate() + 1 - (n.maxTranslate() - a.startTranslate - _) ** P))), L && (f.preventedByNestedSwiper = !0), !n.allowSlideNext && n.swipeDirection === "next" && a.currentTranslate < a.startTranslate && (a.currentTranslate = a.startTranslate), !n.allowSlidePrev && n.swipeDirection === "prev" && a.currentTranslate > a.startTranslate && (a.currentTranslate = a.startTranslate), !n.allowSlidePrev && !n.allowSlideNext && (a.currentTranslate = a.startTranslate), c.threshold > 0)
    if (Math.abs(_) > c.threshold || a.allowThresholdMove) {
      if (!a.allowThresholdMove) {
        a.allowThresholdMove = !0, o.startX = o.currentX, o.startY = o.currentY, a.currentTranslate = a.startTranslate, o.diff = n.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY;
        return;
      }
    } else {
      a.currentTranslate = a.startTranslate;
      return;
    }
  !c.followFinger || c.cssMode || ((c.freeMode && c.freeMode.enabled && n.freeMode || c.watchSlidesProgress) && (n.updateActiveIndex(), n.updateSlidesClasses()), c.freeMode && c.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(), n.updateProgress(a.currentTranslate), n.setTranslate(a.currentTranslate));
}
function UA(s) {
  const r = this, n = r.touchEventsData;
  let a = s;
  a.originalEvent && (a = a.originalEvent);
  let c;
  if (a.type === "touchend" || a.type === "touchcancel") {
    if (c = [...a.changedTouches].filter((P) => P.identifier === n.touchId)[0], !c || c.identifier !== n.touchId) return;
  } else {
    if (n.touchId !== null || a.pointerId !== n.pointerId) return;
    c = a;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(a.type) && !(["pointercancel", "contextmenu"].includes(a.type) && (r.browser.isSafari || r.browser.isWebView)))
    return;
  n.pointerId = null, n.touchId = null;
  const {
    params: d,
    touches: p,
    rtlTranslate: f,
    slidesGrid: b,
    enabled: m
  } = r;
  if (!m || !d.simulateTouch && a.pointerType === "mouse") return;
  if (n.allowTouchCallbacks && r.emit("touchEnd", a), n.allowTouchCallbacks = !1, !n.isTouched) {
    n.isMoved && d.grabCursor && r.setGrabCursor(!1), n.isMoved = !1, n.startMoving = !1;
    return;
  }
  d.grabCursor && n.isMoved && n.isTouched && (r.allowSlideNext === !0 || r.allowSlidePrev === !0) && r.setGrabCursor(!1);
  const S = Wi(), A = S - n.touchStartTime;
  if (r.allowClick) {
    const P = a.path || a.composedPath && a.composedPath();
    r.updateClickedSlide(P && P[0] || a.target, P), r.emit("tap click", a), A < 300 && S - n.lastClickTime < 300 && r.emit("doubleTap doubleClick", a);
  }
  if (n.lastClickTime = Wi(), Ca(() => {
    r.destroyed || (r.allowClick = !0);
  }), !n.isTouched || !n.isMoved || !r.swipeDirection || p.diff === 0 && !n.loopSwapReset || n.currentTranslate === n.startTranslate && !n.loopSwapReset) {
    n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
    return;
  }
  n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
  let y;
  if (d.followFinger ? y = f ? r.translate : -r.translate : y = -n.currentTranslate, d.cssMode)
    return;
  if (d.freeMode && d.freeMode.enabled) {
    r.freeMode.onTouchEnd({
      currentPos: y
    });
    return;
  }
  const _ = y >= -r.maxTranslate() && !r.params.loop;
  let O = 0, G = r.slidesSizesGrid[0];
  for (let P = 0; P < b.length; P += P < d.slidesPerGroupSkip ? 1 : d.slidesPerGroup) {
    const k = P < d.slidesPerGroupSkip - 1 ? 1 : d.slidesPerGroup;
    typeof b[P + k] < "u" ? (_ || y >= b[P] && y < b[P + k]) && (O = P, G = b[P + k] - b[P]) : (_ || y >= b[P]) && (O = P, G = b[b.length - 1] - b[b.length - 2]);
  }
  let M = null, E = null;
  d.rewind && (r.isBeginning ? E = d.virtual && d.virtual.enabled && r.virtual ? r.virtual.slides.length - 1 : r.slides.length - 1 : r.isEnd && (M = 0));
  const T = (y - b[O]) / G, L = O < d.slidesPerGroupSkip - 1 ? 1 : d.slidesPerGroup;
  if (A > d.longSwipesMs) {
    if (!d.longSwipes) {
      r.slideTo(r.activeIndex);
      return;
    }
    r.swipeDirection === "next" && (T >= d.longSwipesRatio ? r.slideTo(d.rewind && r.isEnd ? M : O + L) : r.slideTo(O)), r.swipeDirection === "prev" && (T > 1 - d.longSwipesRatio ? r.slideTo(O + L) : E !== null && T < 0 && Math.abs(T) > d.longSwipesRatio ? r.slideTo(E) : r.slideTo(O));
  } else {
    if (!d.shortSwipes) {
      r.slideTo(r.activeIndex);
      return;
    }
    r.navigation && (a.target === r.navigation.nextEl || a.target === r.navigation.prevEl) ? a.target === r.navigation.nextEl ? r.slideTo(O + L) : r.slideTo(O) : (r.swipeDirection === "next" && r.slideTo(M !== null ? M : O + L), r.swipeDirection === "prev" && r.slideTo(E !== null ? E : O));
  }
}
function gc() {
  const s = this, {
    params: r,
    el: n
  } = s;
  if (n && n.offsetWidth === 0) return;
  r.breakpoints && s.setBreakpoint();
  const {
    allowSlideNext: a,
    allowSlidePrev: c,
    snapGrid: o
  } = s, d = s.virtual && s.params.virtual.enabled;
  s.allowSlideNext = !0, s.allowSlidePrev = !0, s.updateSize(), s.updateSlides(), s.updateSlidesClasses();
  const p = d && r.loop;
  (r.slidesPerView === "auto" || r.slidesPerView > 1) && s.isEnd && !s.isBeginning && !s.params.centeredSlides && !p ? s.slideTo(s.slides.length - 1, 0, !1, !0) : s.params.loop && !d ? s.slideToLoop(s.realIndex, 0, !1, !0) : s.slideTo(s.activeIndex, 0, !1, !0), s.autoplay && s.autoplay.running && s.autoplay.paused && (clearTimeout(s.autoplay.resizeTimeout), s.autoplay.resizeTimeout = setTimeout(() => {
    s.autoplay && s.autoplay.running && s.autoplay.paused && s.autoplay.resume();
  }, 500)), s.allowSlidePrev = c, s.allowSlideNext = a, s.params.watchOverflow && o !== s.snapGrid && s.checkOverflow();
}
function GA(s) {
  const r = this;
  r.enabled && (r.allowClick || (r.params.preventClicks && s.preventDefault(), r.params.preventClicksPropagation && r.animating && (s.stopPropagation(), s.stopImmediatePropagation())));
}
function HA() {
  const s = this, {
    wrapperEl: r,
    rtlTranslate: n,
    enabled: a
  } = s;
  if (!a) return;
  s.previousTranslate = s.translate, s.isHorizontal() ? s.translate = -r.scrollLeft : s.translate = -r.scrollTop, s.translate === 0 && (s.translate = 0), s.updateActiveIndex(), s.updateSlidesClasses();
  let c;
  const o = s.maxTranslate() - s.minTranslate();
  o === 0 ? c = 0 : c = (s.translate - s.minTranslate()) / o, c !== s.progress && s.updateProgress(n ? -s.translate : s.translate), s.emit("setTranslate", s.translate, !1);
}
function VA(s) {
  const r = this;
  Ui(r, s.target), !(r.params.cssMode || r.params.slidesPerView !== "auto" && !r.params.autoHeight) && r.update();
}
function zA() {
  const s = this;
  s.documentTouchHandlerProceeded || (s.documentTouchHandlerProceeded = !0, s.params.touchReleaseOnEdges && (s.el.style.touchAction = "auto"));
}
const Vc = (s, r) => {
  const n = xr(), {
    params: a,
    el: c,
    wrapperEl: o,
    device: d
  } = s, p = !!a.nested, f = r === "on" ? "addEventListener" : "removeEventListener", b = r;
  !c || typeof c == "string" || (n[f]("touchstart", s.onDocumentTouchStart, {
    passive: !1,
    capture: p
  }), c[f]("touchstart", s.onTouchStart, {
    passive: !1
  }), c[f]("pointerdown", s.onTouchStart, {
    passive: !1
  }), n[f]("touchmove", s.onTouchMove, {
    passive: !1,
    capture: p
  }), n[f]("pointermove", s.onTouchMove, {
    passive: !1,
    capture: p
  }), n[f]("touchend", s.onTouchEnd, {
    passive: !0
  }), n[f]("pointerup", s.onTouchEnd, {
    passive: !0
  }), n[f]("pointercancel", s.onTouchEnd, {
    passive: !0
  }), n[f]("touchcancel", s.onTouchEnd, {
    passive: !0
  }), n[f]("pointerout", s.onTouchEnd, {
    passive: !0
  }), n[f]("pointerleave", s.onTouchEnd, {
    passive: !0
  }), n[f]("contextmenu", s.onTouchEnd, {
    passive: !0
  }), (a.preventClicks || a.preventClicksPropagation) && c[f]("click", s.onClick, !0), a.cssMode && o[f]("scroll", s.onScroll), a.updateOnWindowResize ? s[b](d.ios || d.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", gc, !0) : s[b]("observerUpdate", gc, !0), c[f]("load", s.onLoad, {
    capture: !0
  }));
};
function WA() {
  const s = this, {
    params: r
  } = s;
  s.onTouchStart = kA.bind(s), s.onTouchMove = FA.bind(s), s.onTouchEnd = UA.bind(s), s.onDocumentTouchStart = zA.bind(s), r.cssMode && (s.onScroll = HA.bind(s)), s.onClick = GA.bind(s), s.onLoad = VA.bind(s), Vc(s, "on");
}
function jA() {
  Vc(this, "off");
}
var QA = {
  attachEvents: WA,
  detachEvents: jA
};
const pc = (s, r) => s.grid && r.grid && r.grid.rows > 1;
function KA() {
  const s = this, {
    realIndex: r,
    initialized: n,
    params: a,
    el: c
  } = s, o = a.breakpoints;
  if (!o || o && Object.keys(o).length === 0) return;
  const d = s.getBreakpoint(o, s.params.breakpointsBase, s.el);
  if (!d || s.currentBreakpoint === d) return;
  const f = (d in o ? o[d] : void 0) || s.originalParams, b = pc(s, a), m = pc(s, f), S = s.params.grabCursor, A = f.grabCursor, y = a.enabled;
  b && !m ? (c.classList.remove(`${a.containerModifierClass}grid`, `${a.containerModifierClass}grid-column`), s.emitContainerClasses()) : !b && m && (c.classList.add(`${a.containerModifierClass}grid`), (f.grid.fill && f.grid.fill === "column" || !f.grid.fill && a.grid.fill === "column") && c.classList.add(`${a.containerModifierClass}grid-column`), s.emitContainerClasses()), S && !A ? s.unsetGrabCursor() : !S && A && s.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((T) => {
    if (typeof f[T] > "u") return;
    const L = a[T] && a[T].enabled, P = f[T] && f[T].enabled;
    L && !P && s[T].disable(), !L && P && s[T].enable();
  });
  const _ = f.direction && f.direction !== a.direction, O = a.loop && (f.slidesPerView !== a.slidesPerView || _), G = a.loop;
  _ && n && s.changeDirection(), Kt(s.params, f);
  const M = s.params.enabled, E = s.params.loop;
  Object.assign(s, {
    allowTouchMove: s.params.allowTouchMove,
    allowSlideNext: s.params.allowSlideNext,
    allowSlidePrev: s.params.allowSlidePrev
  }), y && !M ? s.disable() : !y && M && s.enable(), s.currentBreakpoint = d, s.emit("_beforeBreakpoint", f), n && (O ? (s.loopDestroy(), s.loopCreate(r), s.updateSlides()) : !G && E ? (s.loopCreate(r), s.updateSlides()) : G && !E && s.loopDestroy()), s.emit("breakpoint", f);
}
function qA(s, r, n) {
  if (r === void 0 && (r = "window"), !s || r === "container" && !n) return;
  let a = !1;
  const c = qt(), o = r === "window" ? c.innerHeight : n.clientHeight, d = Object.keys(s).map((p) => {
    if (typeof p == "string" && p.indexOf("@") === 0) {
      const f = parseFloat(p.substr(1));
      return {
        value: o * f,
        point: p
      };
    }
    return {
      value: p,
      point: p
    };
  });
  d.sort((p, f) => parseInt(p.value, 10) - parseInt(f.value, 10));
  for (let p = 0; p < d.length; p += 1) {
    const {
      point: f,
      value: b
    } = d[p];
    r === "window" ? c.matchMedia(`(min-width: ${b}px)`).matches && (a = f) : b <= n.clientWidth && (a = f);
  }
  return a || "max";
}
var YA = {
  setBreakpoint: KA,
  getBreakpoint: qA
};
function JA(s, r) {
  const n = [];
  return s.forEach((a) => {
    typeof a == "object" ? Object.keys(a).forEach((c) => {
      a[c] && n.push(r + c);
    }) : typeof a == "string" && n.push(r + a);
  }), n;
}
function XA() {
  const s = this, {
    classNames: r,
    params: n,
    rtl: a,
    el: c,
    device: o
  } = s, d = JA(["initialized", n.direction, {
    "free-mode": s.params.freeMode && n.freeMode.enabled
  }, {
    autoheight: n.autoHeight
  }, {
    rtl: a
  }, {
    grid: n.grid && n.grid.rows > 1
  }, {
    "grid-column": n.grid && n.grid.rows > 1 && n.grid.fill === "column"
  }, {
    android: o.android
  }, {
    ios: o.ios
  }, {
    "css-mode": n.cssMode
  }, {
    centered: n.cssMode && n.centeredSlides
  }, {
    "watch-progress": n.watchSlidesProgress
  }], n.containerModifierClass);
  r.push(...d), c.classList.add(...r), s.emitContainerClasses();
}
function ZA() {
  const s = this, {
    el: r,
    classNames: n
  } = s;
  !r || typeof r == "string" || (r.classList.remove(...n), s.emitContainerClasses());
}
var $A = {
  addClasses: XA,
  removeClasses: ZA
};
function e0() {
  const s = this, {
    isLocked: r,
    params: n
  } = s, {
    slidesOffsetBefore: a
  } = n;
  if (a) {
    const c = s.slides.length - 1, o = s.slidesGrid[c] + s.slidesSizesGrid[c] + a * 2;
    s.isLocked = s.size > o;
  } else
    s.isLocked = s.snapGrid.length === 1;
  n.allowSlideNext === !0 && (s.allowSlideNext = !s.isLocked), n.allowSlidePrev === !0 && (s.allowSlidePrev = !s.isLocked), r && r !== s.isLocked && (s.isEnd = !1), r !== s.isLocked && s.emit(s.isLocked ? "lock" : "unlock");
}
var t0 = {
  checkOverflow: e0
}, La = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function n0(s, r) {
  return function(a) {
    a === void 0 && (a = {});
    const c = Object.keys(a)[0], o = a[c];
    if (typeof o != "object" || o === null) {
      Kt(r, a);
      return;
    }
    if (s[c] === !0 && (s[c] = {
      enabled: !0
    }), c === "navigation" && s[c] && s[c].enabled && !s[c].prevEl && !s[c].nextEl && (s[c].auto = !0), ["pagination", "scrollbar"].indexOf(c) >= 0 && s[c] && s[c].enabled && !s[c].el && (s[c].auto = !0), !(c in s && "enabled" in o)) {
      Kt(r, a);
      return;
    }
    typeof s[c] == "object" && !("enabled" in s[c]) && (s[c].enabled = !0), s[c] || (s[c] = {
      enabled: !1
    }), Kt(r, a);
  };
}
const wa = {
  eventsEmitter: $v,
  update: uA,
  translate: mA,
  transition: bA,
  slide: IA,
  loop: RA,
  grabCursor: NA,
  events: QA,
  breakpoints: YA,
  checkOverflow: t0,
  classes: $A
}, ba = {};
let Pa = class Ln {
  constructor() {
    let r, n;
    for (var a = arguments.length, c = new Array(a), o = 0; o < a; o++)
      c[o] = arguments[o];
    c.length === 1 && c[0].constructor && Object.prototype.toString.call(c[0]).slice(8, -1) === "Object" ? n = c[0] : [r, n] = c, n || (n = {}), n = Kt({}, n), r && !n.el && (n.el = r);
    const d = xr();
    if (n.el && typeof n.el == "string" && d.querySelectorAll(n.el).length > 1) {
      const m = [];
      return d.querySelectorAll(n.el).forEach((S) => {
        const A = Kt({}, n, {
          el: S
        });
        m.push(new Ln(A));
      }), m;
    }
    const p = this;
    p.__swiper__ = !0, p.support = Uc(), p.device = Gc({
      userAgent: n.userAgent
    }), p.browser = Jv(), p.eventsListeners = {}, p.eventsAnyListeners = [], p.modules = [...p.__modules__], n.modules && Array.isArray(n.modules) && p.modules.push(...n.modules);
    const f = {};
    p.modules.forEach((m) => {
      m({
        params: n,
        swiper: p,
        extendParams: n0(n, f),
        on: p.on.bind(p),
        once: p.once.bind(p),
        off: p.off.bind(p),
        emit: p.emit.bind(p)
      });
    });
    const b = Kt({}, La, f);
    return p.params = Kt({}, b, ba, n), p.originalParams = Kt({}, p.params), p.passedParams = Kt({}, n), p.params && p.params.on && Object.keys(p.params.on).forEach((m) => {
      p.on(m, p.params.on[m]);
    }), p.params && p.params.onAny && p.onAny(p.params.onAny), Object.assign(p, {
      enabled: p.params.enabled,
      el: r,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return p.params.direction === "horizontal";
      },
      isVertical() {
        return p.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: p.params.allowSlideNext,
      allowSlidePrev: p.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: p.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: p.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), p.emit("_swiper"), p.params.init && p.init(), p;
  }
  getDirectionLabel(r) {
    return this.isHorizontal() ? r : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[r];
  }
  getSlideIndex(r) {
    const {
      slidesEl: n,
      params: a
    } = this, c = hn(n, `.${a.slideClass}, swiper-slide`), o = Ki(c[0]);
    return Ki(r) - o;
  }
  getSlideIndexByData(r) {
    return this.getSlideIndex(this.slides.filter((n) => n.getAttribute("data-swiper-slide-index") * 1 === r)[0]);
  }
  recalcSlides() {
    const r = this, {
      slidesEl: n,
      params: a
    } = r;
    r.slides = hn(n, `.${a.slideClass}, swiper-slide`);
  }
  enable() {
    const r = this;
    r.enabled || (r.enabled = !0, r.params.grabCursor && r.setGrabCursor(), r.emit("enable"));
  }
  disable() {
    const r = this;
    r.enabled && (r.enabled = !1, r.params.grabCursor && r.unsetGrabCursor(), r.emit("disable"));
  }
  setProgress(r, n) {
    const a = this;
    r = Math.min(Math.max(r, 0), 1);
    const c = a.minTranslate(), d = (a.maxTranslate() - c) * r + c;
    a.translateTo(d, typeof n > "u" ? 0 : n), a.updateActiveIndex(), a.updateSlidesClasses();
  }
  emitContainerClasses() {
    const r = this;
    if (!r.params._emitClasses || !r.el) return;
    const n = r.el.className.split(" ").filter((a) => a.indexOf("swiper") === 0 || a.indexOf(r.params.containerModifierClass) === 0);
    r.emit("_containerClasses", n.join(" "));
  }
  getSlideClasses(r) {
    const n = this;
    return n.destroyed ? "" : r.className.split(" ").filter((a) => a.indexOf("swiper-slide") === 0 || a.indexOf(n.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const r = this;
    if (!r.params._emitClasses || !r.el) return;
    const n = [];
    r.slides.forEach((a) => {
      const c = r.getSlideClasses(a);
      n.push({
        slideEl: a,
        classNames: c
      }), r.emit("_slideClass", a, c);
    }), r.emit("_slideClasses", n);
  }
  slidesPerViewDynamic(r, n) {
    r === void 0 && (r = "current"), n === void 0 && (n = !1);
    const a = this, {
      params: c,
      slides: o,
      slidesGrid: d,
      slidesSizesGrid: p,
      size: f,
      activeIndex: b
    } = a;
    let m = 1;
    if (typeof c.slidesPerView == "number") return c.slidesPerView;
    if (c.centeredSlides) {
      let S = o[b] ? Math.ceil(o[b].swiperSlideSize) : 0, A;
      for (let y = b + 1; y < o.length; y += 1)
        o[y] && !A && (S += Math.ceil(o[y].swiperSlideSize), m += 1, S > f && (A = !0));
      for (let y = b - 1; y >= 0; y -= 1)
        o[y] && !A && (S += o[y].swiperSlideSize, m += 1, S > f && (A = !0));
    } else if (r === "current")
      for (let S = b + 1; S < o.length; S += 1)
        (n ? d[S] + p[S] - d[b] < f : d[S] - d[b] < f) && (m += 1);
    else
      for (let S = b - 1; S >= 0; S -= 1)
        d[b] - d[S] < f && (m += 1);
    return m;
  }
  update() {
    const r = this;
    if (!r || r.destroyed) return;
    const {
      snapGrid: n,
      params: a
    } = r;
    a.breakpoints && r.setBreakpoint(), [...r.el.querySelectorAll('[loading="lazy"]')].forEach((d) => {
      d.complete && Ui(r, d);
    }), r.updateSize(), r.updateSlides(), r.updateProgress(), r.updateSlidesClasses();
    function c() {
      const d = r.rtlTranslate ? r.translate * -1 : r.translate, p = Math.min(Math.max(d, r.maxTranslate()), r.minTranslate());
      r.setTranslate(p), r.updateActiveIndex(), r.updateSlidesClasses();
    }
    let o;
    if (a.freeMode && a.freeMode.enabled && !a.cssMode)
      c(), a.autoHeight && r.updateAutoHeight();
    else {
      if ((a.slidesPerView === "auto" || a.slidesPerView > 1) && r.isEnd && !a.centeredSlides) {
        const d = r.virtual && a.virtual.enabled ? r.virtual.slides : r.slides;
        o = r.slideTo(d.length - 1, 0, !1, !0);
      } else
        o = r.slideTo(r.activeIndex, 0, !1, !0);
      o || c();
    }
    a.watchOverflow && n !== r.snapGrid && r.checkOverflow(), r.emit("update");
  }
  changeDirection(r, n) {
    n === void 0 && (n = !0);
    const a = this, c = a.params.direction;
    return r || (r = c === "horizontal" ? "vertical" : "horizontal"), r === c || r !== "horizontal" && r !== "vertical" || (a.el.classList.remove(`${a.params.containerModifierClass}${c}`), a.el.classList.add(`${a.params.containerModifierClass}${r}`), a.emitContainerClasses(), a.params.direction = r, a.slides.forEach((o) => {
      r === "vertical" ? o.style.width = "" : o.style.height = "";
    }), a.emit("changeDirection"), n && a.update()), a;
  }
  changeLanguageDirection(r) {
    const n = this;
    n.rtl && r === "rtl" || !n.rtl && r === "ltr" || (n.rtl = r === "rtl", n.rtlTranslate = n.params.direction === "horizontal" && n.rtl, n.rtl ? (n.el.classList.add(`${n.params.containerModifierClass}rtl`), n.el.dir = "rtl") : (n.el.classList.remove(`${n.params.containerModifierClass}rtl`), n.el.dir = "ltr"), n.update());
  }
  mount(r) {
    const n = this;
    if (n.mounted) return !0;
    let a = r || n.params.el;
    if (typeof a == "string" && (a = document.querySelector(a)), !a)
      return !1;
    a.swiper = n, a.parentNode && a.parentNode.host && a.parentNode.host.nodeName === n.params.swiperElementNodeName.toUpperCase() && (n.isElement = !0);
    const c = () => `.${(n.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let d = a && a.shadowRoot && a.shadowRoot.querySelector ? a.shadowRoot.querySelector(c()) : hn(a, c())[0];
    return !d && n.params.createElements && (d = Qi("div", n.params.wrapperClass), a.append(d), hn(a, `.${n.params.slideClass}`).forEach((p) => {
      d.append(p);
    })), Object.assign(n, {
      el: a,
      wrapperEl: d,
      slidesEl: n.isElement && !a.parentNode.host.slideSlots ? a.parentNode.host : d,
      hostEl: n.isElement ? a.parentNode.host : a,
      mounted: !0,
      // RTL
      rtl: a.dir.toLowerCase() === "rtl" || Wn(a, "direction") === "rtl",
      rtlTranslate: n.params.direction === "horizontal" && (a.dir.toLowerCase() === "rtl" || Wn(a, "direction") === "rtl"),
      wrongRTL: Wn(d, "display") === "-webkit-box"
    }), !0;
  }
  init(r) {
    const n = this;
    if (n.initialized || n.mount(r) === !1) return n;
    n.emit("beforeInit"), n.params.breakpoints && n.setBreakpoint(), n.addClasses(), n.updateSize(), n.updateSlides(), n.params.watchOverflow && n.checkOverflow(), n.params.grabCursor && n.enabled && n.setGrabCursor(), n.params.loop && n.virtual && n.params.virtual.enabled ? n.slideTo(n.params.initialSlide + n.virtual.slidesBefore, 0, n.params.runCallbacksOnInit, !1, !0) : n.slideTo(n.params.initialSlide, 0, n.params.runCallbacksOnInit, !1, !0), n.params.loop && n.loopCreate(), n.attachEvents();
    const c = [...n.el.querySelectorAll('[loading="lazy"]')];
    return n.isElement && c.push(...n.hostEl.querySelectorAll('[loading="lazy"]')), c.forEach((o) => {
      o.complete ? Ui(n, o) : o.addEventListener("load", (d) => {
        Ui(n, d.target);
      });
    }), Ta(n), n.initialized = !0, Ta(n), n.emit("init"), n.emit("afterInit"), n;
  }
  destroy(r, n) {
    r === void 0 && (r = !0), n === void 0 && (n = !0);
    const a = this, {
      params: c,
      el: o,
      wrapperEl: d,
      slides: p
    } = a;
    return typeof a.params > "u" || a.destroyed || (a.emit("beforeDestroy"), a.initialized = !1, a.detachEvents(), c.loop && a.loopDestroy(), n && (a.removeClasses(), o && typeof o != "string" && o.removeAttribute("style"), d && d.removeAttribute("style"), p && p.length && p.forEach((f) => {
      f.classList.remove(c.slideVisibleClass, c.slideFullyVisibleClass, c.slideActiveClass, c.slideNextClass, c.slidePrevClass), f.removeAttribute("style"), f.removeAttribute("data-swiper-slide-index");
    })), a.emit("destroy"), Object.keys(a.eventsListeners).forEach((f) => {
      a.off(f);
    }), r !== !1 && (a.el && typeof a.el != "string" && (a.el.swiper = null), Gv(a)), a.destroyed = !0), null;
  }
  static extendDefaults(r) {
    Kt(ba, r);
  }
  static get extendedDefaults() {
    return ba;
  }
  static get defaults() {
    return La;
  }
  static installModule(r) {
    Ln.prototype.__modules__ || (Ln.prototype.__modules__ = []);
    const n = Ln.prototype.__modules__;
    typeof r == "function" && n.indexOf(r) < 0 && n.push(r);
  }
  static use(r) {
    return Array.isArray(r) ? (r.forEach((n) => Ln.installModule(n)), Ln) : (Ln.installModule(r), Ln);
  }
};
Object.keys(wa).forEach((s) => {
  Object.keys(wa[s]).forEach((r) => {
    Pa.prototype[r] = wa[s][r];
  });
});
Pa.use([Xv, Zv]);
const zc = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function tr(s) {
  return typeof s == "object" && s !== null && s.constructor && Object.prototype.toString.call(s).slice(8, -1) === "Object" && !s.__swiper__;
}
function Ar(s, r) {
  const n = ["__proto__", "constructor", "prototype"];
  Object.keys(r).filter((a) => n.indexOf(a) < 0).forEach((a) => {
    typeof s[a] > "u" ? s[a] = r[a] : tr(r[a]) && tr(s[a]) && Object.keys(r[a]).length > 0 ? r[a].__swiper__ ? s[a] = r[a] : Ar(s[a], r[a]) : s[a] = r[a];
  });
}
function Wc(s) {
  return s === void 0 && (s = {}), s.navigation && typeof s.navigation.nextEl > "u" && typeof s.navigation.prevEl > "u";
}
function jc(s) {
  return s === void 0 && (s = {}), s.pagination && typeof s.pagination.el > "u";
}
function Qc(s) {
  return s === void 0 && (s = {}), s.scrollbar && typeof s.scrollbar.el > "u";
}
function Kc(s) {
  s === void 0 && (s = "");
  const r = s.split(" ").map((a) => a.trim()).filter((a) => !!a), n = [];
  return r.forEach((a) => {
    n.indexOf(a) < 0 && n.push(a);
  }), n.join(" ");
}
function r0(s) {
  return s === void 0 && (s = ""), s ? s.includes("swiper-wrapper") ? s : `swiper-wrapper ${s}` : "swiper-wrapper";
}
function i0(s) {
  let {
    swiper: r,
    slides: n,
    passedParams: a,
    changedParams: c,
    nextEl: o,
    prevEl: d,
    scrollbarEl: p,
    paginationEl: f
  } = s;
  const b = c.filter((N) => N !== "children" && N !== "direction" && N !== "wrapperClass"), {
    params: m,
    pagination: S,
    navigation: A,
    scrollbar: y,
    virtual: _,
    thumbs: O
  } = r;
  let G, M, E, T, L, P, k, q;
  c.includes("thumbs") && a.thumbs && a.thumbs.swiper && !a.thumbs.swiper.destroyed && m.thumbs && (!m.thumbs.swiper || m.thumbs.swiper.destroyed) && (G = !0), c.includes("controller") && a.controller && a.controller.control && m.controller && !m.controller.control && (M = !0), c.includes("pagination") && a.pagination && (a.pagination.el || f) && (m.pagination || m.pagination === !1) && S && !S.el && (E = !0), c.includes("scrollbar") && a.scrollbar && (a.scrollbar.el || p) && (m.scrollbar || m.scrollbar === !1) && y && !y.el && (T = !0), c.includes("navigation") && a.navigation && (a.navigation.prevEl || d) && (a.navigation.nextEl || o) && (m.navigation || m.navigation === !1) && A && !A.prevEl && !A.nextEl && (L = !0);
  const W = (N) => {
    r[N] && (r[N].destroy(), N === "navigation" ? (r.isElement && (r[N].prevEl.remove(), r[N].nextEl.remove()), m[N].prevEl = void 0, m[N].nextEl = void 0, r[N].prevEl = void 0, r[N].nextEl = void 0) : (r.isElement && r[N].el.remove(), m[N].el = void 0, r[N].el = void 0));
  };
  c.includes("loop") && r.isElement && (m.loop && !a.loop ? P = !0 : !m.loop && a.loop ? k = !0 : q = !0), b.forEach((N) => {
    if (tr(m[N]) && tr(a[N]))
      Object.assign(m[N], a[N]), (N === "navigation" || N === "pagination" || N === "scrollbar") && "enabled" in a[N] && !a[N].enabled && W(N);
    else {
      const V = a[N];
      (V === !0 || V === !1) && (N === "navigation" || N === "pagination" || N === "scrollbar") ? V === !1 && W(N) : m[N] = a[N];
    }
  }), b.includes("controller") && !M && r.controller && r.controller.control && m.controller && m.controller.control && (r.controller.control = m.controller.control), c.includes("children") && n && _ && m.virtual.enabled ? (_.slides = n, _.update(!0)) : c.includes("virtual") && _ && m.virtual.enabled && (n && (_.slides = n), _.update(!0)), c.includes("children") && n && m.loop && (q = !0), G && O.init() && O.update(!0), M && (r.controller.control = m.controller.control), E && (r.isElement && (!f || typeof f == "string") && (f = document.createElement("div"), f.classList.add("swiper-pagination"), f.part.add("pagination"), r.el.appendChild(f)), f && (m.pagination.el = f), S.init(), S.render(), S.update()), T && (r.isElement && (!p || typeof p == "string") && (p = document.createElement("div"), p.classList.add("swiper-scrollbar"), p.part.add("scrollbar"), r.el.appendChild(p)), p && (m.scrollbar.el = p), y.init(), y.updateSize(), y.setTranslate()), L && (r.isElement && ((!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-button-next"), o.innerHTML = r.hostEl.constructor.nextButtonSvg, o.part.add("button-next"), r.el.appendChild(o)), (!d || typeof d == "string") && (d = document.createElement("div"), d.classList.add("swiper-button-prev"), d.innerHTML = r.hostEl.constructor.prevButtonSvg, d.part.add("button-prev"), r.el.appendChild(d))), o && (m.navigation.nextEl = o), d && (m.navigation.prevEl = d), A.init(), A.update()), c.includes("allowSlideNext") && (r.allowSlideNext = a.allowSlideNext), c.includes("allowSlidePrev") && (r.allowSlidePrev = a.allowSlidePrev), c.includes("direction") && r.changeDirection(a.direction, !1), (P || q) && r.loopDestroy(), (k || q) && r.loopCreate(), r.update();
}
function s0(s, r) {
  s === void 0 && (s = {}), r === void 0 && (r = !0);
  const n = {
    on: {}
  }, a = {}, c = {};
  Ar(n, La), n._emitClasses = !0, n.init = !1;
  const o = {}, d = zc.map((f) => f.replace(/_/, "")), p = Object.assign({}, s);
  return Object.keys(p).forEach((f) => {
    typeof s[f] > "u" || (d.indexOf(f) >= 0 ? tr(s[f]) ? (n[f] = {}, c[f] = {}, Ar(n[f], s[f]), Ar(c[f], s[f])) : (n[f] = s[f], c[f] = s[f]) : f.search(/on[A-Z]/) === 0 && typeof s[f] == "function" ? r ? a[`${f[2].toLowerCase()}${f.substr(3)}`] = s[f] : n.on[`${f[2].toLowerCase()}${f.substr(3)}`] = s[f] : o[f] = s[f]);
  }), ["navigation", "pagination", "scrollbar"].forEach((f) => {
    n[f] === !0 && (n[f] = {}), n[f] === !1 && delete n[f];
  }), {
    params: n,
    passedParams: c,
    rest: o,
    events: a
  };
}
function a0(s, r) {
  let {
    el: n,
    nextEl: a,
    prevEl: c,
    paginationEl: o,
    scrollbarEl: d,
    swiper: p
  } = s;
  Wc(r) && a && c && (p.params.navigation.nextEl = a, p.originalParams.navigation.nextEl = a, p.params.navigation.prevEl = c, p.originalParams.navigation.prevEl = c), jc(r) && o && (p.params.pagination.el = o, p.originalParams.pagination.el = o), Qc(r) && d && (p.params.scrollbar.el = d, p.originalParams.scrollbar.el = d), p.init(n);
}
function l0(s, r, n, a, c) {
  const o = [];
  if (!r) return o;
  const d = (f) => {
    o.indexOf(f) < 0 && o.push(f);
  };
  if (n && a) {
    const f = a.map(c), b = n.map(c);
    f.join("") !== b.join("") && d("children"), a.length !== n.length && d("children");
  }
  return zc.filter((f) => f[0] === "_").map((f) => f.replace(/_/, "")).forEach((f) => {
    if (f in s && f in r)
      if (tr(s[f]) && tr(r[f])) {
        const b = Object.keys(s[f]), m = Object.keys(r[f]);
        b.length !== m.length ? d(f) : (b.forEach((S) => {
          s[f][S] !== r[f][S] && d(f);
        }), m.forEach((S) => {
          s[f][S] !== r[f][S] && d(f);
        }));
      } else s[f] !== r[f] && d(f);
  }), o;
}
const o0 = (s) => {
  !s || s.destroyed || !s.params.virtual || s.params.virtual && !s.params.virtual.enabled || (s.updateSlides(), s.updateProgress(), s.updateSlidesClasses(), s.parallax && s.params.parallax && s.params.parallax.enabled && s.parallax.setTranslate());
};
function qi() {
  return qi = Object.assign ? Object.assign.bind() : function(s) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (s[a] = n[a]);
    }
    return s;
  }, qi.apply(this, arguments);
}
function qc(s) {
  return s.type && s.type.displayName && s.type.displayName.includes("SwiperSlide");
}
function Yc(s) {
  const r = [];
  return ft.Children.toArray(s).forEach((n) => {
    qc(n) ? r.push(n) : n.props && n.props.children && Yc(n.props.children).forEach((a) => r.push(a));
  }), r;
}
function c0(s) {
  const r = [], n = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return ft.Children.toArray(s).forEach((a) => {
    if (qc(a))
      r.push(a);
    else if (a.props && a.props.slot && n[a.props.slot])
      n[a.props.slot].push(a);
    else if (a.props && a.props.children) {
      const c = Yc(a.props.children);
      c.length > 0 ? c.forEach((o) => r.push(o)) : n["container-end"].push(a);
    } else
      n["container-end"].push(a);
  }), {
    slides: r,
    slots: n
  };
}
function u0(s, r, n) {
  if (!n) return null;
  const a = (m) => {
    let S = m;
    return m < 0 ? S = r.length + m : S >= r.length && (S = S - r.length), S;
  }, c = s.isHorizontal() ? {
    [s.rtlTranslate ? "right" : "left"]: `${n.offset}px`
  } : {
    top: `${n.offset}px`
  }, {
    from: o,
    to: d
  } = n, p = s.params.loop ? -r.length : 0, f = s.params.loop ? r.length * 2 : r.length, b = [];
  for (let m = p; m < f; m += 1)
    m >= o && m <= d && b.push(r[a(m)]);
  return b.map((m, S) => /* @__PURE__ */ ft.cloneElement(m, {
    swiper: s,
    style: c,
    key: m.props.virtualIndex || m.key || `slide-${S}`
  }));
}
function jr(s, r) {
  return typeof window > "u" ? _e(s, r) : rv(s, r);
}
const hc = /* @__PURE__ */ xc(null), f0 = /* @__PURE__ */ xc(null), Jc = /* @__PURE__ */ bc(function(s, r) {
  let {
    className: n,
    tag: a = "div",
    wrapperTag: c = "div",
    children: o,
    onSwiper: d,
    ...p
  } = s === void 0 ? {} : s, f = !1;
  const [b, m] = Oe("swiper"), [S, A] = Oe(null), [y, _] = Oe(!1), O = Ie(!1), G = Ie(null), M = Ie(null), E = Ie(null), T = Ie(null), L = Ie(null), P = Ie(null), k = Ie(null), q = Ie(null), {
    params: W,
    passedParams: N,
    rest: V,
    events: K
  } = s0(p), {
    slides: Z,
    slots: j
  } = c0(o), te = () => {
    _(!y);
  };
  Object.assign(W.on, {
    _containerClasses(ye, Be) {
      m(Be);
    }
  });
  const re = () => {
    Object.assign(W.on, K), f = !0;
    const ye = {
      ...W
    };
    if (delete ye.wrapperClass, M.current = new Pa(ye), M.current.virtual && M.current.params.virtual.enabled) {
      M.current.virtual.slides = Z;
      const Be = {
        cache: !1,
        slides: Z,
        renderExternal: A,
        renderExternalUpdate: !1
      };
      Ar(M.current.params.virtual, Be), Ar(M.current.originalParams.virtual, Be);
    }
  };
  G.current || re(), M.current && M.current.on("_beforeBreakpoint", te);
  const ue = () => {
    f || !K || !M.current || Object.keys(K).forEach((ye) => {
      M.current.on(ye, K[ye]);
    });
  }, Ne = () => {
    !K || !M.current || Object.keys(K).forEach((ye) => {
      M.current.off(ye, K[ye]);
    });
  };
  _e(() => () => {
    M.current && M.current.off("_beforeBreakpoint", te);
  }), _e(() => {
    !O.current && M.current && (M.current.emitSlidesClasses(), O.current = !0);
  }), jr(() => {
    if (r && (r.current = G.current), !!G.current)
      return M.current.destroyed && re(), a0({
        el: G.current,
        nextEl: L.current,
        prevEl: P.current,
        paginationEl: k.current,
        scrollbarEl: q.current,
        swiper: M.current
      }, W), d && !M.current.destroyed && d(M.current), () => {
        M.current && !M.current.destroyed && M.current.destroy(!0, !1);
      };
  }, []), jr(() => {
    ue();
    const ye = l0(N, E.current, Z, T.current, (Be) => Be.key);
    return E.current = N, T.current = Z, ye.length && M.current && !M.current.destroyed && i0({
      swiper: M.current,
      slides: Z,
      passedParams: N,
      changedParams: ye,
      nextEl: L.current,
      prevEl: P.current,
      scrollbarEl: q.current,
      paginationEl: k.current
    }), () => {
      Ne();
    };
  }), jr(() => {
    o0(M.current);
  }, [S]);
  function Ge() {
    return W.virtual ? u0(M.current, Z, S) : Z.map((ye, Be) => /* @__PURE__ */ ft.cloneElement(ye, {
      swiper: M.current,
      swiperSlideIndex: Be
    }));
  }
  return /* @__PURE__ */ ft.createElement(a, qi({
    ref: G,
    className: Kc(`${b}${n ? ` ${n}` : ""}`)
  }, V), /* @__PURE__ */ ft.createElement(f0.Provider, {
    value: M.current
  }, j["container-start"], /* @__PURE__ */ ft.createElement(c, {
    className: r0(W.wrapperClass)
  }, j["wrapper-start"], Ge(), j["wrapper-end"]), Wc(W) && /* @__PURE__ */ ft.createElement(ft.Fragment, null, /* @__PURE__ */ ft.createElement("div", {
    ref: P,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ ft.createElement("div", {
    ref: L,
    className: "swiper-button-next"
  })), Qc(W) && /* @__PURE__ */ ft.createElement("div", {
    ref: q,
    className: "swiper-scrollbar"
  }), jc(W) && /* @__PURE__ */ ft.createElement("div", {
    ref: k,
    className: "swiper-pagination"
  }), j["container-end"]));
});
Jc.displayName = "Swiper";
const Xc = /* @__PURE__ */ bc(function(s, r) {
  let {
    tag: n = "div",
    children: a,
    className: c = "",
    swiper: o,
    zoom: d,
    lazy: p,
    virtualIndex: f,
    swiperSlideIndex: b,
    ...m
  } = s === void 0 ? {} : s;
  const S = Ie(null), [A, y] = Oe("swiper-slide"), [_, O] = Oe(!1);
  function G(L, P, k) {
    P === S.current && y(k);
  }
  jr(() => {
    if (typeof b < "u" && (S.current.swiperSlideIndex = b), r && (r.current = S.current), !(!S.current || !o)) {
      if (o.destroyed) {
        A !== "swiper-slide" && y("swiper-slide");
        return;
      }
      return o.on("_slideClass", G), () => {
        o && o.off("_slideClass", G);
      };
    }
  }), jr(() => {
    o && S.current && !o.destroyed && y(o.getSlideClasses(S.current));
  }, [o]);
  const M = {
    isActive: A.indexOf("swiper-slide-active") >= 0,
    isVisible: A.indexOf("swiper-slide-visible") >= 0,
    isPrev: A.indexOf("swiper-slide-prev") >= 0,
    isNext: A.indexOf("swiper-slide-next") >= 0
  }, E = () => typeof a == "function" ? a(M) : a, T = () => {
    O(!0);
  };
  return /* @__PURE__ */ ft.createElement(n, qi({
    ref: S,
    className: Kc(`${A}${c ? ` ${c}` : ""}`),
    "data-swiper-slide-index": f,
    onLoad: T
  }, m), d && /* @__PURE__ */ ft.createElement(hc.Provider, {
    value: M
  }, /* @__PURE__ */ ft.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof d == "number" ? d : void 0
  }, E(), p && !_ && /* @__PURE__ */ ft.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !d && /* @__PURE__ */ ft.createElement(hc.Provider, {
    value: M
  }, E(), p && !_ && /* @__PURE__ */ ft.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
Xc.displayName = "SwiperSlide";
function d0(s, r, n, a) {
  return s.params.createElements && Object.keys(a).forEach((c) => {
    if (!n[c] && n.auto === !0) {
      let o = hn(s.el, `.${a[c]}`)[0];
      o || (o = Qi("div", a[c]), o.className = a[c], s.el.append(o)), n[c] = o, r[c] = o;
    }
  }), n;
}
function zr(s) {
  return s === void 0 && (s = ""), `.${s.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function g0(s) {
  let {
    swiper: r,
    extendParams: n,
    on: a,
    emit: c
  } = s;
  const o = "swiper-pagination";
  n({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (E) => E,
      formatFractionTotal: (E) => E,
      bulletClass: `${o}-bullet`,
      bulletActiveClass: `${o}-bullet-active`,
      modifierClass: `${o}-`,
      currentClass: `${o}-current`,
      totalClass: `${o}-total`,
      hiddenClass: `${o}-hidden`,
      progressbarFillClass: `${o}-progressbar-fill`,
      progressbarOppositeClass: `${o}-progressbar-opposite`,
      clickableClass: `${o}-clickable`,
      lockClass: `${o}-lock`,
      horizontalClass: `${o}-horizontal`,
      verticalClass: `${o}-vertical`,
      paginationDisabledClass: `${o}-disabled`
    }
  }), r.pagination = {
    el: null,
    bullets: []
  };
  let d, p = 0;
  function f() {
    return !r.params.pagination.el || !r.pagination.el || Array.isArray(r.pagination.el) && r.pagination.el.length === 0;
  }
  function b(E, T) {
    const {
      bulletActiveClass: L
    } = r.params.pagination;
    E && (E = E[`${T === "prev" ? "previous" : "next"}ElementSibling`], E && (E.classList.add(`${L}-${T}`), E = E[`${T === "prev" ? "previous" : "next"}ElementSibling`], E && E.classList.add(`${L}-${T}-${T}`)));
  }
  function m(E, T, L) {
    if (E = E % L, T = T % L, T === E + 1)
      return "next";
    if (T === E - 1)
      return "previous";
  }
  function S(E) {
    const T = E.target.closest(zr(r.params.pagination.bulletClass));
    if (!T)
      return;
    E.preventDefault();
    const L = Ki(T) * r.params.slidesPerGroup;
    if (r.params.loop) {
      if (r.realIndex === L) return;
      const P = m(r.realIndex, L, r.slides.length);
      P === "next" ? r.slideNext() : P === "previous" ? r.slidePrev() : r.slideToLoop(L);
    } else
      r.slideTo(L);
  }
  function A() {
    const E = r.rtl, T = r.params.pagination;
    if (f()) return;
    let L = r.pagination.el;
    L = Tn(L);
    let P, k;
    const q = r.virtual && r.params.virtual.enabled ? r.virtual.slides.length : r.slides.length, W = r.params.loop ? Math.ceil(q / r.params.slidesPerGroup) : r.snapGrid.length;
    if (r.params.loop ? (k = r.previousRealIndex || 0, P = r.params.slidesPerGroup > 1 ? Math.floor(r.realIndex / r.params.slidesPerGroup) : r.realIndex) : typeof r.snapIndex < "u" ? (P = r.snapIndex, k = r.previousSnapIndex) : (k = r.previousIndex || 0, P = r.activeIndex || 0), T.type === "bullets" && r.pagination.bullets && r.pagination.bullets.length > 0) {
      const N = r.pagination.bullets;
      let V, K, Z;
      if (T.dynamicBullets && (d = Ea(N[0], r.isHorizontal() ? "width" : "height"), L.forEach((j) => {
        j.style[r.isHorizontal() ? "width" : "height"] = `${d * (T.dynamicMainBullets + 4)}px`;
      }), T.dynamicMainBullets > 1 && k !== void 0 && (p += P - (k || 0), p > T.dynamicMainBullets - 1 ? p = T.dynamicMainBullets - 1 : p < 0 && (p = 0)), V = Math.max(P - p, 0), K = V + (Math.min(N.length, T.dynamicMainBullets) - 1), Z = (K + V) / 2), N.forEach((j) => {
        const te = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((re) => `${T.bulletActiveClass}${re}`)].map((re) => typeof re == "string" && re.includes(" ") ? re.split(" ") : re).flat();
        j.classList.remove(...te);
      }), L.length > 1)
        N.forEach((j) => {
          const te = Ki(j);
          te === P ? j.classList.add(...T.bulletActiveClass.split(" ")) : r.isElement && j.setAttribute("part", "bullet"), T.dynamicBullets && (te >= V && te <= K && j.classList.add(...`${T.bulletActiveClass}-main`.split(" ")), te === V && b(j, "prev"), te === K && b(j, "next"));
        });
      else {
        const j = N[P];
        if (j && j.classList.add(...T.bulletActiveClass.split(" ")), r.isElement && N.forEach((te, re) => {
          te.setAttribute("part", re === P ? "bullet-active" : "bullet");
        }), T.dynamicBullets) {
          const te = N[V], re = N[K];
          for (let ue = V; ue <= K; ue += 1)
            N[ue] && N[ue].classList.add(...`${T.bulletActiveClass}-main`.split(" "));
          b(te, "prev"), b(re, "next");
        }
      }
      if (T.dynamicBullets) {
        const j = Math.min(N.length, T.dynamicMainBullets + 4), te = (d * j - d) / 2 - Z * d, re = E ? "right" : "left";
        N.forEach((ue) => {
          ue.style[r.isHorizontal() ? re : "top"] = `${te}px`;
        });
      }
    }
    L.forEach((N, V) => {
      if (T.type === "fraction" && (N.querySelectorAll(zr(T.currentClass)).forEach((K) => {
        K.textContent = T.formatFractionCurrent(P + 1);
      }), N.querySelectorAll(zr(T.totalClass)).forEach((K) => {
        K.textContent = T.formatFractionTotal(W);
      })), T.type === "progressbar") {
        let K;
        T.progressbarOpposite ? K = r.isHorizontal() ? "vertical" : "horizontal" : K = r.isHorizontal() ? "horizontal" : "vertical";
        const Z = (P + 1) / W;
        let j = 1, te = 1;
        K === "horizontal" ? j = Z : te = Z, N.querySelectorAll(zr(T.progressbarFillClass)).forEach((re) => {
          re.style.transform = `translate3d(0,0,0) scaleX(${j}) scaleY(${te})`, re.style.transitionDuration = `${r.params.speed}ms`;
        });
      }
      T.type === "custom" && T.renderCustom ? (N.innerHTML = T.renderCustom(r, P + 1, W), V === 0 && c("paginationRender", N)) : (V === 0 && c("paginationRender", N), c("paginationUpdate", N)), r.params.watchOverflow && r.enabled && N.classList[r.isLocked ? "add" : "remove"](T.lockClass);
    });
  }
  function y() {
    const E = r.params.pagination;
    if (f()) return;
    const T = r.virtual && r.params.virtual.enabled ? r.virtual.slides.length : r.grid && r.params.grid.rows > 1 ? r.slides.length / Math.ceil(r.params.grid.rows) : r.slides.length;
    let L = r.pagination.el;
    L = Tn(L);
    let P = "";
    if (E.type === "bullets") {
      let k = r.params.loop ? Math.ceil(T / r.params.slidesPerGroup) : r.snapGrid.length;
      r.params.freeMode && r.params.freeMode.enabled && k > T && (k = T);
      for (let q = 0; q < k; q += 1)
        E.renderBullet ? P += E.renderBullet.call(r, q, E.bulletClass) : P += `<${E.bulletElement} ${r.isElement ? 'part="bullet"' : ""} class="${E.bulletClass}"></${E.bulletElement}>`;
    }
    E.type === "fraction" && (E.renderFraction ? P = E.renderFraction.call(r, E.currentClass, E.totalClass) : P = `<span class="${E.currentClass}"></span> / <span class="${E.totalClass}"></span>`), E.type === "progressbar" && (E.renderProgressbar ? P = E.renderProgressbar.call(r, E.progressbarFillClass) : P = `<span class="${E.progressbarFillClass}"></span>`), r.pagination.bullets = [], L.forEach((k) => {
      E.type !== "custom" && (k.innerHTML = P || ""), E.type === "bullets" && r.pagination.bullets.push(...k.querySelectorAll(zr(E.bulletClass)));
    }), E.type !== "custom" && c("paginationRender", L[0]);
  }
  function _() {
    r.params.pagination = d0(r, r.originalParams.pagination, r.params.pagination, {
      el: "swiper-pagination"
    });
    const E = r.params.pagination;
    if (!E.el) return;
    let T;
    typeof E.el == "string" && r.isElement && (T = r.el.querySelector(E.el)), !T && typeof E.el == "string" && (T = [...document.querySelectorAll(E.el)]), T || (T = E.el), !(!T || T.length === 0) && (r.params.uniqueNavElements && typeof E.el == "string" && Array.isArray(T) && T.length > 1 && (T = [...r.el.querySelectorAll(E.el)], T.length > 1 && (T = T.filter((L) => Fc(L, ".swiper")[0] === r.el)[0])), Array.isArray(T) && T.length === 1 && (T = T[0]), Object.assign(r.pagination, {
      el: T
    }), T = Tn(T), T.forEach((L) => {
      E.type === "bullets" && E.clickable && L.classList.add(...(E.clickableClass || "").split(" ")), L.classList.add(E.modifierClass + E.type), L.classList.add(r.isHorizontal() ? E.horizontalClass : E.verticalClass), E.type === "bullets" && E.dynamicBullets && (L.classList.add(`${E.modifierClass}${E.type}-dynamic`), p = 0, E.dynamicMainBullets < 1 && (E.dynamicMainBullets = 1)), E.type === "progressbar" && E.progressbarOpposite && L.classList.add(E.progressbarOppositeClass), E.clickable && L.addEventListener("click", S), r.enabled || L.classList.add(E.lockClass);
    }));
  }
  function O() {
    const E = r.params.pagination;
    if (f()) return;
    let T = r.pagination.el;
    T && (T = Tn(T), T.forEach((L) => {
      L.classList.remove(E.hiddenClass), L.classList.remove(E.modifierClass + E.type), L.classList.remove(r.isHorizontal() ? E.horizontalClass : E.verticalClass), E.clickable && (L.classList.remove(...(E.clickableClass || "").split(" ")), L.removeEventListener("click", S));
    })), r.pagination.bullets && r.pagination.bullets.forEach((L) => L.classList.remove(...E.bulletActiveClass.split(" ")));
  }
  a("changeDirection", () => {
    if (!r.pagination || !r.pagination.el) return;
    const E = r.params.pagination;
    let {
      el: T
    } = r.pagination;
    T = Tn(T), T.forEach((L) => {
      L.classList.remove(E.horizontalClass, E.verticalClass), L.classList.add(r.isHorizontal() ? E.horizontalClass : E.verticalClass);
    });
  }), a("init", () => {
    r.params.pagination.enabled === !1 ? M() : (_(), y(), A());
  }), a("activeIndexChange", () => {
    typeof r.snapIndex > "u" && A();
  }), a("snapIndexChange", () => {
    A();
  }), a("snapGridLengthChange", () => {
    y(), A();
  }), a("destroy", () => {
    O();
  }), a("enable disable", () => {
    let {
      el: E
    } = r.pagination;
    E && (E = Tn(E), E.forEach((T) => T.classList[r.enabled ? "remove" : "add"](r.params.pagination.lockClass)));
  }), a("lock unlock", () => {
    A();
  }), a("click", (E, T) => {
    const L = T.target, P = Tn(r.pagination.el);
    if (r.params.pagination.el && r.params.pagination.hideOnClick && P && P.length > 0 && !L.classList.contains(r.params.pagination.bulletClass)) {
      if (r.navigation && (r.navigation.nextEl && L === r.navigation.nextEl || r.navigation.prevEl && L === r.navigation.prevEl)) return;
      const k = P[0].classList.contains(r.params.pagination.hiddenClass);
      c(k === !0 ? "paginationShow" : "paginationHide"), P.forEach((q) => q.classList.toggle(r.params.pagination.hiddenClass));
    }
  });
  const G = () => {
    r.el.classList.remove(r.params.pagination.paginationDisabledClass);
    let {
      el: E
    } = r.pagination;
    E && (E = Tn(E), E.forEach((T) => T.classList.remove(r.params.pagination.paginationDisabledClass))), _(), y(), A();
  }, M = () => {
    r.el.classList.add(r.params.pagination.paginationDisabledClass);
    let {
      el: E
    } = r.pagination;
    E && (E = Tn(E), E.forEach((T) => T.classList.add(r.params.pagination.paginationDisabledClass))), O();
  };
  Object.assign(r.pagination, {
    enable: G,
    disable: M,
    render: y,
    update: A,
    init: _,
    destroy: O
  });
}
const p0 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAdVJREFUaEPtmLFu1EAQhr+/goICQhHxDFBECQ+AaAMtqaNUoUseJHQoFUoLLUeZgj4gCvIKiCakCRJUf2RpT0KWkce+9d2ttCtdc54Zzzf/7oxtUfhS4flTAVatYFWgKrBgBeoWWrCAC7tXBdoltL0BbAPnkrxwiXsCZFfA9gzYBQ4kvVsrANsPgebXXj8k3TR/2v6SFHgDnI4AuJJ0FfULK2D7CXAB3OkIvifpQwsgmkPb7i/wVNL3SIAhAI8TwN2JAf4kgMusAKm6D4DmkLbXT0m/WwqcAG8jSbRsfkm6jvqFFYgGtP0ReAHsSzqL+o21mwLgPrAFfC6yjY6t5Fi/7AqMTWSs31IAbDf3eQ58HXJAI1DLAtgHmqn8SVJzwLOtQQBpEne10b6EDoGjpMBOarf3gEcdjk0bXfok7gOYX2+20BzgFfC+w3ElkzgnwEomcR/Aa+C4Ywtt/mcLrW4Sd5HYnh/imaSXfbRDrg86xEMC/2ub2ugz4FuRbXQseMRvKQpEEhlrkx3AdtkPc2v9OG273Bca22W/Uhb/Up8ewMr9rBJtc2v9YSsCUfynxQhkTpvsgyxncpFYFSBSpSltqgJTVjcSuyoQqdKUNlWBKasbiX0LNiDCMXGxnH0AAAAASUVORK5CYII=", mc = "body-style-active", h0 = (s) => {
  var dt, gt, Gt, it, pt, Tt, ot;
  const r = Qr("(min-width: 1024px)"), { getClassLetters: n, navigateToBrandPage: a, getVehicleTreeData: c, getDefaultBodyAndClass: o, formatPrice: d } = Bc(), { overlay: p, showOverlay: f } = Mc(), b = Ie([g0]), m = Ie(null), S = Ie(null), A = Ie(null), y = Ie(null), _ = Ie(null), [O, G] = Oe(0), [M, E] = Oe(0), [T, L] = Oe(0), P = Ie([]), k = Ie(null), q = Ie(null), W = Ie(null), [N, V] = Oe("hidden"), K = s.vehicleListData.vehicleList.data, Z = s.vehicleListData.bodyStyles, j = Oc(), re = (() => {
    var Q, X, ge;
    return (ge = (X = (Q = W.current) == null ? void 0 : Q[O]) == null ? void 0 : X.classList[M]) != null && ge.modelList[T] ? W.current[O].classList[M].modelList[T].CTAs || [] : [];
  })(), ue = ((dt = re[0]) == null ? void 0 : dt.link) || "", Ne = ((gt = re[1]) == null ? void 0 : gt.link) || "", { isHiddenCTA: Ge } = zi(ue), { isHiddenCTA: ye } = zi(Ne), Be = (Q) => Q.filter((X, ge) => ge === 0 ? !Ge : ge === 1 ? !ye : !0);
  _e(() => {
    if (!r) {
      if (s.displayOnHomepage) {
        V("display-on-homepage-mobile g-flex");
        return;
      }
      if (s.isVehicleListOpened === void 0) {
        V("g-hidden");
        return;
      }
      s.isVehicleListOpened ? V("open g-flex") : V("close g-flex");
    }
  }, [s.isVehicleListOpened, s.displayOnHomepage, r]);
  const We = (Q, X, ge = !1) => {
    G(Q);
    let Te = 0, we = 0;
    if (X !== void 0)
      we = X;
    else {
      const be = W.current[Q];
      be.isBrand || (we = be.classList.findIndex((Le) => Le.recommend));
    }
    ge && (we = 0), X !== void 0 && P.current[Q] && (P.current[Q].classIdx = X, P.current[Q].modelIdx = W.current[Q].classList[X].modelList.findIndex((be) => be.recommend)), P.current[Q] && (we = P.current[Q].classIdx, Te = P.current[Q].modelIdx >= 0 ? P.current[Q].modelIdx : 0);
    const ze = Te < 0 ? 0 : Te;
    E(we < 0 ? 0 : we), L(ze);
  };
  _e(() => {
    k.current && k.current.slideTo(T);
  }, [T]);
  const je = (Q) => {
    We(O, Q);
  };
  _e(() => {
    if (K) {
      const Q = K.attributes.OWVehicleBody;
      if (Q != null && Q.length) {
        W.current = c(Q);
        const [X, ge] = o(Q), we = new URLSearchParams(window.location.search).get("body");
        let ze = X;
        if (we && Z) {
          let be = -1;
          if (we in Hi) {
            const Le = Hi[we];
            be = Z.findIndex(
              (Xe) => Xe.enName === Le
            ), be < 0 && W.current && (be = W.current.findIndex(
              (Xe) => Xe.name === Le
            ));
          }
          be < 0 && W.current && (be = W.current.findIndex(
            (Le) => Le.name === we
          )), be >= 0 && (ze = be);
        }
        We(ze, ge), P.current = Q.map((be) => {
          const Le = be.OWVehicleClass.findIndex((Lt) => Lt.recommend), Xe = Le >= 0 ? Le : 0, st = be.OWVehicleClass[Xe].OWVehicleModel.findIndex((Lt) => Lt.recommend), xt = st >= 0 ? st : 0;
          return { classIdx: Xe, modelIdx: xt };
        });
      }
    }
  }, []), _e(() => {
    k.current && S.current && (S.current.style.backgroundImage = `url(${W.current[O].classList[M].modelList[T].vehicleImageMobile})`);
  }, [O, M, T]);
  const He = (Q) => {
    k.current = Q;
  }, sn = (Q) => {
    if (S.current) {
      L(Q.activeIndex);
      const X = W.current[O].classList[M].modelList[Q.activeIndex];
      S.current.style.backgroundImage = `url(${X.vehicleImageMobile})`;
    }
  }, Qe = (Q) => {
    a(Q);
  }, Ve = Lv(() => {
    if (A.current) {
      const Q = A.current.getBoundingClientRect().right ?? 0, X = A.current.querySelectorAll("li");
      Q && X.length && X.forEach((ge) => {
        const Te = ge.getBoundingClientRect().width;
        ge.getBoundingClientRect().right >= Q && ge.getBoundingClientRect().right < Q + Te ? ge.classList.add("gradient-text") : ge.classList.remove("gradient-text");
      });
    }
  }, 20), bt = (Q, X, ge = 300) => {
    const Te = Date.now(), we = Q, ze = we.scrollLeft;
    function be() {
      const Xe = Date.now() - Te, st = Math.min(1, Xe / ge), xt = ze + X * st;
      we.scrollLeft = xt, st < 1 && requestAnimationFrame(be);
    }
    be();
  };
  _e(() => {
    var Q;
    (Q = W.current) == null || Q[O].classList[M].modelList.forEach(
      (X) => X.vehicleImageMobile && Lc(X.vehicleImageMobile)
    );
  }, [O, M]), _e(() => {
    s.isVehicleListOpened && A.current && Ve();
  }, [Ve, s.isVehicleListOpened]);
  const Ke = (Q) => {
    if (!W.current)
      return console.error("processedVehicleListData is not initialized"), null;
    for (const X of W.current)
      for (const ge of X.classList)
        if (ge.modelList.some((we) => we.name === Q))
          return X.name;
    return console.warn(`Model with name "${Q}" not found`), null;
  }, ce = (Q) => [Je.AMG, Je.MAYBACH, Je.G_CLASS].includes(Q), vt = async (Q, X, ge, Te) => {
    var we;
    if (X) {
      let ze = X;
      const be = W.current[O], Le = be.classList[M], Xe = Le.modelList[T], st = Ke(Xe.name), xt = ce(be.name) ? st : be.name;
      if (s.onClick) {
        const Lt = {
          market_segment: xt || "",
          vehicle_series_name: Le.name,
          vehicle_model_name: Xe.name,
          button_name: ge
        };
        s.onClick(Lt);
      }
      if (j && ((we = Xe.model) != null && we.enName) && X.includes("/test-drive") && s.navigateToTestDrive) {
        s.navigateToTestDrive(Xe.model.enName);
        return;
      }
      Te && Xe.model ? ze = await Rc(
        X,
        Xe.model,
        Te,
        Z,
        Xe.nstCode || "",
        s.occUrl || ""
      ) : (ge === "在线预订" && (ze = `${X}?nstCode=${Xe.nstCode}&isModelLevel=true`), ge === "预约品鉴" && (ze = `${X}?model=${Xe.name}&body=${be.name}&class=${Le.name}`), X.includes("/presale-testdrive") && j && (ze = `${X.replace(/\.html/, ".woHeaderFooter.html")}&source=salesapp`)), Ic(ze, Q);
    }
    window.location.href.includes("/purchase/") && setTimeout(() => {
      window.location.reload();
    }, 100);
  };
  return _e(() => {
    if (A.current) {
      const Q = A.current.querySelector(`.${mc}`);
      if (Q) {
        const X = A.current.getBoundingClientRect().right, ge = Q.getBoundingClientRect().width;
        Q.getBoundingClientRect().right >= X && Q.getBoundingClientRect().right < X + ge && bt(A.current, ge), Q.getBoundingClientRect().right >= 16 && Q.getBoundingClientRect().right < ge + 16 && bt(A.current, -ge);
      }
    }
  }, [O]), _e(() => {
    const Q = m.current;
    s.displayOnHomepage && Q && !r && (Q.style.height = `${window.innerHeight - 64}px`), setTimeout(() => {
      A.current && Ve();
    }, 500);
  }, [Ve, r, s.displayOnHomepage]), /* @__PURE__ */ x.jsx("div", { className: "antialiased global-header-vehicles-mobile-container " + N, ref: m, children: /* @__PURE__ */ x.jsxs("div", { className: "global-header-vehicles-mobile-container-wrapper", ref: S, children: [
    /* @__PURE__ */ x.jsxs("div", { className: "global-header-vehicles-mobile-container-wrapper__top", ref: _, children: [
      /* @__PURE__ */ x.jsx(
        "ul",
        {
          className: "global-header-vehicles-mobile-container-wrapper__top-body",
          ref: A,
          onScroll: Ve,
          style: j ? { width: "calc(100% - 32px)" } : {},
          children: (Gt = W.current) == null ? void 0 : Gt.map((Q, X) => /* @__PURE__ */ x.jsx(
            "li",
            {
              className: O === X ? mc : "",
              onClick: () => {
                We(X, void 0, !0);
              },
              children: Nc(Q)
            },
            X
          ))
        }
      ),
      /* @__PURE__ */ x.jsxs("div", { className: "global-header-vehicles-mobile-container-wrapper__top-class", ref: y, children: [
        ((it = W.current) == null ? void 0 : it[O].isBrand) && /* @__PURE__ */ x.jsx(
          "div",
          {
            className: "global-header-vehicles-mobile-container-wrapper__top-class-brand",
            onClick: () => Qe(W.current[O].name),
            children: ((pt = W.current) == null ? void 0 : pt[O].name) === Je.G_CLASS ? "越野传奇" : "品牌中心"
          }
        ),
        (Tt = W.current) == null ? void 0 : Tt[O].classList.map((Q, X) => /* @__PURE__ */ x.jsxs(
          "div",
          {
            className: `global-header-vehicles-mobile-container-wrapper__top-class-box ${X === M ? "global-header-vehicles-mobile-container-wrapper__top-class-box-active" : ""}`,
            onClick: () => je(X),
            children: [
              /* @__PURE__ */ x.jsxs("div", { className: "global-header-vehicles-mobile-container-wrapper__top-class-box-letter", children: [
                /* @__PURE__ */ x.jsx("div", { className: "hidden-letter", children: n(Q.name) }),
                /* @__PURE__ */ x.jsx("div", { className: "visible-letter", children: n(Q.name) })
              ] }),
              Q.name.includes(br) && /* @__PURE__ */ x.jsx("div", { className: "global-header-vehicles-mobile-container-wrapper__top-class-box-level", children: br })
            ]
          },
          Q.name
        ))
      ] }),
      !j && /* @__PURE__ */ x.jsx("a", { href: Gi, children: /* @__PURE__ */ x.jsx(
        "img",
        {
          className: "global-header-vehicles-mobile-container-wrapper__top-filter",
          src: p0,
          alt: "Filter"
        }
      ) })
    ] }),
    /* @__PURE__ */ x.jsx(
      Jc,
      {
        className: "global-header-vehicles-model-swiper",
        modules: b.current,
        pagination: { clickable: !0 },
        onSwiper: He,
        onSlideChange: sn,
        ref: q,
        children: (ot = W.current) == null ? void 0 : ot[O].classList[M].modelList.map((Q) => /* @__PURE__ */ x.jsxs(Xc, { className: "!flex flex-col", children: [
          /* @__PURE__ */ x.jsxs("div", { className: "global-header-vehicles-mobile-container-wrapper__model-name", children: [
            Q.nameImageMobile ? /* @__PURE__ */ x.jsx(
              "img",
              {
                className: "global-header-vehicles-mobile-container-wrapper__model-name-img",
                src: Q.nameImageMobile,
                alt: "model name"
              }
            ) : /* @__PURE__ */ x.jsx("pre", { children: Q.name }),
            Q.msrp ? /* @__PURE__ */ x.jsxs("p", { className: "global-header-vehicles-mobile-container-wrapper__model-name-tip", children: [
              /* @__PURE__ */ x.jsxs("span", { children: [
                "厂家建议零售价 ",
                d(Q.msrp),
                "起"
              ] }),
              /* @__PURE__ */ x.jsx(
                "img",
                {
                  src: Pc,
                  onClick: (X) => {
                    X.stopPropagation(), f();
                  }
                }
              )
            ] }) : /* @__PURE__ */ x.jsx("p", { className: "global-header-vehicles-mobile-container-wrapper__model-name-tip", children: "具体车型配置以经销商实车为准" }),
            Q.detailLink && /* @__PURE__ */ x.jsxs("div", { className: "global-header-vehicles-mobile-container-wrapper__model-name-more", children: [
              /* @__PURE__ */ x.jsx(
                "span",
                {
                  className: "global-header-vehicles-mobile-container-wrapper__model-name-more-text",
                  onClick: (X) => vt(X, Q.detailLink, "了解更多"),
                  children: "了解更多"
                }
              ),
              /* @__PURE__ */ x.jsx(
                "svg",
                {
                  className: "icon",
                  viewBox: "0 0 1024 1024",
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "p-id": "4356",
                  width: "10",
                  height: "10",
                  children: /* @__PURE__ */ x.jsx(
                    "path",
                    {
                      d: "M320 885.333333c-8.533333 0-17.066667-4.266667-23.466667-10.666666-12.8-12.8-10.666667-34.133333 2.133334-44.8L654.933333 512 298.666667 194.133333c-12.8-10.666667-14.933333-32-2.133334-44.8 10.666667-12.8 32-14.933333 44.8-2.133333l384 341.333333c6.4 6.4 10.666667 14.933333 10.666667 23.466667 0 8.533333-4.266667 17.066667-10.666667 23.466667l-384 341.333333c-6.4 6.4-12.8 8.533333-21.333333 8.533333z",
                      fill: "#ffffff",
                      "p-id": "4357"
                    }
                  )
                }
              )
            ] }),
            /* @__PURE__ */ x.jsx(
              "div",
              {
                className: "flex-1",
                onClick: (X) => vt(X, Q.detailLink, "了解更多")
              }
            )
          ] }),
          W.current[O].classList[M].modelList.length > 1 && /* @__PURE__ */ x.jsx("div", { className: "global-header-vehicles-mobile-container-wrapper__bottom-tip", children: "左右滑动查看不同车型" }),
          (() => {
            var ge, Te;
            const X = Be(Q.CTAs || []);
            return !!X.length && /* @__PURE__ */ x.jsxs("div", { className: "global-header-vehicles-mobile-container-wrapper__bottom-cta", children: [
              /* @__PURE__ */ x.jsx(
                "div",
                {
                  className: `global-header-vehicles-mobile-container-wrapper__bottom-cta-purchase ${X.length === 1 ? "global-header-vehicles-mobile-container-wrapper__bottom-cta-single ow-btn-solid-white" : "ow-btn-transparent-white"}`,
                  onClick: (we) => {
                    var ze, be, Le;
                    return vt(we, (ze = X[0]) == null ? void 0 : ze.link, (be = X[0]) == null ? void 0 : be.label, (Le = X[0]) == null ? void 0 : Le.type);
                  },
                  children: (ge = X[0]) == null ? void 0 : ge.label
                }
              ),
              X.length > 1 && /* @__PURE__ */ x.jsx(
                "div",
                {
                  className: "global-header-vehicles-mobile-container-wrapper__bottom-cta-drive ow-btn-solid-white",
                  onClick: (we) => {
                    var ze, be, Le;
                    return vt(we, (ze = X[1]) == null ? void 0 : ze.link, (be = X[1]) == null ? void 0 : be.label, (Le = X[1]) == null ? void 0 : Le.type);
                  },
                  children: (Te = X[1]) == null ? void 0 : Te.label
                }
              )
            ] });
          })()
        ] }, Q.id))
      }
    ),
    p,
    /* @__PURE__ */ x.jsx("div", { className: "global-header-vehicles-mobile-container-wrapper__bottom" })
  ] }) });
}, m0 = (s) => {
  const r = Qr("(min-width: 1024px)"), { pathname: n } = iv(), { triggerEvent: a } = Yi(), c = (d) => {
    try {
      if (["/", "/homepage", "/homepage.html"].includes(d))
        return er.HOMEPAGE;
      const p = d == null ? void 0 : d.split("/")[1];
      return Object.values(er).includes(p) ? p : er.UNKNOWN;
    } catch {
      return er.UNKNOWN;
    }
  }, o = (d) => {
    const p = c(n), f = s.qtFeatureKeys || {}, b = s.qtLogKey || { CLK: "vehicle_list_clk" };
    switch (p) {
      case er.HOMEPAGE:
        a(Ot.CLICK, "hp_button_clk", {
          page_name: "home_page",
          page_title: "首页_功能按钮点击",
          ...d
        });
        break;
      case er.CAMPAIGNS:
        a(Ot.CLICK, b.CLK, {
          ...f,
          ...d
        });
        break;
      default:
        a(Ot.CLICK, "vehicle_list_clk", {
          ...d
        });
        break;
    }
  };
  return /* @__PURE__ */ x.jsx(x.Fragment, { children: r ? /* @__PURE__ */ x.jsx(kv, { ...s, onClick: o }) : /* @__PURE__ */ x.jsx(h0, { ...s, onClick: o }) });
}, v0 = "data:image/webp;base64,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", A0 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAeRJREFUaEPtWNtRAkEQ7M7AEDACMQINQSNQI1AjECMQI1AjECNQI1AykAjUCNqaqsNa7g72cQ+g2P1kZ4fu6ZnerSO2fHHL8SMTWLeCWYGsQMMK5BZqWMDGx3dHAUkjADeNS1af4Jak5Y9ewQpIUnT2iAMkg7G4aYMPZQIeNbICvnYtt1Bqxeb/01a+5BnIBEqullqQ3VXANzOx+70rEAvQF58J+CqUanuBN/gFyUcfhrr9zoc4gMA9ySsXnKRzABOSPz5S6ybwRNLA/i9JYwCXAAy8KTNZRWKdBKYkhzWVf3B+MxL7q5RIJuCT1rM/BXDsApN0AuC5dG4GYLhpBH4LUF/Ou8iUeAWw5xCwOCP52UkLJSpQASVpAOCjBN7SH/rAW1DfLXTqDqUkq7hVfmEWiuENstU+CVS8XpK1x0FJzWuS5kRBqy8CdV5vFT4roazYqo9FHwRWeb2L74WkOVHU6prAjKQNqXtR2cXler3tVWw1lEXXBBb6OdXr27LR2A9bZpmD+SW0xC6DvL4VAqGSLouTZA+2u9J+kNdvCoE3AEcOmOQntEsoeAaaKFBcWN9FjncAI5JGqPHqi4DdtNZC45DnQQyrXgjEAIqNzQRiK9Z2fFag7YrG5ssKxFas7fitV+APzRD4Mb4kam0AAAAASUVORK5CYII=", w0 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAp1JREFUaEPtWO0xJUEUPScCMkAEiGCJYIkAEVgRIIMVwRIBIvBEgAgQgRXBVUf1VDE1M336vd7Hq537Z2pqerrvued+NrHgwgXXHyOAr2ZwZGBkYEYLjC7UNmBEbAC4BLDa+vYEYJfk/YxG//R7dQYi4rFD+ebQe5Kb3xZAsv5dRsE1kmKjilRlICJ+AzjMaHZK8qSK9kCdShwRWwCOAejpyASAgOg5kxQxkFxkD8BfAArGZwB6/zWlFmLsDMA6AAX/MoCLkkC3AUSENleA6vkvRcZRnOiZlRIAjn9nDzQXnJG0WLUAmNnF1M1eZmUrF8BNQYC+AlCWmTS+nAywk2JlyYSg/7dza10Akdsofb+Qkn3+m+LoHMBPZz+SWf2yC3RQRKjwrGQOVfbYdxSLiCsDxANJZaZBcQFoI+XsPvrlNqtu5khMyChD+2056dQCkFgQiL424YikspQtA1VbxrCU12E2gATipacObDrW+oguVW8lh7Y8kVxzLVEKoDOYnWDrUigiZt7vvwOg8t4VeFbRMV3omWR7GOr1KJuBTDWuGcQy0rYbUxaApLwCrq+RK2rAjMbQBuECGBoTG3rPSR442SMiNDOrtRgSa/x0AbithNoEuVNnK5ws/8dQ/h2Yk91cAKrCPxzrpmFHRe261cyp/1GL7M4T+j/HklfIIkJZQW40T7Eym8VAqsLzHGjswb8EgKgfasBqsVPUGNoAPjR0apmboV6A9J67SukDp4FezKpRbIZ6ZTP79q4IQJ8WqTHTFOYG+q2mtrlfq+R8ZGEvthpg5vBvZZecsZrvVVyo1aQNjZ/WmOgq/17sShY7axMLmnnbM7Ru8XZKAtQ5rzoA59Caa0YANa05zV4jA9NYreY/IwM1rTnNXgvPwBuNpfwx6G2bHQAAAABJRU5ErkJggg==", b0 = "data:image/png;base64,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";
function x0(s) {
  const r = Ie(null), n = Qr("(min-width: 1024px)");
  Sc(r, (f) => {
    const m = (f.composedPath ? f.composedPath() : [f.target])[0];
    m.closest(".exclude-click") || m.classList.contains(Cc) || n && s.hideUserCenter();
  });
  const a = () => {
    s.notLogin(), s.hideUserCenter();
  }, c = (f) => {
    f.stopPropagation(), Iv(), window.location.href = `${s.loginUrl}&device=${n ? "desktop" : "mobile"}`;
  }, o = () => {
    window.location.href = `${s.logoutUrl}&device=${n ? "desktop" : "mobile"}`;
  }, d = () => /* @__PURE__ */ x.jsx("div", { className: "g-fixed g-z-[10930] g-top-16 lg:g-top-[84px] lg:g-right-6 g-h-dvh g-w-dvw g-bg-black/40 g-font-pingFangNormal g-text-white g-text-[14px] g-leading-[1.8] lg:g-w-[336px] lg:g-bg-neutral-826/70 lg:g-rounded-md lg:g-backdrop-blur-[20px] lg:g-h-auto lg:g-overflow-hidden lg:g-shadow-profile", children: /* @__PURE__ */ x.jsxs("div", { className: "g-bg-black g-min-h-[314px] g-h-auto g-opacity-90 g-text-center g-pt-6 g-pb-8 lg:g-px-8 lg:g-bg-transparent", children: [
    /* @__PURE__ */ x.jsxs("div", { className: "g-font-MBCorpo g-text-[30px]", children: [
      "欢迎",
      s.status === "suspended" ? "回来" : "来到",
      "梅赛德斯-奔驰"
    ] }),
    /* @__PURE__ */ x.jsx("div", { className: "g-mb-16 g-mt-5 g-opacity-60", children: s.status === "suspended" ? " 为保障您的账号安全，您已暂时被登出，请点击下方重新登录，尽享品牌专属服务 " : /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx("div", { children: "注册/登录" }),
      /* @__PURE__ */ x.jsx("div", { children: "Mercedes me ID（梅赛德斯-奔驰账户）" }),
      /* @__PURE__ */ x.jsx("div", { children: "享受品牌专属服务" })
    ] }) }),
    /* @__PURE__ */ x.jsxs(
      "button",
      {
        className: "exclude-click g-bg-white g-mx-auto g-h-11 g-text-black g-rounded-[20px] g-w-[178px] g-mb-4 lg:g-w-[158px] lg:g-font-semibold",
        onClick: c,
        children: [
          s.status === "suspended" ? "重新" : "",
          "登录"
        ]
      }
    ),
    /* @__PURE__ */ x.jsx("div", { className: "g-cursor-pointer", onClick: a, children: "暂时不用" })
  ] }) }), p = () => {
    var f;
    return /* @__PURE__ */ x.jsxs(
      "div",
      {
        className: `g-z-[10910] g-fixed g-inset-0 g-bg-black g-pl-4 g-pr-2 g-py-[30px] g-font-pingFangNormal g-text-white g-text-[14px] 
      lg:g-inset lg:g-w-[336px] lg:g-top-[84px] lg:g-right-6 lg:g-bg-neutral-826/70 lg:g-rounded-md lg:g-backdrop-blur-[20px] lg:g-h-auto lg:g-overflow-hidden lg:g-shadow-profile lg:g-inset-auto`,
        children: [
          !n && /* @__PURE__ */ x.jsx(
            "div",
            {
              className: "g-absolute g--z-10 g-top-0 g-left-0 g-w-full g-h-[316px] g-bg-no-repeat g-bg-[20%_-50px] g-bg-cover",
              style: { backgroundImage: `url('${v0}')` }
            }
          ),
          !n && /* @__PURE__ */ x.jsxs("div", { className: "g-text-center g-relative g-mb-[46px] g-mr-2", children: [
            /* @__PURE__ */ x.jsx("span", { onClick: s.hideUserCenter, className: "g-rotate-180 g-inline-block g-absolute g-top-2 g-left-1", children: /* @__PURE__ */ x.jsx("svg", { viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", children: /* @__PURE__ */ x.jsx(
              "path",
              {
                d: "M450.346667 255.829333L683.264 512l-232.96 256.213333-47.317333-43.093333L596.736 512 402.986667 298.88l47.36-43.093333z",
                fill: "#8a8a8a"
              }
            ) }) }),
            /* @__PURE__ */ x.jsx("span", { className: "g-opacity-50", children: "个人中心" })
          ] }),
          /* @__PURE__ */ x.jsxs("div", { className: "g-min-h-15 g-cursor-default", children: [
            /* @__PURE__ */ x.jsxs("div", { className: "g-text-2xl g-font-medium g-font-MBCorpo g-whitespace-nowrap g-mb-2", children: [
              "您好，",
              s.username || "奔驰用户"
            ] }),
            /* @__PURE__ */ x.jsx("div", { className: "g-text-[12px]", children: (f = s.userPhone) == null ? void 0 : f.replaceAll('"', "") })
          ] }),
          /* @__PURE__ */ x.jsxs("div", { className: "g-bg-neutral-900/80 g-flex g-justify-between g-rounded-md g-px-3 g-py-5 g-mt-4 g-mb-8 lg:g-bg-black/15 lg:g-mb-4", children: [
            /* @__PURE__ */ x.jsxs("a", { href: "/purchase/purchase-journey-page.html#/order-list", className: "g-leading-8 exclude-click", children: [
              /* @__PURE__ */ x.jsx("img", { className: "g-w-6 g-mr-2 g-align-middle g-inline-block lg:g-w-8", src: A0, alt: "" }),
              "我的订单"
            ] }),
            /* @__PURE__ */ x.jsx(
              "a",
              {
                href: "/purchase/purchase-journey-page.html#/order-list",
                className: "g-w-20 g-h-8 g-text-[12px] g-border g-border-white g-text-center g-rounded-3xl g-leading-8 exclude-click",
                children: "去查看"
              }
            )
          ] }),
          /* @__PURE__ */ x.jsxs("div", { className: "g-bg-neutral-900/80 g-flex g-justify-between g-rounded-t-md g-px-3 g-py-5 lg:g-bg-black/15", children: [
            /* @__PURE__ */ x.jsxs("a", { href: "/setting.html", className: "exclude-click", children: [
              /* @__PURE__ */ x.jsx("img", { src: w0, alt: "", className: "g-w-6 g-mr-2 g-align-middle g-inline-block lg:g-w-8" }),
              "设置"
            ] }),
            /* @__PURE__ */ x.jsx("a", { href: "/setting.html", className: "exclude-click", children: /* @__PURE__ */ x.jsx("svg", { viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", children: /* @__PURE__ */ x.jsx(
              "path",
              {
                d: "M450.346667 255.829333L683.264 512l-232.96 256.213333-47.317333-43.093333L596.736 512 402.986667 298.88l47.36-43.093333z",
                fill: "#8a8a8a"
              }
            ) }) })
          ] }),
          /* @__PURE__ */ x.jsxs("div", { className: "g-bg-neutral-900/80 g-flex g-justify-between g-rounded-b-md g-px-3 g-py-5 lg:g-bg-black/15", children: [
            /* @__PURE__ */ x.jsxs("span", { onClick: o, className: "g-cursor-pointer exclude-click", children: [
              /* @__PURE__ */ x.jsx("img", { src: b0, alt: "", className: "g-w-6 g-mr-2 g-align-middle g-inline-block lg:g-w-8" }),
              "登出"
            ] }),
            /* @__PURE__ */ x.jsx("span", { onClick: o, className: "g-cursor-pointer", children: /* @__PURE__ */ x.jsx("svg", { viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", className: "exclude-click", children: /* @__PURE__ */ x.jsx(
              "path",
              {
                d: "M450.346667 255.829333L683.264 512l-232.96 256.213333-47.317333-43.093333L596.736 512 402.986667 298.88l47.36-43.093333z",
                fill: "#8a8a8a"
              }
            ) }) })
          ] })
        ]
      }
    );
  };
  return /* @__PURE__ */ x.jsx("div", { ref: r, className: "", children: s.status === "active" && Mv("isLoggedIn") === "true" ? p() : d() });
}
const S0 = "_listItem_1wtsa_1", y0 = {
  listItem: S0
}, C0 = (s) => {
  const r = Ie(null), [n, a] = Oe([]);
  Sc(r, (o) => {
    var b;
    const p = (o.composedPath ? o.composedPath() : [o.target])[0];
    p.closest(".exclude-click") || p.classList.contains(Ec) || (b = s.hideSearchBox) == null || b.call(s);
  });
  const c = wr((o) => {
    s.suggestionAPI && fetch(`${s.suggestionAPI || "/api/search/suggestions"}?q=${encodeURIComponent(o)}`).then((d) => d.json()).then((d) => {
      a(d.data);
    }).catch((d) => {
      console.error("Error fetching suggestions:", d);
    });
  }, [s]);
  return /* @__PURE__ */ x.jsx("div", { className: `g-w-full g-absolute g-z-[100811] g-top-[72px] ${s.className || ""} g-bg-neutral-850`, ref: r, children: /* @__PURE__ */ x.jsx("div", { className: "g-h-16 g-mx-auto g-flex g-items-center g-justify-center g-relative exclude-click", children: /* @__PURE__ */ x.jsxs(
    "form",
    {
      action: `${s.searchResultURL || "/search"}`,
      role: "search",
      method: "get",
      className: "g-h-8 g-border-b g-border-neutral-250/10 g-max-w-[620px] g-w-full g-relative g-pb-1",
      children: [
        /* @__PURE__ */ x.jsx(
          "input",
          {
            name: "q",
            type: "text",
            placeholder: s.placeholder,
            autoComplete: "off",
            className: "g-bg-transparent g-border-none g-outline-none g-w-full g-font-pingFangNormal g-font-medium g-text-base g-text-white",
            onChange: Ia.debounce((o) => {
              c(o.target.value);
            }, 500)
          }
        ),
        /* @__PURE__ */ x.jsx("button", { type: "submit", className: "g-border-none g-outline-none g-p-0 g-m-0 g-bg-none", children: /* @__PURE__ */ x.jsx("i", { className: "g-absolute g-right-2 g-top-1 g-text-white", children: /* @__PURE__ */ x.jsx("svg", { height: "16", viewBox: "0 0 12 16", width: "12", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ x.jsx(
          "path",
          {
            d: "m9.582 4.792c0 1.231-.38 2.261-1.164 3.134l2.754 4.768c.156.291.246.537.246.784 0 .447-.291.76-.918 1.119v.023c-.425.246-.806.38-1.097.38-.38 0-.694-.246-.962-.716l-2.754-4.769c-.296.045-.595.067-.895.068-2.62 0-4.79-2.172-4.79-4.79-.069-2.487 2.259-4.86 4.789-4.793 1.276 0 2.485.515 3.38 1.41.94.94 1.41 2.06 1.41 3.381zm-4.79-3c-1.59 0-3 1.388-3 3 0 1.656 1.388 3 3 3 1.656 0 3-1.344 3-3 0-1.634-1.344-3-3-3z",
            fill: "currentColor"
          }
        ) }) }) }),
        n.length > 0 && /* @__PURE__ */ x.jsx("ul", { className: "g-absolute g-top-10 g-bg-[#1f1f1f;] g-py-[24px] g-px-[32px] g-max-h-fit g-overflow-y-auto scroll-bar-none w-full", style: { width: "100%" }, children: n.map((o, d) => /* @__PURE__ */ x.jsx(
          "li",
          {
            className: ` g-mb-5 g-font-medium g-text-sm g-font-pingFangNormal last-of-type:g-mb-0  hover:g-text-white   g-leading-[22px] g-text-[#767676] ${y0.listItem}`,
            children: /* @__PURE__ */ x.jsx("a", { href: `${s.searchResultURL || "/search"}?q=${o.trim()}&type=suggestion`, children: o.trim() })
          },
          d
        )) })
      ]
    }
  ) }) });
}, E0 = "data:image/png;base64,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", T0 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAABPhJREFUeF7tmmvon2MYxz9fh0LOMiUvHNfIoRRhjLJYiTkm5AUzUhQ5FLW1EMpEoci2IuwF0njBHF4wZ6UcwoR54SyHNTGH+eqy56nbr/1/v9/z3M/zb9Z91f/Ndl/XfV2f3/Xch+u6RZGhBFT4DCdQAI3IkAKoAMpbREoGlQwqGZRHoGRQHr+yBpUMKhmUR6BkUB6/sgaVDCoZlEdgY80g21OAk6u/Q4DdgC2An4GVwLPAMknv9kpgYwNUgZkPXAxsOUbwK4BrJb0+xtjOh0zqIm17NvAgsH3DSAzcA1wp6a+GulnDJw2Q7WuAW4HNJvD4DyD+th0S0QvAqZJ+yYq6gfKkALJ9PvAAMDjfK8BiYDnwtSTbDkBHAWcDoTf4GS4DTouxDeJsPbR3QLZjAY71Y6vEy1iI50p6bJjntvcDHgIOHxg3T9JNraNuoDgZgJ4DZiY+fQccK+mjcfy0HWAD5EnJ+F+BqZK+HMdGzpheAdk+Hng+cXAdcJykl5s4bXs74A1g/0TvXkmXNrHTZmzfgJYAFySOLZZ0URtHbZ8IPJPo/gRM6XtX6w2Q7ditvgF2TYKaJikOga3E9jvAwYnyTEmxs/UmfQKaBnyYeL5SUvxba7F9AzAvMTBf0o2tDY6h2CegwU/iCUmnj+HThENsnwM80sUnO64ffQIKGI8njiySNHdcxzY0zvYJ1Zmp/u+lks7NsTlKt09AJYOG0bdd1qARgMouNur7tR33rAu7WFQ3uXNQQCkn6VEptB5SuYuNWIvKbX5UIpV60ChC6z+1cSqKvwNxc59INs2KYh1tRk06TDwNzJb05xi/R2dDejtJD3pYFb5iy78K2LtlBJ8AdwBLJK1taaOR2qQAsn1mFdgejbybePAXVYdjaMm2i7l6BWR7h6oof8YQZ6ND8QGwClhdjQu9vYADRnQ54jI8R1Kt1wWT/9joDZDtfasK4D4b8Pp74GHgUeDNiaqCtqPTGgX7s4DzBopvtdlPgVmS4vPrXHoBZPugqhYd7eVUokwaBa77JEXhfWyxvQ1wSVUw22lAMRoBUV18b2yDYw7sHJDtPYHod+0+4MOTVasngmktVet6UdXTT+18BUyX9Hlr4xtQ7BRQtVNFDyxOz7VEg2+BpCiXdia2o7+/YKAZGTXrI7rc4boGdBdw2QCF6Kff2RmZlLx9RbU7pubvlnR5V/N1Bsj2YVUHNe29L5QUJ+jexPZtwNXJBH9XWfRWF5N2Cegl4JjEqdeAGX33raqdLuY+Mpl7haQZGw0g2+HMi4lDcR04VNL7XTg5yobtA4G3Bx46RHs7wGVJJxlkO1ox0ZKpJbuD0TQq2/cDade2k45HNqCqb/4tsHUVVOxa0UH9uGmQOeNtTwXiQUQd02/xrE/Smhy7XQCKd4ZxxqnlVUnTc5xqq2s7zl/xtqiWUyQ91dZe6HUBaGF1Q6/9uF7SLTlOtdW1fR1wc6J/u6R0h2tsugtA8TosOp61HC0pfslJF9uRuenTmuWSZuU40gWgz6qbd+3HLpJ+zHGqra7tnYEfEv1VktrWnv410wWgeE4X5YmQtZLqxbptnFl6tmNxrp/7rZa0Y47BLgAtBTavnFgjaU6OQ7m6VbOyrmuvk5QePxqbzwbUeMb/mUIBNOIHK4AKoLxvumRQyaCSQXkESgbl8StrUMmgkkF5BEoG5fEra1DJoLwM+gcd8q5YRVoXSgAAAABJRU5ErkJggg==", L0 = "data:image/png;base64,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", xa = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAAATlJREFUeF7t2MGNwkAMRmHcBJXQxVZBZVSxXWwlNDEr7YVbgvxjbSJ9nGOP9fLsCa6L3yaBwmebAEA7hgAEUDZEGMQgBmUEGJTxM4MYxKCMAIMyfmYQgxiUEZgyaK31M1rZh5NX1a2Tsj2DANrBDRBAfwSSFvvu9PR/xVTVV+fsNqDOYWeMAWjqmj+jDZ2aGcSgjjevGAYxiEEZAQZl/MwgBjEoIzBl0FrLn9UtuPZB9kHxPshOWosFG8XRq+NAyX0oTl3zB3rJo6UwiEGZYAxiEIMyAgzK+JlBDGJQRmDKoLXWY7SyDyevqnsnZXsGWZhZmFmYvdNyWmxwSF/feQNHeaaqnp1a2gZ1DjtjDEBTLXZGGzo1M4hBHW9eMQxiEIMyAgzK+JlBDGJQRoBBGT8ziEEMygjsRP8CtltASWmYmpEAAAAASUVORK5CYII=", vc = "data:image/png;base64,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";
function I0() {
  return document.documentElement.clientWidth <= 480 || screen.width <= 480 || /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|huawei/i.test(navigator.userAgent.toLowerCase());
}
function Ac(s, r = "width") {
  return r === "width" ? window.innerWidth >= s && screen.width >= s : window.innerHeight >= s && screen.height >= s;
}
const R0 = (s) => {
  const r = Qr("(min-width: 1024px)"), [n, a] = Oe(!1), [c, o] = Oe(!1), [d, p] = Oe(!1), [f, b] = Oe(!1), [m, S] = Oe(!1), [A, y] = Oe({
    alt: "菜单",
    img: xa,
    button_name: "汉堡菜单"
  }), [_, O] = Oe(void 0), { triggerEvent: G } = Yi(), M = (N) => {
    N ? document.body.classList.add("global-header__overflow-hidden") : document.body.classList.remove("global-header__overflow-hidden");
  };
  _e(() => {
    M(!!(_ || c));
  }, [_, c]);
  const E = Ie(null), T = Ie(null), L = (N) => {
    b(N), y(N ? {
      alt: "返回",
      img: vc,
      button_name: "关闭搜索"
    } : {
      alt: "菜单",
      img: xa,
      button_name: "汉堡菜单"
    });
  }, P = () => {
    O(!_), sessionStorage.getItem("vehicleListByFloatingButton") === "1" && o(!1), G(Ot.CLICK, "top_button_clk", {
      button_name: "探索车型"
    });
  }, k = () => {
    _ === !0 && O(!1);
  };
  _e(() => {
    s.userInfo.status === "suspended" && p(!0);
  }, [s.userInfo.status]), _e(() => {
    var N, V, K, Z, j, te, re, ue, Ne, Ge, ye, Be, We, je, He;
    !r && (c || d) ? ((N = E.current) == null || N.classList.add("!g-opacity-0"), (V = E.current) == null || V.classList.add("g-pointer-events-none"), (Z = (K = T.current) == null ? void 0 : K.querySelector("a.test-drive")) == null || Z.classList.add("!g-opacity-0"), (te = (j = T.current) == null ? void 0 : j.querySelector("a.test-drive")) == null || te.classList.add("g-pointer-events-none"), f || _ ? y({
      alt: "返回",
      img: vc,
      button_name: "关闭搜索"
    }) : s.userInfo.status === "suspended" && !c ? y({
      alt: "",
      img: "",
      button_name: ""
    }) : y({
      alt: "关闭",
      img: ya,
      button_name: "关闭汉堡菜单"
    })) : I0() && !c && sessionStorage.getItem("vehicleListByFloatingButton") === "1" ? (y({
      alt: "关闭",
      img: ya,
      button_name: "关闭汉堡菜单"
    }), sessionStorage.removeItem("vehicleListByFloatingButton"), (re = E.current) == null || re.classList.add("!g-opacity-0", "g-pointer-events-none"), (Ne = (ue = T.current) == null ? void 0 : ue.querySelector("a.test-drive")) == null || Ne.classList.add("!g-opacity-0", "g-pointer-events-none")) : ((Ge = E.current) == null || Ge.classList.remove("!g-opacity-0"), (ye = E.current) == null || ye.classList.remove("g-pointer-events-none"), (We = (Be = T.current) == null ? void 0 : Be.querySelector("a.test-drive")) == null || We.classList.remove("!g-opacity-0"), (He = (je = T.current) == null ? void 0 : je.querySelector("a.test-drive")) == null || He.classList.remove("g-pointer-events-none"), y({
      alt: "菜单",
      img: xa,
      button_name: "汉堡菜单"
    }));
  }, [c, f, _, r, d, s.userInfo.status]);
  const q = () => {
    G(Ot.CLICK, "top_button_clk", {
      button_name: "菜单"
    }), A.img && (k(), r ? (o(!c), _ && O(!1)) : (f && b(!1), _ && O(!1), d && p(!1), !f && !_ && !d && o(!c)));
  }, W = () => {
    G(Ot.CLICK, "top_button_clk", {
      button_name: "奔驰星标"
    }), !((c || d) && !r) && (window.location.href = mv);
  };
  return _e(() => {
  }, [_, c]), _e(() => {
    const N = sessionStorage.getItem(yc) === "true";
    N && S(N);
  }, []), _e(() => {
    s.onPopup && s.onPopup(d || n);
  }, [s, d, n]), /* @__PURE__ */ x.jsxs("div", { className: "antialiased g-fixed g-top-0 g-left-0 g-z-[10700] g-w-full " + (m ? "g-hidden" : ""), children: [
    d && /* @__PURE__ */ x.jsx(x0, { ...s.userInfo, hideUserCenter: () => p(!1) }),
    s.vehicleListData.vehicleList.data && s.vehicleListData.vehicleList.data.attributes.OWVehicleBody.length > 0 && /* @__PURE__ */ x.jsx(
      m0,
      {
        vehicleListData: s.vehicleListData,
        displayOnHomepage: !1,
        closeVehicleModal: () => O(!1),
        isVehicleListOpened: _,
        occUrl: s.occUrl
      }
    ),
    /* @__PURE__ */ x.jsx(
      C0,
      {
        ...s.search,
        className: n && r ? "" : "g-hidden",
        hideSearchBox: () => a(!1)
      }
    ),
    /* @__PURE__ */ x.jsxs(
      "header",
      {
        className: `g-flex g-justify-stretch g-fixed g-z-[10900] g-bg-black g-min-h-16 g-w-full g-px-4 lg:g-min-h-[72px] lg:g-px-6 g-top-0
       g-left-0`,
        children: [
          /* @__PURE__ */ x.jsxs("div", { className: "g-flex-1 g-text-white g-flex g-items-center", children: [
            /* @__PURE__ */ x.jsx("span", { className: "g-font-MBCorpo g-indent-[9999]" }),
            /* @__PURE__ */ x.jsx("span", { className: "g-font-MBCorpo g-indent-[9999]" }),
            /* @__PURE__ */ x.jsxs(
              "div",
              {
                className: "g-flex g-gap-x-2 lg:g-gap-x-8 g-text-sm g-leading-6 g-opacity-100 g-duration-300 g-transition ",
                ref: T,
                children: [
                  /* @__PURE__ */ x.jsx(
                    "span",
                    {
                      className: `g-cursor-pointer g-w-6 g-h-6 g-bg-center g-bg-cover g-bg-no-repeat ${c && !r ? "g-animate-rotateDown" : "g-animate-rotateUp"}`,
                      style: { backgroundImage: `url(${A.img})` },
                      onClick: q
                    }
                  ),
                  /* @__PURE__ */ x.jsx("span", { className: "g-menu-text g-cursor-pointer g-hidden lg:g-inline-block g-select-none", onClick: P, children: "探索车型" }),
                  /* @__PURE__ */ x.jsx(
                    "a",
                    {
                      href: pv,
                      className: "g-menu-text g-cursor-pointer test-drive g-opacity-100 g-duration-500 g-transition g-select-none",
                      onClick: () => G(Ot.CLICK, "top_button_clk", {
                        button_name: "预约品鉴"
                      }),
                      children: "预约品鉴"
                    }
                  ),
                  /* @__PURE__ */ x.jsx(
                    "a",
                    {
                      href: hv,
                      className: "g-menu-text g-cursor-pointer g-hidden lg:g-inline-block g-select-none",
                      onClick: () => G(Ot.CLICK, "top_button_clk", {
                        button_name: "找经销商"
                      }),
                      children: "找经销商"
                    }
                  )
                ]
              }
            )
          ] }),
          /* @__PURE__ */ x.jsx("div", { className: "g-flex g-justify-center g-items-center", children: /* @__PURE__ */ x.jsx("div", { onClick: W, className: "logo-container g-w-9 g-h-9 g-relative g-box-content", children: /* @__PURE__ */ x.jsx(
            "img",
            {
              alt: "logo",
              className: "g-cursor-pointer g-object-contain g-w-full g-h-full logo",
              referrerPolicy: "no-referrer",
              src: E0
            }
          ) }) }),
          /* @__PURE__ */ x.jsxs(
            "div",
            {
              className: "g-flex g-flex-1 g-justify-end g-items-center g-text-white g-gap-x-2 lg:g-gap-x-[18px] w1440:g-gap-x-6 g-opacity-100 g-duration-500 g-transition",
              ref: E,
              children: [
                /* @__PURE__ */ x.jsx(
                  "img",
                  {
                    alt: "搜索",
                    className: "g-cursor-pointer g-w-6 g-h-6 g-invisible lg:g-visible " + Ec,
                    referrerPolicy: "no-referrer",
                    src: Tc,
                    onClick: () => {
                      G(Ot.CLICK, "top_button_clk", {
                        button_name: "搜索"
                      }), a(!n);
                    }
                  }
                ),
                /* @__PURE__ */ x.jsx(
                  "img",
                  {
                    alt: "收藏",
                    className: "g-cursor-pointer g-w-6 g-h-6",
                    referrerPolicy: "no-referrer",
                    src: L0,
                    onClick: () => {
                      G(Ot.CLICK, "top_button_clk", {
                        button_name: "收藏"
                      }), window.location.href = "/myfavorites.html";
                    }
                  }
                ),
                /* @__PURE__ */ x.jsx(
                  "img",
                  {
                    alt: "个人中心",
                    onClick: () => {
                      G(Ot.CLICK, "top_button_clk", {
                        button_name: "我的"
                      }), p(!d);
                    },
                    className: "g-cursor-pointer g-w-6 g-h-6 " + Cc,
                    referrerPolicy: "no-referrer",
                    src: T0
                  }
                )
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ x.jsx(
      Ev,
      {
        menuData: s.burgerMenuData,
        isBurgerMenuOpen: c,
        handleCloseBurgerMenu: () => o(!1),
        search: s.search,
        searchEnabled: f,
        updateSearchStatus: L,
        showVehicles: () => O(!0)
      }
    )
  ] });
}, _0 = (s) => {
  var S;
  const r = ((S = s.data) == null ? void 0 : S.attributes) || { GlobalFooterRow1CTAs: [], GlobalFooterRow2CTAs: [], Touchpoint: [] }, { width: n } = sv(), [a, c] = Oe(!1), { triggerEvent: o } = Yi(), d = (A) => {
    o(Ot.CLICK, "bottom_button_clk", {
      button_name: A.label
    }), A.link && (lc(A.link) ? window.location.href = A.link : window.open(A.link, "_blank"));
  };
  _e(() => {
    const A = sessionStorage.getItem(yc) === "true";
    A && c(A);
  }, []);
  const p = (A) => {
    A.stopPropagation(), A.currentTarget.classList.remove("g-flex"), A.currentTarget.classList.add("g-hidden");
  };
  function f() {
    const A = Array.from(document.querySelectorAll(".popup-image-wrapper-pc"));
    return ["wc-common-footer"].forEach((_) => {
      document.querySelectorAll(_).forEach((O) => {
        O.shadowRoot && A.push(...Array.from(O.shadowRoot.querySelectorAll(".popup-image-wrapper-pc")));
      });
    }), A;
  }
  _e(() => {
    const A = (y) => {
      const _ = f();
      _.some((O) => y.composedPath().includes(O)) || _.forEach((O) => {
        O.classList.remove("g-max-h-screen");
      });
    };
    return document.addEventListener("click", A), () => {
      document.removeEventListener("click", A);
    };
  }, []);
  const b = (A, y) => {
    if (o(Ot.CLICK, "bottom_button_clk", {
      button_name: y.label
    }), y.type === "b-popup" && y.popup.data) {
      const _ = A.currentTarget.querySelector(".popup-image-wrapper-pc"), O = A.currentTarget.querySelector(".popup-image-wrapper-mobile");
      _ && Ac(1200) && setTimeout(() => {
        _.classList.add("g-max-h-screen");
      }, 0), O && !Ac(1200) && setTimeout(() => {
        O.classList.remove("g-hidden"), O.classList.add("g-flex");
      });
    }
    y.type === "a-跳转链接" && y.link && (lc(y.link) ? window.location.href = y.link : window.open(y.link, "_blank"));
  }, m = () => {
    const A = (y, _ = !0) => /* @__PURE__ */ x.jsxs(
      "div",
      {
        className: "g-flex g-items-center " + (n >= 480 ? "" : "g-basis-auto g-shrink-0 g-grow"),
        children: [
          /* @__PURE__ */ x.jsx(
            "span",
            {
              className: y.link ? "g-cursor-pointer" : "g-cursor-text g-text-neutral-539",
              onClick: () => d(y),
              children: y.label
            }
          ),
          _ && /* @__PURE__ */ x.jsx("i", { className: "g-flex g-w-4 w480:g-ww-6 g-flex-1 g-justify-center g-h-[0.8em] g-overflow-hidden g-leading-3 global-footer__divider-line", children: "|" })
        ]
      },
      y.label
    );
    return r.GlobalFooterRow1CTAs.length > 4 && n <= 480 ? [
      /* @__PURE__ */ x.jsx("div", { className: "g-flex g-w-full g-flex-wrap", children: r.GlobalFooterRow1CTAs.slice(0, 4).map((y, _) => A(y, _ !== 3)) }),
      /* @__PURE__ */ x.jsx("div", { className: "g-flex g-w-full g-flex-wrap", children: r.GlobalFooterRow1CTAs.slice(4).map(
        (y, _) => A(y, _ !== r.GlobalFooterRow1CTAs.length - 5)
      ) })
    ] : r.GlobalFooterRow1CTAs.map(
      (y, _) => A(y, _ !== r.GlobalFooterRow1CTAs.length - 1)
    );
  };
  return /* @__PURE__ */ x.jsxs(
    "footer",
    {
      className: "antialiased g-flex g-flex-col-reverse g-px-4 g-py-[18px] xs:g-pt-3.5 xs:g-px-9 xs:g-pb-6 sm:g-pt-3.5 sm:g-px-10 w1200:g-py-2.5 w1200:g-px-[7%] w1200:g-flex-row g-font-pingFangNormal g-text-neutral-357 g-bg-black g-text-xs g-min-h-[106px] g-items-center " + (a ? "g-hidden" : ""),
      children: [
        /* @__PURE__ */ x.jsxs("div", { className: "g-flex g-flex-col g-items-center w1200:g-flex-1 g-gap-y-2 w1200:g-gap-y-3 g-leading-6", children: [
          /* @__PURE__ */ x.jsx("div", { className: "g-flex g-flex-wrap g-pt-1 w1200:g-pt-0 g-w-full", children: m() }),
          /* @__PURE__ */ x.jsx("ul", { className: "g-w-full g-flex g-flex-wrap", children: r.GlobalFooterRow2CTAs.map((A) => /* @__PURE__ */ x.jsx("li", { className: "g-pr-[10%] w480:g-pr-[2em]", children: /* @__PURE__ */ x.jsx("span", { className: A.link ? "g-cursor-pointer" : "g-cursor-text", onClick: () => d(A), children: A.label }) }, A.label)) })
        ] }),
        /* @__PURE__ */ x.jsx("ul", { className: "g-grid g-border-b w1200:g-border-none g-border-neutral-600 g-pb-3.5 g-w-full g-max-w-150 w1200:g-max-w-none w1200:g-w-100 g-mb-5 w1200:g-mb-0 g-grid-cols-[50%_auto] g-justify-center g-mx-auto w1200:g-pb-0 w1200:g-grid-cols-3", children: r.Touchpoint.filter((A) => A.isHomeOnly && Tv() || !A.isHomeOnly).map((A) => {
          var y, _;
          return /* @__PURE__ */ x.jsxs(
            "li",
            {
              className: (A.type === "a-跳转链接" && A.link || A.type === "b-popup" && A.popup.data ? "g-cursor-pointer" : "g-cursor-text g-text-neutral-539") + " g-flex g-items-center g-py-2 g-relative",
              onClick: (O) => b(O, A),
              children: [
                A.type === "b-popup" && A.popup.data && /* @__PURE__ */ x.jsx("div", { className: "g-absolute g-min-w-max popup-image-wrapper-pc g-bottom-8 g-left-0 g-transition-[max-height] g-max-h-0 g-duration-500 g--translate-x-1/2 g-overflow-hidden", children: /* @__PURE__ */ x.jsxs("div", { className: "g-bg-neutral-661 g-mb-4", children: [
                  /* @__PURE__ */ x.jsx(
                    "img",
                    {
                      src: (y = A.popup.data) == null ? void 0 : y.attributes.url,
                      alt: A.label,
                      className: "g-w-[268px] g-h-auto w1200:g-h-[194px] w1200:g-w-auto"
                    }
                  ),
                  /* @__PURE__ */ x.jsx("div", { className: "g-w-0 g-h-0 g-border-l-[16px] g-border-r-[16px] g-border-t-[16px] g-border-t-neutral-661 g-border-r-transparent g-border-l-transparent g-left-[calc(50%_-_8px)] g-absolute" })
                ] }) }),
                A.type === "b-popup" && A.popup.data && /* @__PURE__ */ x.jsx(
                  "div",
                  {
                    className: "g-fixed g-bg-black/65 g-z-[10000] g-left-0 g-right-0 g-top-0 g-bottom-0 g-items-center g-justify-center popup-image-wrapper-mobile g-hidden",
                    onClick: p,
                    children: /* @__PURE__ */ x.jsx(
                      "img",
                      {
                        src: (_ = A.popup.data) == null ? void 0 : _.attributes.url,
                        onClick: (O) => O.stopPropagation(),
                        alt: A.label,
                        className: "g-w-[268px] g-h-auto w1200:g-h-[194px] w1200:g-w-auto g-bg-neutral-661 g-animate-fadeInDown"
                      }
                    )
                  }
                ),
                /* @__PURE__ */ x.jsx("img", { src: A.icon.data.attributes.url, className: "g-w-5 g-h-5 g-mr-2.5", alt: "" }),
                /* @__PURE__ */ x.jsx("span", { children: A.label })
              ]
            },
            A.label
          );
        }) })
      ]
    }
  );
};
export {
  _0 as MainFooter,
  R0 as MainHeader,
  m0 as VehicleList
};
//# sourceMappingURL=oneweb.es.js.map
